import ADMINPARKING from './adminParking/en'
import AUTH from './auth/en'
import CALENDAR from './calendar/en'
import CAREER from './carriere/en'
import CHAT from './chat/en'
import COMMUNITY from './community/en'
import DICTIONNAIRE from './dictionnaire/en'
import DOCUMENT from './document/en'
import EVENT from './event/en'
import FICHEPOSTE from './ficheposte/en'
import FORMATIONS from './formations/en'
import GENERAL from './general/en'
import IDEA from './idea/en'
import LEAVE from './leave/en'
import NEWSLETTER from './newsletter/en'
import ONBOARDING from './onboarding/en'
import OSPLANNER from './osplanner/en'
import PROJECT from './project/en'
import QUESTION_REPONSE from './question-reponse/en'
import REMUNERATION_TRANSLATIONS from './remuneration/en'
import SURVEY from './surveys/en'
import TACHEADMINSTRATIVE from './tache_administrative/en'
import TEMPS from './temps/en'
import TRANSPORT from './transport/en'
import USER_PROFILE from './user-profile/en'
import USERDETAILS from './user/en'
import FORFAIT from './forfait/en'
// AI import wording remains modular while being exposed through the existing English dictionary.
import COLLABORATOR from './collaborator-ai-import/en'

export const locale = {
  lang: 'en',
  data: {
    // A dedicated namespace avoids collisions with the legacy COLLAB keys used by the existing page.
    COLLABORATOR,
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    BSI: {
      LIST: {
        TITLE: 'BSI Campaigns',
        CREATE: 'Generate a new BSI campaign',
        CAMPAIGN_NAME: 'Campaign name',
        UPDATED_AT: 'Updated at',
        CREATED_BY: 'Created by',
        DOWNLOAD_SUCCESS: 'Your document has been downloaded successfully!',
        CAMPAIGN_DUPLICATED: 'Campaign duplicated successfully!',
        ERROR_DUPLICATE_CAMPAIGN: 'Error while duplicating the campaign',
        CAMPAIGN_NAME_UPDATED: 'Campaign name updated successfully!',
        ERROR_UPDATE_CAMPAIGN_NAME: 'Error while updating the campaign name',
      },
      GENERATE: {
        CHOOSE_MODEL_TITLE: 'Choose your template',
        LOADING: 'Loading...',
        LOADING_TEMPLATES: 'Loading templates...',
        RETRY: 'Retry',
        EMPTY: 'No template available.',
        DECRYPTING: 'Decrypting...',
        DECRYPTING_IN_PROGRESS: 'Decrypting in progress...',
        CHOOSE_TEMPLATE: 'Choose template',
        PREVIEW: 'Preview',
        NO_PREVIEW: 'No preview available for this template',
        CHOOSE_THIS_TEMPLATE: 'Choose this template',
        LOAD_ERROR: 'Error loading templates',
      },
      GENERATE_DOCUMENT: {
        TITLE: 'BSI generation',
        PHOTO: 'PHOTO',
        NAME: 'NAME',
        FILTER_COLLABORATOR: 'Collaborator',
        SEARCH_BY_COLLABORATOR_NAME: 'Search by collaborator name...',
        STATUS: 'STATUS',
        ALL_STATUSES: 'All statuses',
        READ_FILTER: 'Reading',
        ALL_READ_STATUSES: 'All reading statuses',
        READ_COLUMN: 'READ',
        READ_YES: 'Read',
        READ_NO: 'Unread',
        ACTIONS: 'ACTIONS',
        DELETE_COLLAB_CONFIRM: 'Are you sure you want to delete {{name}}?',
        STATUS_DRAFT: 'Draft',
        STATUS_READY: 'Ready to send',
        STATUS_SENT: 'Sent',
        READY_SUCCESS: 'BSI marked as ready to send!',
        READY_ERROR: 'Error while marking the BSI as ready to send',
        SEND_SUCCESS: 'BSI sent successfully!',
        SEND_ERROR: 'Error sending the BSI',
        RETURN_TO_DRAFT_SUCCESS: 'BSI returned to draft successfully!',
        RETURN_TO_DRAFT_ERROR: 'Error while returning the BSI to draft',
        SEND_ALL: 'Send to all',
        SEND_ALL_CONFIRM: 'Are you sure you want to send the BSI to all collaborators?',
        SEND_ALL_SUCCESS: 'All BSIs sent successfully!',
        SEND_ALL_MISSING_PDF: '{{count}} collaborator(s) skipped: document not yet generated',
        NO_DOCS_TO_SEND: 'No documents to send',
      },
      ADD_COLLAB: {
        TITLE: 'Add a collaborator',
        TARGET_LABEL: 'Target:',
        SELECT_LABEL: 'Select:',
        TARGET_SINGLE: 'Single collaborator',
        TARGET_SITE: 'Site(s)',
        TARGET_SERVICE: 'Service(s)',
        TARGET_TEAM: 'Team(s)',
        TARGET_FONCTION: 'Role(s)',
        TARGET_ALL: 'All employees',
        TARGET_PLACEHOLDER_SITE: 'Select one or more sites',
        TARGET_PLACEHOLDER_SERVICE: 'Select one or more services',
        TARGET_PLACEHOLDER_TEAM: 'Select one or more teams',
        TARGET_PLACEHOLDER_FONCTION: 'Select one or more roles',
        EMPLOYEE_LABEL: 'Collaborator:',
        PREVIEW: 'Preview',
        PREVIEW_COUNT: '{{count}} collaborator(s)',
        CANCEL: 'Cancel',
        ADD: 'Add',
      },
      SERVICE: {
        ERROR_LOAD_TEMPLATES: 'Error loading templates',
        ERROR_CONNECT_SERVER: 'Unable to connect to the server.',
        ERROR_LOAD_TEMPLATE: 'Error loading template',
        ERROR_CONNECT_SERVER_BACKEND_3001: 'Unable to connect to the server. Please check the backend is running on port 3001.',
        ERROR_TEMPLATE_NOT_FOUND: 'Template not found. Please check the UUID.',
        ERROR_SAVE: 'Error while saving',
        ERROR_DECRYPT: 'Error while decrypting the file',
      },
      DELETE: {
        TITLE: 'Delete campaign',
        CONFIRM: 'Are you sure you want to delete the campaign',
        IRREVERSIBLE: 'This action is irreversible.',
        IMPOSSIBLE: 'Deletion is not possible.',
        DELETING: 'Deleting...',
      },
      MODIFY: {
        TITLE: 'BSI Management',
        STEP_CHOOSE_TEMPLATE: 'Choose template',
        STEP_MODIFY_PREVIEW: 'Edit and preview',
        STEP_DOCUMENT: 'the document',
        STEP_GENERATE_DOCUMENT: 'Generate document',
        EDITS_TITLE: 'Edits',
        LIVE_PREVIEW_TITLE: 'Live preview',
        LOAD_TEMPLATE_ERROR: 'Error loading template',
        LOAD_ERROR: 'Error while loading',
        CONFIRM_NEXT_STEP: 'Proceed to the next step?',
        SAVED: 'Saved!',
        SAVE_SUCCESS: 'Document saved successfully',
        VARIABLES_PLACEHOLDER: 'Variables',
        VARIABLES_SEARCH_PLACEHOLDER: 'Search...',
        VARIABLES_NO_RESULTS: 'No results found',
        COLLABORATOR_PLACEHOLDER: '--',
        LOGO_TITLE: 'BSI logo',
        LOGO_HELP: 'The logo is displayed at the top right of each template page.',
        LOGO_UPLOAD: 'Upload a logo',
        LOGO_FORMAT_INFO: 'Accepted image formats. Maximum size: 200 KB.',
        LOGO_PREVIEW: 'Logo preview',
        LOGO_SIZE: 'Logo size',
        LOGO_POSITION_TOP_RIGHT: 'Top right',
        LOGO_FORMAT_ERROR: 'The logo file must be a valid image.',
        LOGO_SIZE_EXCEEDED: 'The logo exceeds the maximum allowed size of 200 KB.',
        CHART_DEBUG: {
          TITLE: 'Charts',
          HIDE: 'Hide',
          SHOW: 'Show charts',
          HINT: 'Add <code>?debugCharts=1</code> to the URL to show it by default.',
          REMUNERATION: 'Remuneration',
          FIXE: 'Fixed',
          VARIABLE_INDIVIDUELLE: 'Individual variable',
          VARIABLE_COLLECTIVE: 'Collective variable',
          CHARGES_SOCIALES: 'Social charges',
          EMPLOYEUR: 'Employer',
          EMPLOYE: 'Employee',
          POLE_EMPLOI: 'Unemployment',
          RETRAITE: 'Retirement',
          SANTE: 'Health',
          PREVOYANCE: 'Provident',
        },
      },
    },
    CV: {
      UPLOADED_BY: 'Upladed by',
      HIST_DOC: 'Document History',
      DETAILSCANDIDATE: 'Candidate details',
      METIER: 'Job',
      POST: 'Applied Position ',
      CORRESPONDANCE: 'Correspondence',
      MAJ: 'Update',
      VOIR: 'View',
      PROFIL: 'CANDIDATE PROFILE',
      ANNEXP: 'Years of experience',
      OFFER: 'Add a Job Offer',
      VOIRDETAILS: 'Details and contract modification',
      TYPECONTRACT: 'Contract Type',
      NOMENTREPRISE: 'Company Name',
      ADRESSEENTREPRISE: 'Company Address',
      TEMP_WORKER_GROUP: {
        TITLE: 'Temporary worker / Secondment by an employers\' group',
        COMPANY_NAME: 'Company Name',
        COMPANY_ADDRESS: 'Company Address',
      },
      MOTIFDEBUTCONTRAT: 'Reason for Contract Start',
      Temps: 'Time',
      NOMBREHEURES: 'Number of Hours',
      CATEGORIE: 'Socio-Professional Category',
      Matricule: 'Employee ID',
      MOTIFFINCONTRAT: 'Reason for Contract End',
      DATE_FIN_PERIODE_ESSAI_1: 'End date of first trial period',
      DATE_FIN_PERIODE_ESSAI_2: 'End date of second trial period',
      RENSEIGNER_PERIODE_ESSAI_1: 'Please first enter the end date of the first trial period',
      GROUPECONGE: 'Leave Group',
      ADDCONTRAT: 'Add a contract',
      CONTRAT: 'Contract',
      CONTRACT_DATE_CONFLICT: 'Contract date overlap issue.',
      MESOFFRESEMPLOI: 'My Job Offers',
      Titre: 'Title',
      FICHEPOSTE: 'Job Description',
      DATEDEBUT: 'Start Date',
      DATEFIN: 'End Date',
      CANDIDATURERECU: 'Applications Received',
      PUBLIER: 'Publish the offer',
      COPIER: 'Copy the portal link',
      NAVIGATE: 'Open the portal page',
      FERMER: 'Close this offer',
      TOASTFERMER: 'The job offer has been successfully closed',
      // The discovery area distinguishes AI search from local result refinement.
      AI_SEARCH_PLACEHOLDER: 'Describe the profile you are looking for...',
      SEARCH_ACTION: 'Search',
      CLEAR_SEARCH: 'Clear search',
      SEARCH_PLACEHOLDER: 'Search a CV...',
      FILTER_JOB: 'Applied position',
      FILTER_NO_JOB: 'No position',
      FILTER_SKILLS: 'Skills',
      FILTER_COUNTRY: 'Country',
      FILTER_CITY: 'City',
      NO_RESULTS: 'No CV matches your search.',
      RESULTS_FOUND: 'CV found',
      CLARIFY_TITLE: 'Refine your search',
      CLARIFY_SUBTITLE: 'To get more relevant results, please specify your request:',
      CLARIFY_INTRO: 'To refine your search for',
      CLARIFY_ANSWER_LABEL: 'Your answer:',
      CLARIFY_ANSWER_PLACEHOLDER: 'e.g. I am looking for an Angular developer with 3 years of experience, based in Paris, permanent contract...',
      SEARCH_ANYWAY: 'Search anyway',
      IMPROVE_SEARCH: 'Launch improved search',
      // Accessible labels for visually untitled columns in the candidate list.
      FAVORITE: 'Favorite',
      PHOTO: 'Photo',
      FAVORITE_CANDIDATE: 'Favorite candidate',
      NOT_FAVORITE_CANDIDATE: 'Candidate not marked as favorite',
      CANDIDATE_PHOTO_ALT: 'Photo of {{name}}',
      FAVORITES_ONLY: 'Favorites only',
      // These cards combine recent candidates with applications attached to active offers.
      STATISTICS: {
        NEW_CANDIDATES_30_DAYS: 'Candidates added (30 days)',
        IN_PROCESS: 'Candidates in process',
        HIRED: 'Candidates hired',
        OVERDUE: 'Overdue candidates',
      },
      // Candidate selection and bulk-processing labels for the CV library.
      BULK_ACTIONS: {
        CANDIDATE_SELECTED: 'candidate selected',
        CANDIDATES_SELECTED: 'candidates selected',
        ASSIGN_SELECTED: 'Assign an offer',
        DELETE_SELECTED: 'Delete selection',
        SELECT_VISIBLE: 'Select all visible candidates',
        SELECT_CANDIDATE: 'Select candidate',
        ASSIGN_TITLE: 'Assign an offer to selected candidates',
        SELECT_OFFER: 'Select an offer',
        SELECT_OFFERS: 'Select offers',
        PROGRESS: '{{processed}} / {{total}} candidates processed',
        ASSIGN: 'Assign',
        CLOSE: 'Close',
        ASSIGN_SUCCESS: '{{count}} candidates were assigned successfully.',
        ASSIGN_PARTIAL: '{{success}} candidates assigned, {{failed}} failed. Failed candidates remain selected.',
        DELETE_TITLE: 'Delete selected candidates',
        DELETE_CONFIRMATION: 'Are you sure you want to delete all selected candidates?',
        DELETE_SUCCESS: '{{count}} candidates were deleted successfully.',
        DELETE_PARTIAL: '{{success}} candidates deleted, {{failed}} failed. Failed candidates remain selected.',
      },
      CLARA_FILTER: {
        TITLE: 'Step candidate filter',
        AVATAR_ALT: 'Clara, recruitment assistant',
        OPEN: 'Open Clara for the {{section}} step',
        DISCUSS: 'Chat with Clara',
        CLOSE: 'Close Clara',
        // Discussion-history deletion labels that explicitly preserve the active filter.
        CLEAR_HISTORY: 'Clear discussion history',
        CLEAR_HISTORY_TITLE: 'Clear the Clara discussion',
        CLEAR_HISTORY_CONFIRMATION: 'Are you sure you want to delete the entire discussion history? The active filter and displayed candidates will not be changed.',
        CLEAR_HISTORY_ACTION: 'Clear discussion',
        SECTION: 'Selected step',
        INPUT_LABEL: 'Professional criteria for Clara',
        PLACEHOLDER: 'Example: Show up to 5 candidates with Angular and 3 years of experience...',
        // Clara dictation uses only native browser/OS STT and never submits the instruction automatically.
        DICTATION: {
          START: 'Dictate the instruction',
          STOP: 'Stop dictation',
          WAITING: 'Listening, waiting for transcription…',
          LISTENING: 'Dictation in progress…',
          UNSUPPORTED: 'Native voice dictation is not supported by this browser.',
          HTTPS_REQUIRED: 'Voice dictation requires a secure HTTPS connection.',
          PERMISSION_DENIED: 'Microphone access was denied. Allow it in your browser settings.',
          MICROPHONE_UNAVAILABLE: 'No available microphone could be used.',
          RECOGNITION_ERROR: 'Voice dictation was interrupted. Please try again.',
          START_ERROR: 'Unable to start voice dictation.',
        },
        SEND: 'Send',
        LOADING: 'One moment, I’m analyzing the profiles…',
        RESET: 'Reset',
        REAPPLY: 'Reapply',
        REAPPLY_REQUEST: 'Reapply the active professional criteria without changing them.',
        ACTIVE: 'Active criteria',
        ACTIVE_FILTER_SINGULAR: '1 active filter',
        ACTIVE_FILTER_PLURAL: '{{count}} active filters',
        STALE: 'Reapply required',
        STALE_HELP: 'This step population changed. All candidates are shown until the filter is explicitly reapplied.',
        STATE_INVALID: 'New search needed',
        STATE_INVALID_SHORT: 'Renew search',
        STATE_INVALID_HELP: 'This search can no longer be used. Describe a new search to continue.',
        NO_ACTIVE_CRITERIA: 'No active criteria.',
        COUNT: '{{filtered}} of {{total}} candidates shown',
        WELCOME: 'Describe your search. I will work only with candidates in this step.',
        // Fixed radar copy clarifies that the visualization explains evidence rather than ranking candidates.
        RADAR_TITLE: 'Candidate comparison',
        RADAR_HINT: 'Visual comparison based on documented profile evidence. It is neither a ranking nor an automated decision.',
        RADAR_CANVAS_FALLBACK: 'Candidate comparison radar chart.',
        // Clara movements remain explicit plans that require human confirmation.
        MOVEMENT: {
          TITLE: 'Proposed movements',
          WARNING: 'No candidate will be moved before you confirm.',
          CONFIRM: 'Confirm ({{count}})',
          CONFIRMATION: 'Number of movements to confirm: {{count}}. This action will immediately update the Kanban columns.',
          AUTO_EMAIL: 'This stage may trigger the automatic email configured in the recruitment workflow.',
          EXECUTING: 'Moving candidates…',
          MOVED_COUNT: '{{moved}} of {{total}} movement(s) completed.',
          STATUS: {
            PENDING: 'Pending confirmation',
            EXECUTING: 'In progress',
            COMPLETED: 'Completed',
            PARTIAL: 'Partial',
            FAILED: 'Failed',
            STALE: 'Expired',
          },
          TOASTS: {
            SUCCESS: '{{moved}} movement(s) completed.',
            PARTIAL: '{{moved}} of {{total}} movement(s) completed. The Kanban was reloaded.',
            FAILED: 'No candidate could be moved. The Kanban was reloaded.',
            STALE: 'The Kanban changed after Clara prepared this proposal. Ask Clara to prepare a new movement.',
          },
        },
        // Clara's proposed actions are explicit buttons followed by a recruiter-authored free-text choice.
        SUGGESTIONS: {
          TITLE: 'Choose what happens next',
          CUSTOM_LABEL: 'Another request',
          CUSTOM_PLACEHOLDER: 'Write your own instruction…',
          CUSTOM_SEND: 'Send this instruction to Clara',
        },
        STRICT_MATCHES: 'I found {{matching}} candidates out of {{total}} who match your search.',
        STRICT_MATCHES_SINGULAR: 'I found 1 candidate out of {{total}} who matches your search.',
        STRICT_LIMITED: 'I found {{matching}} candidates out of {{total}} who match your search. I’m showing the first {{displayed}}.',
        STRICT_FEWER: 'I found {{matching}} candidates out of {{total}} who match your search, fewer than the {{requested}} requested.',
        STRICT_FEWER_SINGULAR: 'I found 1 candidate out of {{total}} who matches your search, fewer than the {{requested}} requested.',
        STRICT_EXACT: 'I found {{matching}} candidates out of {{total}} who match your search.',
        STRICT_EXACT_SINGULAR: 'I found 1 candidate out of {{total}} who matches your search.',
        NO_MATCHES: 'I couldn’t find any candidates in this step who match your search.',
        GENERIC_RESPONSE: 'I left the displayed candidates unchanged.',
        FILTER_RESET: 'I reset the search. All candidates in this step are visible again.',
        RESULT_DISCARDED: 'Clara’s result was discarded because the step population or signed state could not be validated. All candidates remain visible.',
        CRITERIA_REQUIRED: 'Provide at least one objective professional criterion before requesting a candidate count.',
        // Explain non-mutating clarification and provider safety refusals directly inside the Clara discussion.
        CLARIFICATION_REQUIRED: 'Specify the intended action. The current filter and displayed candidates remain unchanged.',
        GUARDRAIL_BLOCKED: 'I could not process this request because it was blocked by the AI service safety rules. The current filter and displayed candidates remain unchanged.',
        CANDIDATE_FALLBACK: 'Candidate',
        PROTECTED_IGNORED: {
          MIXED: 'I didn’t use {{categories}} for this search.\nI filtered candidates only by the professional criteria in your request: {{criteria}}.',
          MIXED_FALLBACK: 'I didn’t use {{categories}} for this search.\nThe results are based only on the other professional criteria in your request.',
          ONLY: 'I can’t filter candidates by {{categories}}. You can use their experience, skills, or certifications instead.',
          GENERIC: 'I can’t use this criterion to filter candidates. Try a professional criterion instead.',
          RESULTS: {
            MATCHES: 'I found {{matching}} candidates out of {{total}} who match these professional criteria.',
            MATCHES_SINGULAR: 'I found 1 candidate out of {{total}} who matches these professional criteria.',
            LIMITED: 'I found {{matching}} candidates out of {{total}} who match these professional criteria. I’m showing the first {{displayed}}.',
            FEWER: 'I found {{matching}} candidates out of {{total}} who match these professional criteria, fewer than the {{requested}} requested.',
            FEWER_SINGULAR: 'I found 1 candidate out of {{total}} who matches these professional criteria, fewer than the {{requested}} requested.',
            NO_MATCHES: 'I couldn’t find any candidates in this step who match these professional criteria.',
          },
          CATEGORIES: {
            AGE: 'age or date of birth',
            GENDER: 'sex, gender, or pregnancy',
            ORIGIN: 'origin, color, or ethnicity',
            RELIGION: 'religion or beliefs',
            HEALTH: 'disability or health',
            PERSONAL: 'family, marital, or personal situation',
            ORIENTATION: 'sexual orientation',
            IDENTITY: 'name or identity',
            APPEARANCE: 'photo or physical appearance',
            GENERIC: 'protected criterion',
          },
        },
        POLICY: {
          WARNING: 'Warning: Basing recruitment on {{categories}} is not only discriminatory: it is prohibited by law.',
          // Explain that an explicit disability/RQTH criterion was applied while keeping a human compliance check.
          INCLUSION_WARNING: 'This explicit disability or RQTH criterion was applied. Verify that it supports an authorized inclusion measure or hiring priority in your context.',
          BLOCKED_DETAIL: 'I cannot apply this request. The displayed candidates and current criteria remain unchanged.',
        },
        ERRORS: {
          CRITERIA_REQUIRED: 'Valid professional criteria are required.',
          LIMIT_200: 'This step exceeds the 200-candidate limit and cannot be filtered by Clara.',
          QUOTA: 'The available AI quota is insufficient for this analysis.',
          RATE_LIMIT: 'Too many Clara requests were sent. Wait briefly, then retry.',
          TIMEOUT: 'The analysis timed out. The previous filter remains unchanged.',
          INVALID_STATE: 'This Clara session state is invalid. Reset the filter and apply it again.',
          STATE_EXPIRED: 'This Clara session expired. Reset the filter and apply it again.',
          STATE_UNAVAILABLE: 'The signed Clara state is unavailable. Reset the filter or describe a new one.',
          POPULATION_CHANGED: 'This step changed during the analysis. Candidates were refreshed; reapply the filter.',
          CONTENT_TOO_LARGE: 'The candidate content required for this analysis is too large for Clara to process completely.',
          // Keep a dedicated panel fallback if a safety refusal cannot be rendered as a chat event.
          GUARDRAIL_BLOCKED: 'The request was blocked by the AI service safety rules. The previous filter remains unchanged.',
          GENERIC: 'Clara cannot apply this filter right now. The previous filter remains unchanged.',
        },
        TOASTS: {
          APPLIED: 'The Clara filter was applied to this step.',
          RESET: 'The Clara filter was reset.',
          HISTORY_CLEARED: 'The Clara discussion history was deleted. The active filter is preserved.',
          INFO: 'Clara kept the current filter state.',
          RESULT_DISCARDED: 'The stale Clara result was discarded. All candidates remain visible.',
          PROTECTED: 'Protected criteria were ignored.',
          ALERT: 'Clara applied the request with a warning.',
          BLOCKED: 'Clara blocked this criterion and kept the current results.',
          // Notify the recruiter without presenting a provider guardrail as a temporary technical failure.
          GUARDRAIL_BLOCKED: 'Request blocked by the AI service safety rules. The current filter was preserved.',
          ERROR_CRITERIA_REQUIRED: 'Add at least one valid professional criterion.',
          ERROR_LIMIT_200: 'Clara can analyze at most 200 candidates per step.',
          ERROR_QUOTA: 'Insufficient AI quota to filter candidates.',
          ERROR_RATE_LIMIT: 'Too many Clara requests. Wait briefly, then retry.',
          ERROR_TIMEOUT: 'Clara’s analysis timed out.',
          ERROR_INVALID_STATE: 'The Clara session is invalid. Reset and apply the filter again.',
          ERROR_STATE_EXPIRED: 'The Clara session expired. Reset and apply the filter again.',
          ERROR_STATE_UNAVAILABLE: 'The signed Clara state is unavailable. Reset or start a new filter.',
          ERROR_POPULATION_CHANGED: 'The step population changed. Candidates were refreshed.',
          ERROR_CONTENT_TOO_LARGE: 'The candidate content is too large for Clara to analyze.',
          ERROR_GENERIC: 'Unable to apply the Clara filter.',
        },
        ADVISORY: 'Clara is an advisory filtering tool. The recruiter remains responsible for evaluation and every decision.',
      },
      // The threshold is a local display filter and never alters Clara's signed state.
      KANBAN_SCORE_THRESHOLD: {
        LABEL: 'Total score threshold for {{section}}',
        HELP: 'Show candidates whose score_total is greater than or equal to this threshold. 0 shows every candidate.',
      },
      // Bulk movement reuses existing single-candidate mutations and can therefore produce a partial result.
      KANBAN_BULK_MOVE: {
        OPEN: 'Move the {{count}} visible candidates from {{section}}',
        TITLE: 'Move filtered candidates',
        SUMMARY: '{{count}} candidate(s) visible in {{source}} with a {{threshold}}% threshold.',
        TARGET: 'Destination column',
        SELECT_TARGET: 'Select a column',
        AUTO_EMAIL_WARNING: 'This destination may trigger the automatic emails configured for each candidate.',
        NON_ATOMIC_WARNING: 'Candidates are moved one at a time. If an error occurs, some candidates may already have moved before processing stops.',
        CONFIRM: 'Move ({{count}})',
        PROGRESS: 'Bulk movement in progress.',
        SUCCESS: '{{moved}} candidate(s) moved.',
        PARTIAL: '{{moved}} of {{total}} candidate(s) moved. The Kanban was refreshed.',
        FAILED: 'No candidate could be moved. The Kanban was refreshed.',
        STALE: 'The column or workflow changed. Refresh the Kanban before trying again.',
      },
      // Candidate comparison includes every internal, public, modal, error, and empty-state label.
      CANDIDATE_COMPARISON: {
        // This shorter label prevents candidate cards from becoming visually crowded.
        ADD: 'Compare',
        REMOVE: 'Remove {{name}} from comparison',
        SELECTED: 'Selected',
        LIMIT_REACHED: 'You can compare up to 5 candidates.',
        MINIMUM_REQUIRED: 'Select at least 2 candidates to start a comparison.',
        COMPARE: 'Compare',
        HISTORY: 'Saved comparisons',
        GENERATE_TITLE: 'Generate a candidate comparison',
        // Explicit ranking or recommendation requests remain available through additional instructions.
        AI_HINT: 'Clara creates a factual table from the available career data. You may request a ranking, score, or recommendation in the additional instructions; the final decision remains human.',
        CUSTOM_INSTRUCTIONS: 'Additional instructions (optional)',
        CUSTOM_INSTRUCTIONS_PLACEHOLDER: 'Example: Add a section about international environments and detail certifications relevant to the role.',
        ANONYMIZE: 'Anonymize candidates',
        ANONYMIZE_HINT: 'Names, photos, and contact details will be removed. Date of birth and age remain available.',
        GENERATING: 'Generating…',
        // Progress is a time-based estimate of thirty-five seconds per compared candidate.
        GENERATING_PROGRESS: 'Generating — {{percent}}%',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        LIST_TITLE: 'Comparison history',
        LIST_HINT: 'Find comparisons that are still available for this offer.',
        DETAIL_TITLE: 'Candidate comparison',
        OPEN: 'Open',
        DELETE: 'Delete',
        DELETE_TITLE: 'Delete comparison',
        DELETE_CONFIRMATION: 'Do you want to permanently delete this comparison and its share links?',
        DELETE_SUCCESS: 'The comparison was deleted.',
        DELETE_FAILED: 'The comparison could not be deleted.',
        ANONYMIZED: 'Anonymized',
        EXPIRES_AT: 'Expires on',
        CREATED_AT: 'Created on',
        CREATED_BY: 'Created by',
        CANDIDATES: 'candidates',
        RECEIVED_COMMENTS: 'Comments received',
        BACK_TO_CANDIDATES: 'Back to candidates',
        BACK_TO_HISTORY: 'Back to comparisons',
        LOADING: 'Loading comparison…',
        LOAD_FAILED: 'Unable to load this comparison.',
        EMPTY_HISTORY: 'No saved comparison',
        EMPTY_HISTORY_HINT: 'Select 2 to 5 candidates in the Kanban to create the first comparison.',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        PAGE: 'Page {{page}}',
        PAGINATION: 'Comparison pagination',
        TABLE_LABEL: 'Candidate comparison table',
        // This warning explicitly states that the comparison never replaces human decision-making.
        HUMAN_DECISION_NOTICE: 'This comparison is factual decision support. The AI is not designed to recommend, rank, or select candidates. The final decision must always be made by an authorized person.',
        // Radars compare offer-relative fit and explicitly neutralize axes that the offer does not require.
        RADAR_REGION: 'Visual candidate comparison against job requirements',
        RADAR_HINT: 'Each score measures fit against the job offer out of 5. The dashed line represents a fully met requirement; an axis with no explicit requirement gives every candidate 5/5.',
        RADAR_TARGET: 'Requirement met (5/5)',
        RADAR_NOT_REQUIRED: 'no explicit requirement, score neutralized at 5/5',
        RADAR_CANVAS_FALLBACK: 'The radar chart cannot be displayed in this browser.',
        CRITERION: 'Criterion',
        NOT_AVAILABLE: 'Not provided',
        EXPORT_PDF: 'Export PDF',
        EXPORT_FAILED: 'The PDF export could not be generated.',
        SHARE: 'Share',
        SHARE_TITLE: 'Share comparison',
        SHARE_HINT: 'Select the authorized collaborators. Each person will receive a temporary link protected by a verification code.',
        LINK_VALIDITY_HOURS: 'Link validity (hours)',
        LINK_VALIDITY_HINT: 'Between 1 and 720 hours. The default is 72 hours.',
        NOTIFICATION_RECIPIENTS: 'Authorized collaborators',
        SEARCH_COLLABORATORS: 'Search for a collaborator…',
        REMOVE_RECIPIENT: 'Remove {{name}} from authorized recipients',
        CREATE_LINK: 'Create link',
        COPY_LINK: 'Copy link',
        REVOKE_LINK: 'Revoke',
        LINK_CREATED: 'The public link was created.',
        LINK_CREATED_AND_SENT: 'The secure link was created and sent to the recipients.',
        LINK_COPIED: 'The public link was copied.',
        LINK_REVOKED: 'The public link was revoked.',
        SHARE_FAILED: 'Unable to create the public link.',
        COPY_FAILED: 'Unable to copy the link.',
        REVOKE_FAILED: 'Unable to revoke the link.',
        SHARES_LOAD_FAILED: 'Unable to load existing links.',
        ACTIVE_LINKS: 'Created links',
        NO_LINKS: 'No public link has been created yet.',
        ACTIVE: 'Active',
        REVOKED: 'Revoked',
        RECIPIENTS: 'recipients',
        PUBLIC_BADGE: 'Secure external view',
        PUBLIC_TITLE: 'Candidate comparison',
        PUBLIC_PAGE_TITLE: 'Candidate comparison – {{offer}}',
        // A shared comparison may include decision analysis requested by the recruiter without replacing final human accountability.
        PUBLIC_HINT: 'This comparison may include a ranking or recommendation requested by the recruiter. It is decision support and does not replace the final human decision.',
        EXPIRED_OR_INVALID: 'This link is no longer available',
        EXPIRED_OR_INVALID_HINT: 'The link is invalid, expired, or revoked. Contact the person who shared it with you.',
        COMMENTS_TITLE: 'Give feedback on each candidate',
        COMMENTS_HINT: 'Your comment is private and sent to the recruitment team. Previous comments and internal HR notes are not displayed.',
        // These labels belong to the authenticated detail and are never used on the public page.
        INTERNAL_COMMENTS_TITLE: 'Received external comments',
        INTERNAL_COMMENTS_HINT: 'These comments are visible only to the recruitment team from this comparison.',
        NO_INTERNAL_COMMENTS: 'No external comment has been received for this comparison yet.',
        COMMENT_AUTHOR: 'By',
        COMMENT: 'Comment',
        NAME: 'Full name',
        EMAIL: 'Email address',
        VERIFICATION_HINT: 'Enter the email address to which this comparison was sent.',
        SECURE_ACCESS: 'Secure access',
        SECURE_ACCESS_TITLE: 'Verify your email address',
        SECURE_ACCESS_HINT: 'To view this comparison, enter the email address selected by the person who shared it. A verification code will be sent to you.',
        SEND_CODE: 'Send code',
        CODE_SENT: 'If the address can receive the message, a verification code has been sent.',
        CODE_HINT: 'Enter the six-digit code received by email. It is valid for 10 minutes.',
        VERIFICATION_CODE: 'Verification code',
        VERIFY: 'Verify',
        BACK: 'Back',
        INVALID_CODE: 'The code is invalid or expired.',
        VERIFICATION_FAILED: 'Verification cannot be started right now.',
        VISITOR_SESSION_EXPIRED: 'Your access has expired. Verify your email address again.',
        COMMENT_PRIVATE_HINT: 'The comment will be kept in this comparison and will not be shown to people viewing the public link.',
        COMMENT_EDITABLE_HINT: 'You can edit this comment while this page remains open. It will no longer be displayed if you return later.',
        SEND_COMMENT: 'Send comment',
        EDIT_COMMENT: 'Edit comment',
        UPDATE_COMMENT: 'Update comment',
        COMMENT_SENT: 'Comment sent',
        COMMENT_UPDATED: 'Comment updated',
        COMMENT_FAILED: 'The comment could not be sent.',
        COMMENT_UPDATE_FAILED: 'The comment could not be updated.',
        GENERATION_FAILED: 'Comparison generation failed.',
        QUOTA_EXCEEDED: 'There are not enough credits available for this comparison.',
        TEMPORARY_FAILURE: 'The service is temporarily unavailable. Try again shortly.',
        INPUT_TOO_LARGE: 'The candidates’ combined data is too large for this comparison.',
      },
    },
    OFFRE: {
      SELECTEDCRITERE: 'Selection Criteria',

      CRITERESPLACEHOLDER:
        'The candidate must come from a prestigious school, have at least 5 years of post-graduate experience, etc...',
      CRITERS:
        'Enter here the specific criteria candidates must meet for this position. For example: required degree, type of school, minimum years of experience, specific skills, etc. This information helps clarify your expectations and guide applications.',
      COMPETENCES: 'Skills',
      COMPETENCES_INFO: 'Please select a skill from the list provided.',
    },
    MENU: {
      ET: 'and',
      ENREGISTRER: 'Save',
      PAUSE: 'Pause',
      WORKFLOW_TAB: 'Workflow',
      DURRETRAVAIL: 'Duration',
      PERIODE: 'Period',
      TOASTERALERT: 'Please save the changes before performing this action.',
      HEURETRAVAIL: 'Hours',
      DETAILS: 'Details',
      MES_COURRIERS: 'My Letters',
      MES_BSI: 'My BSI',
      DUREE: 'Duration',
      JOUR: 'Day',
      NOM: 'Name',
      PRENOM: 'First Name',
      IMAGE: 'Image',
      NONVALID: 'Not Validated',
      ENATTENTE: 'Pending',
      VALIDER: 'Validate',
      SUIVITEMPS: 'Time tracking',
      SELECTUSER: 'choose the collaborator',
      ADDSUIVITEMPS: 'Declare activities',
      DECLARER_ALERTE: 'Declare an alert',
      SUIVI_TEMPS_SUBTITLE: 'Declare your working hours',
      HORAIRES: 'Schedule',
      PROJET: 'Project',
      SELECT_PROJET: 'Select a project...',
      AUCUN: 'None',
      TEMPSEQUIPE: 'Team time tracking',
      ADDSUIVITEMPSUCCESS: 'date added successfully',
      DATEFIN: 'End time',
      SUIVITEMPSMSG:
        'Are you sure you want to end your day? By confirming, the time will be recorded and you will no longer be able to restart the counter.',
      TEMPS: 'Time',
      MESTEMPS: 'Time',
      HEURES_DEPASSEES: 'Contractual hours exceeded',
      JOURS_CONSECUTIFS_DEPASSES: 'Maximum consecutive working days exceeded',
      MES_REMUNERATIONS: 'My Compensation',

      GESTIONTEMPS: 'Time',
      PARAMETRE: 'Settings',
      SECURITY: 'Security',
      FLEXISPACE: 'Flexispace',
      TASKS: 'My tasks',
      CAREER: 'My Career',
      MY_OBJECTIVES: 'My Objectives',
      CAREERS_MANAGEMENT: 'Careers management',
      SKILLS_MANAGEMENT: 'Skills',
      MY_FLEXISPACE: 'My Flexispace',
      MESCOLLEGUES: 'My colleagues',
      Annuaire: 'Directory',
      MESCONGES: 'Time off',
      MY_EVENT: 'My events',
      Events: 'Events',
      Useridea: 'Ideas box',
      AdminIdea: 'Ideas',
      Attributions: 'Attributions',

      Entretiens: 'Interviews',
      PREONBOARDING: 'Pre-boarding & Onboarding',
      SUIVRE: 'Follow',
      FORMATIONDASH: 'Training',
      PLANNIFIERDASH: 'To plan',
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      BUILDER: 'builder',
      USER_PROFIL: 'User Profil',
      COLLAB: 'Collaborators',
      ENTRE: 'Enterprise',
      SITE: 'Site',
      SERVICE: 'Service',
      EQUIPE: 'Team',
      EQUIPETR: 'Transverse team',
      ACTIVITY: 'Activity',
      MATERIAL: 'Materials',
      MY_ACTIVITY: 'My Activities',
      STRATEGIE: 'Self service',
      COMMUNITY: 'Community',
      MY_COMMUNITIES: 'My Communities',
      REPORTING: 'Reporting',
      // Keep the preview status visible everywhere the experimental module appears in navigation.
      REPORT_AI: 'AI Report (experimental)',
      ALERTS: 'Alerts',
      GERER: 'Manage',
      Catalogue: 'Catalog',
      GERERMAJ: 'MANAGE',
      RENSEIGNER: 'ASK ABOUT',
      GENERERDOC: 'Generation of documents',
      DOCUMENTS: 'Documents',
      MESDOCUMENTS: 'My documents',
      Enquetes: 'Surveys',
      Quizs: 'Quizzes',
      Sondages: 'Polls',
      Cibler: 'Activate',
      AGIR: 'ACT and ORGANIZE',
      RECRUTER: 'RECRUIT',
      OFFRES: 'Job Offers',
      FICHES_POSTE: 'Job Descriptions',
      EXPORT: 'Export',
      IMPORT: 'Import',
      LEAVE: 'Leave',
      Communications: 'Communications',
      Alertes_des_collaborateurs: 'Collaborators alerts',
      ANALYZE: 'ANALYZE AND ANTICIPATE',
      Prev: 'Forcasts',
      FORMATIONS: 'Trainings',
      onboarding: 'My onboarding',
      LIEN: 'Link between entity',
      GENERAL: 'General',
      STRATEGIES: 'Strategies',
      AIDE: 'HELP',
      MANAGE: 'Gérer',
      NEWS: 'News ✨',
      CONTACT: 'Contact support',
      DOCUMENTATION: 'Support and Documentation',
      JEUX: 'Games',

      CAMPAGNES: 'Campaigns',
      ListeDesJeux: 'Games List',
      sondage: 'Survey',
      MES_QUESTIONS: 'My Questions',
      RECEIVED_QUESTIONS: 'Questions received',
      MES_FORMATIONS: 'My trainings',
      MES_TACHES: 'My Tasks',
      MES_SONDAGES: 'My Polls',
      MES_QUIZ: 'My Quizzes',
      MES_ENQUETES: 'My Surveys',
      MES_ENTRETIENS: 'My Interviews',
      MES_DOCUMENTS_A_SIGNER: 'My Documents to Sign',
      INTEGRATION_EXTERNE: 'External integration',
      MODELISATION: 'Space Management',
      OSP_RULES: 'Rules Management',
      OSP_RESV_ADMIN: 'Reservations Management',
      ATTENTEVALIDATION: 'Waiting for validation',
      GESTIONPROJETS: 'Project Management',
      GESTION_ALERTES: 'Alert management',
      ALERTES: 'My alerts',
      CREER_NOUVEAU_PROJET: 'Create New Project',
      REMUNERATION: 'Compensation management',
      OBJECTIFS: 'Objectives',
      LEFT: 'Left',
      CENTER: 'Center',
      RIGHT: 'Right',
    },
    OBJECTIFS: {
      PAGE_TITLE: 'Objectives of',
      ANNUAL_OBJECTIVES: 'Annual objectives',
      TEAM_OBJECTIVES: 'Team objectives',
      INDIVIDUAL_OBJECTIVES: 'Individual objectives',
      FILTER_SITE: 'Site',
      FILTER_SERVICE: 'Service',
      FILTER_TEAM: 'Team',
      CREATE_OBJECTIVE: 'Create an objective',
      EDIT_OBJECTIVE: 'Edit objective',
      DELETE_OBJECTIVE: 'Delete objective',
      DUPLICATE_OBJECTIVE: 'Create a copy',
      OBJECTIVE_TITLE: 'Title',
      OBJECTIVE_TYPE: 'Objective type',
      INDIVIDUAL: 'Individual objective',
      COLLECTIVE: 'Team objective',
      ASSIGNED_TO: 'Assigned to',
      PERIOD: 'For period',
      YEAR: 'Year',
      WEIGHTING: 'Select weighting',
      STEPS: 'Steps',
      STEPS_DESCRIPTION: 'Describe the steps to evaluate objective achievement',
      ADD_STEP: 'Add a step',
      NO_STEPS: 'No steps. If you have the rights, click on "Edit objective" or "Edit proposal" to add some.',
      STATUS: 'Status',
      PROGRESS: 'Progress',
      LINKED_OBJECTIVES: 'linked objectives',
      COMMENT: 'Comment',
      COMMENT_PLACEHOLDER: 'Your comment',
      SEND: 'Save and Send',
      SHOW_HISTORY: 'Show full history',
      CREATED_OBJECTIVE: 'created the objective.',
      SEE_MORE: 'see more',
      SHOW_LESS: 'show less',
      OBJECTIVES_COUNT: 'objectives',
      OBJECTIVE_COUNT: 'objective',
      LINKED_USERS: 'Linked users',
      SEARCH_LINKED_USERS: 'Search collaborator',
      NO_LINKED_USERS: 'No collaborators found',
      STATUS_ACHIEVABLE: 'Achievable',
      STATUS_AT_RISK: 'At risk',
      STATUS_BLOCKED: 'Blocked',
      STATUS_COMPLETED: 'Completed',
      REQUIRED_FIELDS: 'Required fields',
      CLOSE: 'Close',
      KPI: 'Key Performance Indicator (KPI)',
      MY_OBJECTIVES: 'My objectives',
      MY_TEAM: 'My team',
      NO_OBJECTIVES: 'No objectives yet.',
      FILTER_COLLABORATOR: 'Collaborator',
      FILTER_COLLABORATOR_PLACEHOLDER: 'Collaborator name',
      FILTER_AVANCEMENT: 'Minimum achievement ',
      FILTER_AVANCEMENT_PLACEHOLDER: 'e.g. 50',
      UNKNOWN_YEAR: 'Unassigned year',
    },
    INTERVIEWS: {
      PLANNER: {
        CREATE_ERROR: 'The interview could not be scheduled. Check the interview list before trying again to avoid duplicates. If the problem persists, contact an administrator.',
        ERROR_EMPLOYEE_INACTIVE: 'An evaluated collaborator has an inactive account. Ask an administrator to reactivate it before saving this interview, or select an active collaborator when creating an interview.',
        ERROR_PRINCIPAL_MANAGER_INACTIVE: 'The principal manager has an inactive account. Select an active principal manager or ask an administrator to reactivate the account.',
        ERROR_ADDITIONAL_MANAGER_INACTIVE: 'An additional manager has an inactive account. Remove or replace inactive additional managers, or ask an administrator to reactivate their accounts.',
        ERROR_PARTICIPANT_UNAVAILABLE: 'A selected participant is unavailable. Check the collaborator, principal manager and additional managers, then select available accounts or contact an administrator.',
        ERROR_DATE: 'The interview date is invalid. Select a valid calendar date.',
        ERROR_TIME: 'The interview time is invalid. Enter a time in HH:mm format.',
        ERROR_TIMEZONE: 'The collaborator\'s timezone could not be resolved. Ask an administrator to check the collaborator\'s site timezone before saving.',
        ERROR_LOCAL_TIME: 'This time does not exist in the collaborator\'s timezone due to a daylight-saving change. Select another time.',
        ERROR_NOTICE: 'Enter a positive whole number of notice months before saving.',
        ERROR_RECURRENCE: 'Enter a positive whole number of months for the recurrence, or disable recurrence.',
        ERROR_TEMPLATE: 'The selected document template is unavailable. Reload the available templates and select an accessible template.',
        ERROR_TYPE: 'The selected interview type is unavailable. Reload the available types and select one again.',
        ERROR_TEMPLATE_TYPE: 'The document template does not match the interview type. Select a template belonging to the selected type.',
        ERROR_TARGET: 'The selected target is unavailable. Reload and select an available site, department, team or collaborator.',
        ERROR_NO_EMPLOYEES: 'No active collaborators were found for this target. Select another target or ask an administrator to check the accounts.',
        ERROR_STATUS: 'This interview can no longer be edited in its current status. Reload the interview list to check its status.',
        ERROR_CONFLICT: 'The interview changed while you were saving. Reload the interview list and review its current state before trying again.',
        ERROR_NETWORK: 'The server could not be reached. Check your connection and the interview list before retrying to avoid duplicate creation.',
        ERROR_INPUT: 'Some interview information is invalid. Check the participants, document and scheduling fields before saving again.',
        ERROR_SESSION: 'Your session is no longer valid. Sign in again before saving the interview.',
        ERROR_FORBIDDEN: 'You do not have permission to perform this interview action. Contact an administrator or the authorized principal manager.',
        ERROR_UNAVAILABLE: 'The interview or a selected resource is no longer available. Reload the interview list and available selections before trying again.',
        CREATE_TITLE: 'Schedule an interview',
        EDIT_TITLE: 'Edit interview',
        EDIT_DOCUMENT: 'Edit document',
        SAVE: 'Save changes',
        REQUIRED_FIELDS: 'Please complete the interview information.',
        CREATE_SUCCESS: 'Interview scheduled for {{count}} collaborator(s).',
        UPDATE_SUCCESS: 'Interview updated successfully.',
        UPDATE_ERROR: 'Unable to update the interview. Check its status and your permissions, then try again.',
        CHANGE_EMPLOYEE_TITLE: 'Change collaborator?',
        CHANGE_EMPLOYEE_MESSAGE: 'Changing the collaborator will reset this interview\'s responses and validations. Other changes preserve existing responses and validations. Confirm this change?',
        CHANGE_EMPLOYEE_CONFIRM: 'Change and reset',
        REPLACE_EMPLOYEE_TITLE: 'Replace the interview and retain the old one?',
        REPLACE_EMPLOYEE_MESSAGE: 'This interview contains data linked to the current collaborator and cannot be reassigned directly. Confirming will cancel the old interview and retain its data under the original collaborator. Its pending feedback and calendar invitations will be cancelled using the existing behaviour. A clean interview with a new ID will be created for the selected collaborator, without copying the old responses, validations, documents, signatures or history. The selected saved template will be used; local document edits will not be transferred. External signature requests will not be revoked. Cancelling leaves the old interview unchanged and this planner open.',
        REPLACE_EMPLOYEE_CONFIRM: 'Replace and retain the old interview',
        REPLACE_EMPLOYEE_SUCCESS: 'A new interview was created for the selected collaborator. The old interview was cancelled and its data retained under the original collaborator.',
        REPLACE_EMPLOYEE_ERROR: 'The interview replacement could not be confirmed. Check the interview list before trying again.',
        REPLACEMENT_CHILD_BLOCKED: 'The collaborator of this sub-interview cannot be replaced directly. Recreate the feedback for the correct collaborator from the parent interview. This sub-interview remains unchanged.',
        REPLACEMENT_CONFLICT: 'The interview changed during replacement. Reload the interview list to check its state before trying again.',
        REPLACEMENT_CALENDAR_UNCERTAIN: 'The replacement is saved, but delivery of calendar invitations or cancellations could not be confirmed. Check the participants\' calendars; no automatic resend was performed on this retry.',
        EMPLOYEE_CHANGE_BLOCKED: 'The collaborator cannot be changed because this interview contains documents, signatures, feedback or history linked to the current collaborator. Other information can still be edited.',
        TEMPLATE_IMAGE_ONLY: 'To use a new background image, select a template containing that image. The shared template is not changed from this interview.',
      },
      // Shared location labels keep every interview-instance screen aligned with the persisted values.
      LOCATION: 'Location',
      LOCATION_ONSITE: 'On site',
      LOCATION_REMOTE: 'Video conference',
      LOCATION_FORM: 'Form',
      // Translate the complete payroll-backed interview field and its authorization feedback.
      PAYROLL_TEMPLATE_FORBIDDEN: 'This action requires payroll administrator status because the template contains a remuneration field.',
      SCHEDULING_ERROR: 'The interview could not be scheduled.',
      // Planning and Outlook invitations use the evaluated collaborator's site timezone.
      COLLABORATOR_TIMEZONE_INFO: "This interview will use the collaborator's timezone: {{timeZone}}.",
      REMUNERATION: {
        FIELD_TYPE: 'Remuneration',
        CONFIG_TITLE: 'Remuneration data',
        CONFIG_HELP: 'Select one payroll tab and the columns to capture when the interview is created.',
        ONGLET_LABEL: 'Payroll tab',
        COLUMNS_LABEL: 'Visible columns',
        SEARCH_COLUMNS: 'Search columns',
        SELECTED_COLUMNS: '{{ count }} column(s) selected',
        LOADING_ONGLETS: 'Loading accessible payroll tabs...',
        LOADING_COLUMNS: 'Loading columns...',
        NO_ONGLETS: 'No payroll tab is accessible.',
        NO_COLUMNS: 'No column matches this search.',
        UNAVAILABLE_COLUMNS: 'These saved columns are no longer available and must be deselected:',
        DESELECT_COLUMN: 'Deselect',
        ONGLETS_LOAD_ERROR: 'The accessible payroll tabs could not be loaded.',
        COLUMNS_LOAD_ERROR: 'The columns for this payroll tab could not be loaded.',
        CONFIG_REQUIRED: 'Select one payroll tab and at least one column before saving the template.',
        CONFIG_INVALID: 'The remuneration configuration is invalid or references unavailable payroll tabs or columns. Update the remuneration fields in the source template, then try again.',
        API_FAILURE: 'The remuneration data could not be processed. Please try again later or contact your payroll administrator.',
        CLEANUP_WARNING: 'Unavailable payroll references excluded from interview preparation: {{removedColumns}} column reference(s) and {{removedFields}} remuneration field(s). A whole field is excluded when its tab is unavailable or no usable column remains. Counts refer to the configurations checked, not employees. The shared template is unchanged; update the source template.',
        ALLOW_COMMENT: 'Allow a comment',
        ALLOW_COMMENT_HELP: 'The manager and collaborator each have their own optional comment.',
        COMMENT_LABEL: 'Comment',
        COMMENT_PLACEHOLDER: 'Add an optional comment',
        NO_ACCESS_TITLE: 'Restricted remuneration access',
        NO_ACCESS_DESCRIPTION: 'Payroll administrator status is required to view this remuneration information in the preview.',
        CONFIGURED_TITLE: 'Remuneration columns configured',
        CONFIGURED_DESCRIPTION: 'Columns from the {{ onglet }} tab will be captured when the interview is created. No employee data is loaded in this preview.',
        EMPTY_SNAPSHOT: 'No remuneration data is available in this snapshot.',
        CAPTURED_AT: 'Captured on {{ date }}',
      },
      // Custom-skill fallback remains available when authenticated interview searches return no result.
      ADD_SKILL_CUSTOM: 'Add "{{skill}}" as a new skill',
      COLLABORATOR: 'Collaborator',
      SKILLS_MAX_STARS: 'Maximum number of stars',
      NO_SELECTION: 'No selection',
      NO_OPTIONS: 'No options. Add some below.',
      OPTION_PLACEHOLDER: 'New option...',
      ADD_TEXT_OPTION: 'Add option',
      MANAGE_TABS: {
        INTERVIEWS: 'Interviews',
        RECURRENT: 'Recurring interviews',
        CAMPAIGNS: 'Campaigns',
        SETTINGS: 'Settings',
      },
      // Translate the personal reminder preference shown only in My interviews.
      REMINDER_NOTIFICATIONS: {
        ENABLE_LABEL: 'Send reminder emails',
        ENABLE_HELP: 'This personal choice affects reminder emails only. Planning, rescheduling, and validation emails are still sent.',
        STATUS_ENABLED: 'Receive reminder emails: Enabled',
        STATUS_DISABLED: 'Receive reminder emails: Disabled',
        ENABLE_ACTION: 'Receive reminders',
        DISABLE_ACTION: 'Do not receive reminders',
        CONTROL_ARIA_LABEL: 'Change reminder email delivery',
        LOADING: 'Reminders…',
        CONFIRM_TITLE: 'Disable reminders?',
        RESPONSIBILITY_STATEMENT: 'I am responsible for meeting the deadlines in accordance with the evaluation campaign calendar for the year in question.',
        ACKNOWLEDGEMENT_LABEL: 'I acknowledge and accept this responsibility.',
        ACKNOWLEDGEMENT_REQUIRED: 'You must acknowledge this responsibility to disable reminder emails.',
        CONFIRM_HELP: 'By confirming, I acknowledge and accept this responsibility. Other interview-related emails will remain enabled.',
        CONFIRM_DISABLE_ACTION: 'I acknowledge and disable reminders',
        SAVE_SUCCESS: 'Your reminder email preference was saved.',
        SAVE_ERROR: 'Unable to save your reminder email preference.',
        LOAD_ERROR: 'Unable to load your reminder email preference.',
      },
      // Report calendar delivery separately so successful interview writes remain successful.
      CALENDAR_DELIVERY: {
        SUCCESS: 'Calendar notifications were sent successfully.',
        PARTIAL_WARNING: 'The calendar notification was sent to only {{sent}} of {{attempted}} participant(s). The interview was saved successfully.',
        FAILED_WARNING: 'The calendar notification could not be sent to any participant. The interview was saved successfully.',
      },
      // Translate interview type management and the new rename action.
      TYPE_SETTINGS: {
        AVAILABLE_TYPES: 'Available interview types',
        RENAME_TITLE: 'Rename interview type',
        NAME_LABEL: 'Interview type name',
        NAME_PLACEHOLDER: 'E.g. Annual Performance Review',
        ADD_LABEL: 'Add a new interview type',
        LOAD_ERROR: 'Unable to load interview types.',
        ADD_SUCCESS: 'The interview type was added successfully.',
        ADD_ERROR: 'Unable to add the interview type.',
        RENAME_SUCCESS: 'The interview type was renamed successfully.',
        RENAME_ERROR: 'Unable to rename the interview type.',
        DUPLICATE_ERROR: 'An interview type with this name already exists.',
        DELETE_TITLE: 'Delete interview type',
        DELETE_CONFIRMATION: 'Are you sure you want to delete the interview type “{{name}}”?',
        DELETE_SUCCESS: 'The interview type was deleted successfully.',
        DELETE_ERROR: 'Unable to delete the interview type.',
      },
      IMPORTED_PREVIEW: {
        OBJECTIVE_PERIODS: {
          ASSESSED: 'Assessed objectives',
          PLANNED: 'Planned objectives',
          UNKNOWN_PERIOD: 'Period to clarify',
          SOURCE_PERIOD: 'Period in the document',
          DEADLINE: 'Deadline',
          RESULT: 'Result',
          RESULT_ATTAINED: 'Attained',
          RESULT_PARTIAL: 'Partially attained',
          RESULT_NOT_ATTAINED: 'Not attained',
          RESULT_UNKNOWN: 'Not specified',
          PROGRESS_UNKNOWN: 'Not specified',
        },
        LABEL: 'Imported interview',
        HELP: 'Historical interview imported from a document. This preview does not certify participant acceptance or signatures.',
        SOURCE_CONTENT: 'Content from the imported document',
        SECTION: 'Section {{number}}',
        CONTENT_UNAVAILABLE: 'The imported content is unavailable for preview. You can view the attached PDF when available.',
        SOURCE_PDF: 'PDF import',
        SOURCE_EXCEL: 'Excel import',
        OPEN_SOURCE: 'View attached PDF',
        EXPORT: 'Export as PDF',
        LOAD_ERROR: 'The interview preview could not be loaded.',
        EXPORT_ERROR: 'The interview PDF could not be generated. Please try again.',
        FONT_ERROR: 'The PDF font cannot display every interview character. No incomplete PDF was downloaded. The preview remains available.',
        ANALYSIS_UNAVAILABLE: 'No usable interview analysis is available for this Excel import yet. The original source is preserved.',
        ANALYSIS_STALE: 'The Excel source text changed after analysis. The previous analysis is not shown as current interview content.',
        QUESTIONNAIRE: {
          PARTIAL: 'This report is incomplete: some source questions or answers could not be displayed reliably. Ask an administrator to review the source question labels and import preparation. The original source is preserved.',
          STALE: 'The source has changed. This questionnaire is unavailable.',
          UNAVAILABLE: 'Questionnaire unavailable.',
          COLLABORATOR: 'Collaborator',
          MANAGER: 'Manager',
          COMMENT: 'Comment',
          EVALUATION: 'Evaluation',
        },
        REPORT: {
          TITLE: 'Imported interview report',
          SOURCE_PARTICIPANTS: 'Identity extracted from the document',
          ASSIGNED_ACCOUNTS: 'Application assignment',
          ASSIGNED_HELP: 'These accounts control assignment and access in the application. They are not necessarily the people who wrote the source document.',
          SOURCE_DATE: 'Extracted interview date',
          SOURCE_PERIOD: 'Evaluation period',
          GENERAL_INFORMATION: 'Document information',
          OBJECTIVES: 'Objectives',
          NO_OBJECTIVES: 'No objectives were retained in the import data.',
          OBJECTIVES_UNAVAILABLE: 'Structured objectives are unavailable. Source objective information, when present, remains in the document content or source references.',
          OBJECTIVES_REVIEW_REQUIRED: 'The review status of this objective list is not confirmed.',
          OBJECTIVE_SYNC_FAILED: 'Objective synchronization reported an error. The objective data saved with the interview is still shown here.',
          OBJECTIVE_REVIEWED: 'Objective list saved during import',
          SOURCE_AUTHOR: 'Author named in the source',
          RECORD: 'Entry {{number}}',
          SOURCE_NOTICE: 'Notice in the source document',
          STRUCTURE_UNAVAILABLE: 'Some source content could not be structured reliably. It remains available in the source references and attached PDF.',
          SOURCE_TEXT_CHANGED: 'The source text was edited after extraction. Older structured answers are not substituted for the current text.',
          SOURCE_REVIEW_REQUIRED: 'Some source information needs clarification. Refer to the preserved source details.',
          ADDITIONAL_CONTENT: 'Additional document content',
          SOURCE_REFERENCES: 'Additional source references',
          SOURCE_REFERENCES_HELP: 'Original source details are kept separately from the report and the retained objective list. They are not included in the PDF unless selected.',
          SOURCE_UNKNOWN: 'Not specified in the source',
          REFRESH: 'Refresh report',
          REFRESH_ERROR: 'The report could not be refreshed.',
          INCLUDE_REFERENCES: 'Include additional source references in the PDF',
          LEGACY_FORMAT: 'This response uses the older source-view format. Refresh the report after the backend update is loaded.',
        },
      },
      IMPORT: {
        TAB: 'Import',
        EXCEL_INSTRUCTIONS: {
          TITLE: 'Instructions for this file',
          OPTIONAL: 'Optional Excel interpretation instructions',
          OPTIONAL_BADGE: 'Optional',
          UPLOAD_HELP: 'Optional: specify what to retain in the drafts and objectives. Leave blank for the usual import.',
          COMPACT_PRIVATE: 'Private instructions; original file unchanged.',
          DEFAULT_HELP: 'No instructions = usual import.',
          SCOPE_HELP: 'Add a reading rule or an objective filter only if needed.',
          PLACEHOLDER: 'Example: keep only new objectives and their source KPIs.',
          REVIEW_NOTICE: 'Review the AI interpretation before confirming. Original answers are not rewritten.',
          WARNINGS_TITLE: 'Attention points ({{count}})',
          WARNINGS_HELP: 'These semantic treatments are not claimed by any instruction. Preparation stays available; review them before confirming.',
          CHARACTER_COUNT: '{{count}} / {{max}} characters',
          STATUS_EMPTY: 'No instructions',
          STATUS_SAVED: 'Current instructions',
          STATUS_DIRTY: 'Unsaved changes',
          STATUS_READ_ONLY: 'Read-only',
          POLICY: {
            TITLE: 'New objectives to create',
            STANDARD_TITLE: 'Objectives: usual extraction.',
            STANDARD_HELP: 'This analysis has no objective-selection policy. If you expected filters for objectives or years, update the instructions and analyse the file again before preparing drafts.',
            HELP: 'These rules select objectives to propose, not content to remove from the report. Original answers and previous objectives stay in the interview history unless you separately exclude that content.',
            PHASE: 'Objective period',
            PLANNED_ONLY: 'New / planned objectives only',
            TARGET_YEAR: 'Year filter for new objectives',
            ANY_YEAR: 'No year filter',
            CATEGORIES_TITLE: 'Allowed categories',
            SOURCE_KINDS_TITLE: 'Allowed source content',
            SOURCE_REFS: 'Source sections used to propose objectives',
            ALL_INCLUDED: 'All included source sections',
            NONE: 'None',
            MISSING_YEAR: 'When the source has no year',
            MISSING_REVIEW: 'Needs review. Do not infer a year.',
            MISSING_CONTEXT: 'Use {{year}} only when no source year exists, based on this saved instruction:',
            YEAR_HELP: 'A year filter never changes a source year. An explicit source year takes priority over a year supplied by instructions.',
            REVIEW_HELP: 'AI-proposed objectives and KPIs still need review. Confirm this interpretation below, then review the proposed objectives in each draft.',
            CATEGORIES: { performance: 'Performance', management: 'Management', delegation: 'Delegation', development: 'Development', career: 'Career', posture: 'Professional approach', other: 'Other' },
            SOURCE_KINDS: { explicit_goal: 'Explicit objectives', actionable_context: 'Actions described in answers or comments' },
          },
          PRIVATE_HELP: 'Private instructions, not included in the report.',
          EXAMPLES_TITLE: 'Examples of useful instructions',
          EXAMPLES: 'Keep only new objectives and their KPIs; keep previous objectives in the history.\nRetain both previous and new objectives, with their source years.\nUse the Reviews sheet as the main list and the employee number as the identity key.\nThe evaluator is the manager.',
          TOO_LONG: 'Use at most 4096 characters (16 KiB), without hidden control characters. Your text has not been shortened.',
          BATCH_TOO_LONG: 'The combined Excel instructions exceed 64 KiB. Shorten the instructions or select fewer files before creating the batch.',
          RETRY_CREATE: 'Retry batch creation',
          RETRY_CREATE_HELP: 'Batch creation failed. Your files and instructions remain selected. Edit the instructions if needed, then retry; uploaded files will be reused without uploading again.',
          SAVE: 'Save instructions',
          SAVE_HELP: 'Saves this text for this file only. Does not start analysis or change imported interviews.',
          SAVED: 'Instructions saved. Start analysis explicitly to use this version.',
          SAVE_ERROR: 'Instructions could not be saved. Your edits have been kept.',
          STALE: 'This source changed or is no longer editable. Close and reopen it to load the current version. Your unsaved text has been kept here.',
          ANALYSE: 'Analyse with these instructions',
          ANALYSE_HELP: 'Updates the analysis using the text above. No interview is imported.',
          ANALYSIS_STARTED: 'File analysis started with the saved instruction version.',
          ANALYSIS_ERROR: 'Analysis could not be started. The saved instructions have been kept.',
          ANALYSIS_REQUIRED: 'These instructions are saved. Click “Analyse with these instructions”, then review the result.',
          ANALYSIS_REQUIRED_STATUS: 'Saved instructions need analysis',
          IMPORTED_UNCHANGED: 'Changing instructions never changes already imported interviews. Prepared drafts must first be explicitly discarded using the existing source reset action; a source with imported interviews cannot be changed.',
          READ_ONLY: 'These source instructions are read-only. Return to the source card to reset prepared drafts explicitly, if that action is available. Imported interviews cannot be reset here.',
          MAPPING_DIRTY: 'You have unsaved mapping changes. Review the mapping first or close without saving before editing or analysing instructions.',
          DIRTY: 'Instructions changed. Click “Analyse with these instructions” before preparing drafts.',
          DISCARD_TITLE: 'Discard unsaved instructions?',
          DISCARD_HELP: 'Only your unsaved instruction text will be discarded. No prepared drafts or imported interviews will be removed.',
          DISCARD: 'Discard text and close',
          REVIEW_TITLE: 'What the AI understood',
          APPLIED_TITLE: 'Interpretation applied to the prepared drafts',
          REVIEW_HELP: 'Check what the analysis proposes for this file before preparing private drafts.',
          NOT_READY: 'The analysis needs to be redone. Check your instructions, then click “Analyse with these instructions”. No drafts can be prepared yet.',
          SUMMARY: {
            YEAR_FILTER: 'Only objectives for {{year}} will be proposed.',
            MISSING_YEAR_CONTEXT: 'If the source gives no year, use {{year}} from the saved instructions.',
            MISSING_YEAR_REVIEW: 'Objectives without a source year will need review.',
            REPORT_RETAINED: 'Source answers and previous objectives remain in the report. Selecting new objectives does not delete that history.',
            REPORT_EXCLUSIONS: 'The report omits {{sheets}} sheet(s). {{fields}} other field(s) are not included as answers (history, metadata or excluded content). Other answers are retained; objective selection is a separate filter.',
            EXCLUDED_SHEETS: 'Sheets omitted from the report:',
            ANALYSIS_CHECKED: 'The saved analysis has no unresolved instructions. This does not replace your review.',
          },
          IMPORT_HELP: 'Check the detected interviews and the interpretation of your saved instructions before preparing private drafts.',
          CONFLICT_REASONS: {
            duplicate_reference: 'The AI defined the same source field more than once. Its generated rules must be made consistent before drafts can be prepared.',
            non_objective_period: 'The AI attached objective year or period settings to a field that is not an objective. This is a generated-rule error, not a change to your source data.',
            excluded_field_annotation: 'The AI attached an answer role or question reference to a field it excluded from the report. These generated rules are inconsistent.',
            self_question_reference: 'The AI used a field as its own question reference instead of linking the correct question or heading.',
            ignored_question_reference: 'The AI uses an ignored field as a question reference. The reference must be corrected without cancelling the exclusion.',
            ignored_year_reference: 'The AI uses an ignored field as a year reference. This remains blocked rather than dropping the source year or choosing another year automatically.',
            inconsistent_group_phase: 'The AI gave one objective conflicting historical/planned classifications. The application will not choose a period arbitrarily.',
            inconsistent_group_year_reference: 'The AI linked one objective to incompatible year references. The application will not choose one reference arbitrarily.',
            inconsistent_group_default_year: 'The AI assigned different fallback years to one objective. The application will not choose a year arbitrarily.',
          },
          DIAGNOSTICS: {
            GENERIC: 'The analysis did not return a usable interpretation. Analyse the file again with the saved instructions; approving headers alone cannot resolve this issue.',
            CODE: 'Diagnostic code:',
            LOCATION: 'Affected source field(s):',
            INTERVIEW_INTERPRETATION_INVALID: 'The proposed interpretation has an invalid structure or format and cannot be validated. Analyse the file again; no drafts can be prepared yet.',
            INTERVIEW_INTERPRETATION_REQUIRED: 'The analysis did not provide interpretation rules for the saved instructions. Analyse the file again; no draft has been prepared.',
            INTERVIEW_INTERPRETATION_LIMIT: 'The interpretation exceeds a supported size or rule limit. Check the scope of the instructions, then analyse the file again.',
            INTERVIEW_INTERPRETATION_REFERENCE: 'A proposed cell or column reference does not match the file layout. This may also concern a question or year reference. Analyse the file again to correct the references.',
            INTERVIEW_INTERPRETATION_COVERAGE: 'The analysis returned inconsistent instruction links, such as duplicates or invalid instruction numbers. Analyse the file again to rebuild these links.',
            INTERVIEW_INTERPRETATION_CONFLICT: 'The proposed interpretation contains conflicting field rules or references. Check the instructions and analyse the file again.',
            INTERVIEW_INTERPRETATION_HEADER_CONFLICT: 'A proposed rule contradicts an explicit source header, such as the answer role, objective importance, progress or year. Check the instructions and analyse the file again.',
            INTERVIEW_INTERPRETATION_GROUP: 'The proposed objective groups are invalid or incomplete, for example because titles are missing or fields are duplicated. Analyse the file again before preparing drafts.',
            INTERVIEW_INTERPRETATION_DEFAULT_YEAR: 'A proposed default year is invalid or is not present in the saved instructions. Clarify the intended year, then analyse the file again; explicit source years remain unchanged.',
            INTERVIEW_INTERPRETATION_EMPTY_HEADER: 'A proposed question or year reference points to an empty source header. Check the file headers and analyse the file again.',
            INTERVIEW_INTERPRETATION_SHEET_COVERAGE: 'The analysis did not account for all included sheets. Analyse the file again so the included and excluded sheets are handled consistently.',
            INTERVIEW_INTERPRETATION_IGNORED_SHEET: 'The proposed rules still use a sheet that the layout excludes. Analyse the file again to reconcile this exclusion.',
            INTERVIEW_INTERPRETATION_EXCLUDED_FIELDS: 'The proposed interpretation excludes a sheet but still uses its fields. Analyse the file again to correct these conflicting rules.',
            INTERVIEW_INTERPRETATION_COVERAGE_REFERENCE: 'The analysis links an instruction to an invalid sheet or field reference. Analyse the file again to correct the references.',
            INTERVIEW_INTERPRETATION_COVERAGE_STATUS: 'The analysis did not return a valid outcome for an instruction. Check its wording and analyse the file again.',
            INTERVIEW_INTERPRETATION_OBJECTIVE_POLICY: 'The objective selection rules are invalid or incomplete. Clarify the instructions and run a new analysis before confirming.',
            INTERVIEW_INTERPRETATION_OBJECTIVE_POLICY_REFERENCE: 'An objective selection rule refers to a source section that is not included or cannot be used. Review the source references and run a new analysis.',
            INTERVIEW_INTERPRETATION_OBJECTIVE_POLICY_EMPTY: 'The analysis cannot select any new objectives with these rules. Check your instructions, then analyse again.',
          },
          IDENTITY: 'Identity key and mapped fields',
          NONE: 'No explicit key or field',
          QUESTION_REF: 'Question reference',
          YEAR_REF: 'Source year reference',
          GROUP: 'Goal group',
          DEFAULT_YEAR: 'Default {{year}} only when the source year is missing',
          SHEET_SCOPE: 'Sheet inclusion',
          SOURCE_YEAR_HELP: 'An explicit source year always wins. A default year is administrative context only, never a claim about the source or an automatic shift to the current year.',
          HEADERS_REQUIRED: 'First check the detected questions below, then confirm this interpretation. No question label is approved automatically.',
          HEADER_CONFLICT: 'The proposed rule conflicts with an explicit source header, such as an answer role, goal importance, progress or year. Correct the instructions or mapping, then explicitly analyse again.',
          REVIEW_HEADERS: 'Check the questions',
          CONFIRM: 'This summary matches my instructions.',
          CONSENT_HELP: 'By confirming, you authorize the use of detected questions to prepare private drafts.',
          CONSENT_CHANGED: 'The file or analysis changed during confirmation. Review the updated summary before confirming again.',
          HEADERS_UNSAFE: 'The detected questions cannot be used safely. Check the source file and analyse it again before confirming.',
          DISPLAY: { include: 'Included', exclude: 'Excluded' },
          ROLES: { collaborator: 'Collaborator answer', manager: 'Manager answer' },
          PHASES: { assessed: 'Assessed goals', planned: 'Planned goals', unknown: 'Goal period not specified' },
          COVERAGE: { mapped: 'Proposed rule linked to this instruction', unsupported: 'Unsupported instruction', ambiguous: 'Ambiguous instruction', conflict: 'Conflicting instruction', unresolved: 'Unresolved instruction', unclaimed_rule: 'Rule not linked to an instruction', uncovered_source: 'Source content has no interpretation rule', empty_question: 'The referenced question is empty in the source' },
          KINDS: { answer: 'Answer', comment: 'Comment', report_comment: 'Report comment (not an objective source)', evaluation: 'Evaluation', objective_title: 'Goal title', objective_header_title: 'Goal title from the full header', objective_header_title_suffix: 'Goal title from the header after the first " - "', objective_description: 'Goal description', objective_comment: 'Goal comment', objective_kpi: 'Goal KPI', objective_deadline: 'Goal deadline', objective_result: 'Goal result', objective_progress: 'Goal progress', objective_importance: 'Goal importance', objective_year: 'Goal year', objective_context: 'Goal context', metadata: 'Metadata', history: 'Historical context excluded from answers', ignore: 'Ignored field' },
        },
        WORKFLOW_STEP_UPLOAD: 'Step 1 · Upload',
        WORKFLOW_STEP_PROCESS: 'Step 2 · Processing',
        WORKFLOW_STEP_REVIEW: 'Review',
        PAGE_TITLE: 'Review imported interviews',
        PAGE_SUBTITLE: 'Import PDF or Excel files, review spreadsheet layouts and extracted drafts, then validate completed interviews.',
        REVIEW_WAITING_TITLE: 'File analysis finished',
        REVIEW_WAITING_HELP: 'Review the preview to create interview drafts. No drafts have been created yet.',
        REVIEW_CORRECTION_TITLE: 'The import needs a correction',
        REVIEW_CORRECTION_HELP: 'No interview drafts have been created yet. Review the files marked "Correction needed" before continuing.',
        REVIEW_SOURCE_BUTTON: 'Review import',
        REVIEW_SOURCE_HELP: 'Check the preview before creating interview drafts.',
        REVIEW_SOURCES_HELP: 'Review each file using the cards below.',
        REVIEW_DETECTED_COUNT: '{{count}} interview records detected in the preview',
        REVIEW_DIAGNOSTIC_DETAILS: 'Technical details',
        REVIEW_READY_STATUS: 'Review needed',
        REVIEW_CORRECTION_STATUS: 'Correction needed',
        REVIEW_SOURCE_CORRECTION_HELP: 'Draft creation is blocked for this file. Review the preview or retry the analysis.',
        REVIEW_SOURCE_FAILED_HELP: 'File analysis failed. Retry the analysis to continue.',
        REVIEW_SOURCE_DIAGNOSTIC_HELP: 'A problem was detected in this file. Check the details below.',
        REVIEW_SOURCE_PROCESSING_HELP: 'Wait for file analysis to finish before reviewing the preview.',
        REVIEW_PAGE_HELP: 'Review every private interview draft, complete missing information, then explicitly import your selection. File preparation never imports real interviews.',
        REVIEW_ADD_FILES: 'Add files',
        REVIEW_UPLOAD_HELP: 'Choose a campaign and files to prepare private drafts. Review and explicitly import selected interviews later; this step creates no real interviews.',
        REVIEW_READY_TO_IMPORT: 'Ready to import',
        REVIEW_IMPORTED: 'Imported',
        REVIEW_IMPORTED_WITH_WARNINGS: 'Imported with warnings',
        REVIEW_IMPORT_FAILED: 'Import failed',
        ANALYSIS_QUEUED: 'Awaiting analysis',
        ANALYSIS_FAILED: 'Analysis / draft preparation failed',
        ANALYSIS_QUEUE_HELP: 'Drafts are being loaded or analysed in the background. Their statuses update automatically. No interview is imported at this stage.',
        REVIEW_TABLE_TITLE: 'Business review',
        REVIEW_TABLE_CAPTION: 'All interview drafts in this batch, including those still processing and already imported.',
        REVIEW_PRIVATE_HELP: 'Prepared drafts remain private until you import them. Open an interview to read its content, correct details and explicitly review its objectives.',
        VISIBILITY_TITLE: 'Visibility after import',
        VISIBILITY_MANAGER_ONLY: 'Manager only',
        VISIBILITY_MANAGER_COLLABORATOR: 'Manager and collaborator',
        VISIBILITY_HELP: 'Saved for this batch and applied when its interviews are confirmed. Drafts stay private. Already imported interviews are not changed.',
        VISIBILITY_NOT_SAVED: 'The server did not confirm the selected batch visibility. Manager-only visibility is used until the saved setting can be loaded.',
        VISIBILITY_CONFIRM: 'Visibility after import: {{visibility}}.',
        VISIBILITY_CHANGED: 'Visibility changed while the confirmation was open. Review the choice and confirm the import again.',
        REVIEW_PREPARED_STATUS: 'Private drafts prepared',
        REVIEW_PRIVATE_COUNT: '{{count}} private drafts generated. Preparation is not final approval.',
        REVIEW_SOURCE_SUMMARY_HELP: 'File preparation and exceptions only. Review actual interviews in the table below.',
        REVIEW_SOURCE_ADVANCED: 'Advanced file actions',
        REVIEW_SOURCE_ROLES_HELP: 'The main interview list defines the interviews. Supporting sheets add content to those interviews; they do not create extra interviews. Shared headers supply labels only.',
        REVIEW_ROLE_PRIMARY: 'Main interview list',
        REVIEW_ROLE_IGNORED: 'Excluded from preparation',
        REVIEW_ROLE_SUPPORTING: 'Supporting content',
        REVIEW_ROLE_LEGACY: 'No explicit sheet role (legacy interpretation)',
        REVIEW_LEGACY_MAPPING: 'This file uses the earlier confirmed interpretation. Its existing drafts remain available; automatic interpretation reset is not supported.',
        REVIEW_SOURCE_SAMPLE: 'File sample (at most 3 records, not the review list)',
        REVIEW_RESET_TITLE: 'Change file interpretation',
        REVIEW_RESET_ACTION: 'Change file interpretation',
        REVIEW_RESET_CONFIRM: 'This discards ALL unimported private drafts generated from this file and ALL edits made to them. No real interviews are deleted. You must choose the main interview list again. This is blocked if any child is already imported or importing. Continue?',
        REVIEW_RESET_ERROR: 'Unable to reset this file. Refresh its state before trying again.',
        REVIEW_SELECTION: 'Selection',
        REVIEW_ACTION: 'Action',
        REVIEW_SELECT_ROW: 'Select interview for {{name}}',
        REVIEW_SELECTED_COUNT: '{{count}} interviews selected',
        REVIEW_SELECT_READY: 'Select only ready interviews',
        REVIEW_CLEAR_SELECTION: 'Clear selection',
        REVIEW_OPEN: 'Open review',
        REVIEW_COMPLETE_MISSING: 'Complete missing information',
        REVIEW_DEFAULTS_HELP: 'Scope: the {{count}} selected interviews only. Only empty values on private, nonprocessing drafts are filled. Existing values, employees, objectives and extracted text are never overwritten.',
        REVIEW_LEAVE_UNCHANGED: 'Leave unchanged',
        REVIEW_FILL_NOTIFICATIONS: 'Fill missing notification settings only (preserve existing preferences)',
        REVIEW_AFFECTED_COUNT: '{{count}} selected drafts will receive the provided missing values.',
        REVIEW_DEFAULTS_BLOCKED: 'If provided, check the notice (1 to 12 months), and refresh drafts without a current version.',
        REVIEW_CANCEL_DEFAULTS: 'Cancel and clear defaults',
        REVIEW_APPLY_DEFAULTS: 'Save missing information',
        REVIEW_DEFAULTS_ERROR: 'These missing values could not be saved. Review this draft before retrying.',
        REVIEW_DEFAULTS_PARTIAL: '{{count}} drafts could not be updated. Successful updates are kept; review the row errors before retrying.',
        REVIEW_DEFAULTS_SUCCESS: 'Missing information saved on {{count}} drafts. No interviews were imported.',
        REVIEW_DEFAULTS_PROGRESS: 'Saving missing information: {{completed}} / {{total}} complete, {{success}} saved, {{failed}} failed.',
        REVIEW_IMPORT_PROGRESS: 'Import: {{completed}} / {{total}} complete, {{success}} imported, {{failed}} failed.',
        REVIEW_JOB_QUEUED: 'Queued',
        REVIEW_JOB_RUNNING: 'In progress',
        REVIEW_JOB_SUCCESS: 'Completed',
        REVIEW_JOB_FAILED: 'Failed; review before retrying',
        REVIEW_CALENDAR_WARNINGS: '{{count}} imported interviews have calendar delivery warnings. These are not import failures; do not import them again.',
        REVIEW_NAVIGATION_WARNING: 'The selected queue continues if you navigate within the application. Keep this browser tab open until all jobs finish; closing or reloading it can interrupt unsent jobs.',
        REVIEW_SELECTION_BLOCKED: 'Nothing will be imported while any selected interview is not ready, has blocking errors, is missing, or lacks a current version. Correct or refresh these rows, deselect them, or use "Select only ready interviews".',
        REVIEW_FINAL_ACK: 'I reviewed the {{count}} selected interviews and their objectives. I understand that import creates completed historical interviews without requesting signatures or sending participant emails, planning notifications or calendar invitations.',
        REVIEW_IMPORT_SELECTED: 'Import selected interviews ({{count}})',
        REVIEW_IMPORT_ONE: 'Import this interview',
        REVIEW_IMPORT_ONE_BLOCKED: 'This interview must be ready and up to date, with no blocking errors. Open its review to complete any missing checks.',
        REVIEW_IMPORT_ONE_CONFIRM: 'By confirming, you acknowledge that you have reviewed this interview and its objectives. Only this interview will be imported as a completed historical interview, without requesting signatures or sending participant emails, planning notifications or calendar invitations. Other selected interviews will not be imported.',
        REVIEW_IMPORT_ERROR: 'This interview was not imported. Review its current state before retrying.',
        REVIEW_PARTIAL_FAILURE: '{{count}} interviews could not be imported and remain selected for review and retry. Successful imports will not be repeated.',
        REVIEW_IMPORT_SUCCESS: '{{count}} selected interviews imported.',
        REVIEW_REFRESH_REQUIRED: 'This draft has no current version. Refresh or reopen its review before saving or importing.',
        REVIEW_STALE_ERROR: 'The draft changed or is no longer editable. Refresh and review its latest state before retrying. Your request was not applied.',
        REVIEW_MISSING_ERROR: 'This draft no longer exists or is unavailable. Refresh the list and review your selection.',
        IMPORT_BUTTON: 'Import interviews',
        CREATE_TITLE: 'Import interview files',
        HISTORICAL_IMPORT_NOTICE: 'PDF and Excel imports create historical interviews silently: no planning notifications or calendar invitations are sent. Time and notice months are optional; leave them blank when unknown.',
        CREATE_HELP: 'Select a campaign, add fallback details, then upload your files. Excel layouts require review before interview drafts are created.',
        CAMPAIGN: 'Campaign',
        SELECT_CAMPAIGN: 'Select a campaign',
        DEFAULT_MANAGER: 'Default manager',
        DEFAULT_DATE: 'Default date',
        DEFAULT_TIME: 'Default time (optional)',
        DEFAULT_TIME_HELP: 'Used only when the imported interview has no time. Leave blank if unknown; no time is assumed.',
        NOTICE_MONTHS: 'Notice in months (optional)',
        LOCATION: 'Location',
        LOCATION_ONSITE: 'On site',
        LOCATION_REMOTE: 'Remote',
        // Historical imports can now represent interviews completed through a form.
        LOCATION_FORM: 'Form',
        INTERVIEW_LINK: 'Video link',
        FILES: 'PDF or Excel files',
        FILES_HELP: 'Select text PDF, XLS or XLSX source files. Uploads are queued, with three files uploaded at a time. Excel files: maximum 25 MiB each. Processing can continue after you leave this page.',
        ACCEPTED_FILES_ONLY: 'Only PDF, XLS and XLSX files are accepted.',
        SPREADSHEET_SIZE_ERROR: 'Excel files larger than 25 MiB were not added.',
        MAX_FILES: 'Some files could not be added.',
        SELECT_CAMPAIGN_AND_FILES: 'Select a campaign and at least one PDF or Excel file.',
        UPLOAD_ERROR: 'Error while uploading the file.',
        UPLOAD_MISSING_PATH: 'Uploaded document path is missing.',
        BATCH_CREATED: 'Import batch created. Processing is running.',
        BATCH_CREATE_ERROR: 'Error while creating the import batch.',
        LOAD_CAMPAIGNS_ERROR: 'Error loading campaigns.',
        CREATE_BATCH: 'Create import batch',
        FILES_START_HELP: 'Click "{{action}}" to start uploading the selected files.',
        PROGRESS_TITLE: 'Progress',
        PROGRESS_IDLE: 'No processing is running.',
        PROGRESS_RUNNING: 'Extraction and analysis are running. You can wait on this page.',
        PROGRESS_DONE: 'Processing completed.',
        PROGRESS_SUMMARY: '{{processed}}/{{total}} interviews processed · {{ready}} ready · {{review}} to review',
        VALIDATE_READY: 'Validate ready ({{count}})',
        VALIDATE_READY_SUCCESS: 'Ready drafts have been validated.',
        VALIDATE_READY_ERROR: 'Error validating ready drafts.',
        BATCH_SELECTOR: 'Import batch',
        BATCH_CREATED_AT: 'Created {{date}}',
        NO_BATCH: 'No import batch for this selection.',
        DRAFTS_TITLE: 'Imported drafts',
        DRAFTS_COUNT_SUFFIX: 'drafts',
        REFRESH: 'Refresh',
        NO_DRAFTS: 'No imported draft.',
        NO_DRAFTS_HELP: 'Create an import batch to start reviewing extracted interviews.',
        EMPTY_SELECT_TITLE: 'Start with a campaign',
        EMPTY_SELECT_HELP: 'Select a campaign above or open the import modal to upload PDF or Excel interview files.',
        VIEW_PDF: 'View PDF',
        REVIEW_EDIT: 'Review / edit',
        RETRY: 'Retry',
        RETRY_STARTED: 'Retry started.',
        RETRY_VALIDATION: 'Retry validation',
        RETRY_ERROR: 'Error while retrying.',
        VALIDATE: 'Validate',
        VALIDATE_SUCCESS: 'Draft validated successfully.',
        VALIDATE_ERROR: 'Error validating draft.',
        DRAFT_NEEDS_REVIEW: 'This draft still needs review before validation.',
        DELETE_TITLE: 'Delete imported draft',
        DELETE_BATCH_TITLE: 'Delete import batch',
        DELETE_BATCH_CONFIRM: 'Delete this import batch and all its remaining drafts? Already imported interviews and their objectives remain unchanged. Source evidence needed for their reports is retained internally.',
        DELETE_BATCH_SUCCESS: 'Import batch and remaining drafts deleted. Imported interviews are unchanged.',
        DELETE_BATCH_BUSY: 'This batch is being processed. Wait for extraction or import to finish, then try again.',
        DELETE_BATCH_ERROR: 'Unable to delete the import batch. Refresh and try again.',
        DELETE_CONFIRM: 'Do you really want to delete this imported draft?',
        DELETE_SUCCESS: 'Draft deleted successfully.',
        DELETE_ERROR: 'Error deleting draft.',
        FILE_STATUS: {
          PENDING: 'Ready to upload',
          QUEUED: 'Queued for upload',
          UPLOADING: 'Uploading',
          UPLOADED: 'Uploaded',
          FAILED: 'Failed',
        },
        COUNTS: {
          SOURCES: 'Source files',
          MAPPING: 'Layouts to review',
          TOTAL: 'Interviews',
          PROCESSED: 'Processed',
          READY: 'Ready',
          FAILED: 'Failed',
          VALIDATED: 'Validated',
        },
        BULK_AUTOMATION: {
          TITLE: 'Process this batch',
          HELP: 'Review the source files first, then handle interviews together. No interview is imported automatically.',
          VISIBLE_COUNT: '{{visible}} of {{total}} interviews visible',
          FILTERS: 'Filter interviews in the active batch',
          FILTER_all: 'All',
          FILTER_ready: 'Ready',
          FILTER_needsReview: 'Needs review',
          FILTER_failed: 'Failed',
          FILTER_missingEmployee: 'Missing employee',
          FILTER_missingManager: 'Missing manager',
          FILTER_objectives: 'Objectives to review',
          FILTER_missingPlanning: 'Missing planning',
          FILTER_converted: 'Imported',
          SEARCH: 'Search employee or manager',
          SCOPE_SELECTED: 'Scope: {{count}} selected interviews in this batch, including hidden selections.',
          SCOPE_VISIBLE: 'Scope: {{count}} visible interviews in this batch only.',
          SELECTED_COUNT: '{{count}} selected, including {{hidden}} hidden by filters',
          SELECT_VISIBLE: 'Select all eligible visible ({{count}})',
          SELECT_ALL: 'Select visible',
          CLEAR_SELECTION: 'Clear {{count}} selections ({{hidden}} hidden)',
          IMPORT_READY_COUNT: 'Import all ready visible ({{count}})',
          ACCEPT_COUNT: 'Accept objective policy ({{count}})',
          RETRY_FAILED_COUNT: 'Retry failed ({{count}})',
          RETRY_ALL_COUNT: 'Retry all eligible ({{count}})',
          REMATCH_COUNT: 'Match missing users again ({{count}})',
          FILL_PLANNING: 'Select missing planning and fill defaults',
          WAIT_STABLE: 'Bulk actions become available when the active batch has finished loading and processing. Review source files separately.',
          NO_MATCH: 'No interviews match these filters. Hidden selections are retained.',
          EXCEPTIONS: 'Correct missing users in groups ({{count}})',
          GROUP_HELP: 'Only empty assignments are filled. Employees are grouped only with the same original employee number or email and identity; otherwise they stay separate. Manager-name groups require your explicit assignment. Review ambiguous records individually. No account is created.',
          GROUP_employee: 'Employee from source',
          GROUP_manager: 'Manager from source',
          GROUP_COUNT: '{{count}} missing assignments in this scope',
          GROUP_RECORDS: 'Review affected interviews individually',
          CHOOSE_EXISTING: 'Choose an existing user',
          ASSIGN_COUNT: 'Assign to {{count}} missing records',
          ACTION_acceptObjectives: 'Accept objective policy',
          ACTION_importReady: 'Import all ready visible interviews',
          ACTION_retryFailed: 'Retry failed interviews',
          ACTION_retryAll: 'Retry all eligible interviews',
          ACTION_rematch: 'Match missing users again',
          ACTION_assignEmployee: 'Assign missing employees',
          ACTION_assignManager: 'Assign missing managers',
          SNAPSHOT_HELP: 'This confirmation applies only to the listed count and current saved versions. Changes to the batch, filters, selection or sharing require a new confirmation.',
          POLICY_HELP: 'Accept source objectives and available AI-inferred objective formulations together, once for this selection. Existing human choices and exclusions are preserved. This uses cached analysis, not a new AI request, and does not import interviews.',
          POLICY_PRIVATE: 'Source and AI-origin labels remain private to this review. They are not added to the public interview report.',
          POLICY_FACTS: 'Original dates, source wording and known results are preserved. Missing results stay unknown; no achievement or percentage is invented. Phase and year contradictions remain visible as nonblocking warnings after confirmation. Current confirmed instructions govern period classification; unresolved periods and historical assessments stay in the report, not the Objectives menu. Source-integrity and acceptance checks still apply.',
          ASSESSED_YEAR: 'Default assessed year (optional)',
          PLANNED_YEAR: 'Default planned year (optional)',
          YEAR_HELP: 'Four-digit years fill unknown classification years only, for objectives whose assessed or planned phase is known. Explicit source years and deadlines are never changed; the scheduled interview date is not used.',
          IMPORT_HELP: 'Import only the ready interviews visible when this dialog opened. Hidden selections, incomplete records and already imported interviews are excluded. This is final approval, separate from objective policy acceptance.',
          MAIL_HELP: 'Historical imports send no planning notifications or calendar invitations, regardless of any previously saved notification preference.',
          RETRY_HELP: 'Ready, needs-review and cached failed drafts are rechecked without AI. Only genuinely failed drafts without cached analysis restart extraction and may use AI credits. Saved assignments, planning and human edits are preserved. Active work, source files and converted interviews are excluded; resume a failed converted interview using its existing Import action.',
          REMATCH_HELP: 'Try matching missing employees and managers against existing users again, without AI. Existing assignments are never overwritten. Ambiguous or unmatched identities remain available for manual correction.',
          ASSIGN_HELP: 'Assign {{name}} to {{count}} empty assignments. Existing assignments are not changed. Confirm that these original identities refer to the intended user.',
          AI_CREDITS_ACK: 'I authorize restarting analysis for {{count}} failed interviews without a usable cache and understand this may consume AI credits.',
          CONFIRM_ACK: 'I confirm this action for these {{count}} interviews.',
          PROGRESS: '{{completed}} / {{total}} processed: {{success}} successful, {{failed}} failed, {{skipped}} skipped or unresolved',
          SKIPPED: 'Skipped or still needs correction',
          MATCH_UNRESOLVED: 'Some users could not be matched uniquely. Choose an existing user or review this interview.',
          POLICY_UNRESOLVED: 'The policy was applied but some objectives still require individual review. This interview has not been approved for import.',
          COMPLETE: 'Batch action completed. Review the updated statuses before importing.',
          PARTIAL: '{{count}} interviews were skipped or could not be completed. Other records were processed; selections are retained for correction.',
          ERROR: 'This interview could not be processed. Refresh and review its details before retrying.',
          ERROR_INTERVIEW_IMPORT_CONFLICT: 'This interview changed or is being processed. Refresh before retrying.',
          ERROR_INTERVIEW_IMPORT_NOT_ELIGIBLE: 'This interview is no longer eligible for this action.',
          ERROR_INTERVIEW_IMPORT_ANALYSIS_REQUIRED: 'Cached analysis is unavailable. A separate, explicitly confirmed analysis retry is required.',
        },
        OBJECTIVE_BADGE: {
          SELECTED_ONE: '1 selected',
          SELECTED: '{{count}} selected',
          SELECTED_DETAIL_ONE: '1 selected for import',
          SELECTED_DETAIL: '{{count}} selected for import',
          SUGGESTIONS_REVIEW_ONE: '1 suggestion to review',
          SUGGESTIONS_REVIEW: '{{count}} suggestions to review',
          SUGGESTIONS_AVAILABLE_ONE: '+1 suggestion available',
          SUGGESTIONS_AVAILABLE: '+{{count}} suggestions available',
          SUGGESTIONS_HELP: 'These suggestions are not included in the selected import list.',
          REVIEW: 'Review needed',
          VERIFIED: 'Reviewed',
          VERIFIED_ONE: 'Reviewed',
          WITHOUT: 'No objectives selected',
          CONFIRMED: 'Confirmed',
          NONE: 'No objectives detected',
          ANALYZE: 'Awaiting analysis',
          SOURCE_REVIEW: 'Check source',
        },
        TABLE: {
          STATUS: 'Status',
          FILE: 'File',
          COLLABORATOR: 'Collaborator',
          MANAGER: 'Manager',
          DATE: 'Date',
          CONFIDENCE: 'Confidence',
          OBJECTIVES: 'Objectives',
          ERRORS: 'Alerts',
          ACTIONS: 'Actions',
        },
        STATUS: {
          AWAITING_MAPPING: 'Awaiting your review',
          MAPPED: 'Interview drafts generated',
          UPLOADED: 'Uploaded',
          PROCESSING: 'Processing',
          QUEUED: 'Awaiting analysis',
          ANALYSING: 'AI analysis',
          PREPARING: 'Preparing drafts',
          COMPLETED: 'Completed',
          COMPLETED_WITH_ERRORS: 'Completed with errors',
          EXTRACTING_TEXT: 'Extracting text',
          ANALYZING: 'AI analysis',
          NEEDS_REVIEW: 'Needs review',
          READY: 'Ready',
          VALIDATING: 'Validating',
          VALIDATED: 'Validated',
          VALIDATED_WITH_WARNINGS: 'Validated with warnings',
          FAILED: 'Failed',
          FAILED_VALIDATION: 'Validation failed',
          DELETED: 'Deleted',
          UNKNOWN: 'Unknown',
        },
        WARNING: {
          MISSING_CAMPAIGN: 'Campaign is required.',
          INTERVIEW_SPREADSHEET_FONT: 'The individual PDF could not be generated. Your source answers are preserved. Retry preparation after the rendering issue is corrected.',
          INTERVIEW_MAPPING_INPUT_LIMIT: 'The complete workbook exceeds the AI analysis limit. Analysis was stopped without shortening the source. Split it into smaller workbooks and try again.',
          INTERVIEW_IMPORT_AI_INPUT_LIMIT: 'The complete interview exceeds the AI analysis limit. No partial text was sent. Use a smaller source document and try again.',
          INTERVIEW_IMPORT_AI_CONTEXT_UNAVAILABLE: 'The complete questions and source context are unavailable for this older draft. Recheck workbook preparation before retrying; no partial analysis was performed.',
          MISSING_INTERVIEW_TYPE: 'Campaign interview type is required.',
          MISSING_EMPLOYEE: 'Collaborator must be selected.',
          MISSING_MANAGER: 'Manager must be selected.',
          MISSING_INTERVIEW_DATE: 'Interview date is required.',
          MISSING_INTERVIEW_TIME: 'Interview time is required.',
          MISSING_NOTICE_MONTHS: 'Notice in months is required.',
          INVALID_INTERVIEW_TIME: 'Enter a valid interview time, or leave it blank if unknown.',
          INVALID_NOTICE_MONTHS: 'Enter a positive whole number of notice months, or leave it blank if unknown.',
          MISSING_DOCUMENT: 'Uploaded PDF document is required.',
          MISSING_EXTRACTED_TEXT: 'Extracted interview text is required.',
          MISSING_DOC_HTML: 'Generated interview HTML is required.',
          MISSING_WORKFLOW: 'Generated workflow is required.',
          OBJECTIVES_NOT_REVIEWED: 'Objectives must be reviewed before validation.',
          EXCEL_INSTRUCTION_ANALYSIS_STALE: 'The interview analysis is missing or no longer matches the current workbook instructions. Rerun the draft analysis before importing.',
          SPREADSHEET_ARTIFACT: 'The individual interview document is missing or no longer matches the current source text. It must be regenerated before importing.',
          OBJECTIVE_CLASSIFICATION_STALE: 'The objective classification can no longer be verified against the current selection and source. Review the objectives and save the draft to recalculate it before confirming.',
          OBJECTIVE_ACCEPTANCE_REQUIRED: 'The current objective classification has not been accepted. Review the selected objectives, resolve any blockers, then confirm the list and save the draft.',
          OBJECTIVE_SOURCE_STALE: 'A selected objective can no longer be verified against its source. Review its source association before confirming; its title alone is not proof of a match.',
          OBJECTIVE_PHASE_CONFLICT: 'Nonblocking warning: the source wording and interpretation disagree on whether this objective is assessed or planned. Review the applied period; current confirmed instructions govern its classification. This warning does not prevent interview import after confirmation, and the original wording is retained.',
          OBJECTIVE_YEAR_CONFLICT: 'Nonblocking warning: source years disagree with each other or with the current confirmed instructions. Review the applied year without rewriting the source text or deadlines. This warning does not prevent interview import after confirmation.',
          OBJECTIVE_PERIOD_MULTIPLE_YEARS: 'Several years appear in the source. Review the applied classification year. An unresolved year stays in the report only, without creating an Objectives menu item; this warning does not block interview import after confirmation.',
          OBJECTIVE_PERIOD_UNKNOWN: 'The objective period is not fully established. If its phase or year remains unknown, it stays in the report only, not the Objectives menu. Interview import remains possible after confirmation.',
          OBJECTIVE_PLANNING_AMBIGUOUS: 'The source does not clearly distinguish a planned objective from historical context. Review the applied period; an unresolved phase or year stays report-only. This warning does not block interview import after confirmation.',
          OBJECTIVE_HISTORY_ONLY: 'Some assessed objectives or objectives without an established period remain in the interview report only, without creation in the Objectives menu. This does not prevent interview import after confirmation.',
          INTERVIEW_INTERPRETATION_STALE: 'The workbook interpretation is missing or no longer matches the source. Review the workbook preparation before retrying.',
          AMBIGUOUS_INTERVIEW_DATE: 'The extracted interview date is ambiguous. Please verify the date before validation.',
          SHORT_TEXT: 'The PDF may be scanned or unreadable.',
          EMPLOYEE_MATCH: 'Collaborator match needs review.',
          MANAGER_MATCH: 'Manager match needs review.',
          PROCESSING_ERROR: 'Source analysis or draft preparation failed.',
          INSUFFICIENT_AI_CREDITS: 'Insufficient AI credits to analyze this file.',
          OBJECTIVE_IMPORT_FAILED: 'Objective import failed.',
          CONVERSION_FAILED: 'Import validation failed.',
          FAILED: 'Draft analysis or preparation failed.',
          DIAGNOSTIC_CODE: 'Diagnostic code: {{code}}.',
          FAILED_VALIDATION: 'Validation failed.',
          AI_WARNING: 'The AI analysis reported a point to review. Check the preview and make sure all expected answers are included before importing. This warning alone does not mean the analysis failed.',
          INTERVIEW_OBJECTIVE_GUIDANCE_EVIDENCE: 'The guided objective analysis could not verify its source evidence. This is a draft-analysis failure, not a final-import failure.',
          INTERVIEW_INTERPRETATION_DELIVERY_UNAVAILABLE: 'A usable interview document could not be prepared from the retained source content. Review the source and its interpretation; no final import was performed by this preparation step.',
        },
        OBJECTIVE_EVIDENCE_REASON: {
          evidence_list_invalid: 'The proposal did not provide a valid list of source citations.',
          citation_shape_invalid: 'A source citation has an invalid structure.',
          citation_ref_invalid: 'A source cell reference is invalid.',
          citation_part_invalid: 'The citation refers to an unsupported part of the source.',
          citation_quote_invalid: 'A cited passage is empty or exceeds the supported size.',
          source_ref_unavailable: 'The cited cell is not available within this interview’s validated source.',
          source_part_unavailable: 'The cited heading, question or value is unavailable at that reference.',
          quote_not_in_source: 'The cited passage could not be found in the referenced source text.',
          duplicate_citation: 'The proposal repeated a source citation.',
          source_value_required: 'A source answer is required; a heading or date alone cannot establish the objective.',
          fact_shape_invalid: 'A proposed KPI, deadline or year has an invalid structure.',
          fact_part_invalid: 'The proposed fact uses an unsupported source component.',
          fact_value_unsupported: 'The proposed KPI, deadline or year is not supported by its cited passage.',
          fact_value_ambiguous: 'The cited source does not identify one unambiguous value for this fact.',
          year_not_in_source: 'The proposed source year is not present in the cited evidence.',
        },
        SPREADSHEET: {
          DUPLICATE_MATCHING: {
            TITLE: 'Match answers to duplicate interviews',
            HELP: 'Several interviews belong to the same employee. Review the interview assigned to each answer block and change the choices if needed. Previously saved associations are preserved.',
            ORDER_SUGGESTION: 'Suggested associations: review required. When the counts match, answer blocks are suggested in the same order as the employee’s interviews. Order is not proof: check the managers and answers. Unmatched cases receive no automatic choice.',
            CONFIRM: 'I have reviewed these associations and corrected the choices where needed.',
            CONFIRM_HELP: 'Review the associations and tick the confirmation before saving them.',
            GROUP: 'Duplicate group {{number}}',
            SELECT_LABEL: 'Assign this answer block to',
            PLACEHOLDER: 'Choose an interview',
            CHOICE: 'Manager: {{manager}} | Employee: {{employee}} | Main sheet {{sheet}}, row {{row}}',
            CONFLICT: 'Within this duplicate group, two blocks from the same sheet cannot be assigned to the same interview.',
            INCOMPLETE: 'Choose an interview for every answer block, without assigning two blocks from the same sheet to the same interview.',
            SAVE_HELP: 'Save these associations to refresh the preview, then continue the usual review before preparing drafts.',
            SAVE: 'Save associations and preview',
            LOAD: 'Load duplicate answer blocks',
          },
          SIMPLE_TITLE: 'Review the Excel import',
          SIMPLE_HELP: 'Check the detected interviews, then prepare their private drafts. Question-label review is optional without instructions.',
          SIMPLE_COUNT: 'interviews detected',
          SIMPLE_COUNT_UNCONFIRMED: 'proposed interviews to check',
          SIMPLE_IDENTITIES: 'distinct identities in the file',
          SIMPLE_NOT_CREATED: 'This step only prepares private drafts. No real interview is created until the final import on the main page.',
          PRIMARY_LISTS: 'Main interview lists',
          SUPPORTING_COUNT: '{{count}} supporting sheet(s) add details, not extra interviews.',
          PRIMARY_CHOICE_TITLE: 'Which sheet lists the interviews?',
          PRIMARY_CHOICE_HELP: 'Choose the sheet that defines the interviews, not a list of objectives or training details. The file will be analyzed again using your choice without changing other settings here.',
          PRIMARY_CHOICE_PLACEHOLDER: 'Choose a sheet from this file',
          PRIMARY_CHOICE_ACTION: 'Analyze using this interview list',
          LEGACY_ROLE_UPGRADE: 'This older analysis does not distinguish main interviews from supporting details. Choose the main list and analyze again before private drafts can be prepared.',
          SUPPORTING_CORRECTION_HELP: 'Some details cannot be linked to one interview. Clarify which sheet lists the interviews and which identifier links them in the instructions, then analyse again. No details will be assigned by guessing.',
          ROLE: 'Sheet purpose',
          ROLES: { primary: 'Main interviews', supporting: 'Supporting details', unresolved: 'Not determined' },
          SHEET_TITLE_REF: 'Title',
          PREPARE_SUCCESS: 'Private drafts prepared. Review and correct them before the final import.',
          SIMPLE_ISSUE_TITLE: 'A check is needed before continuing',
          SIMPLE_ISSUE_FIELD: 'Some information conflicts. Clarify how to read it in the instructions, then analyse again.',
          SIMPLE_ISSUE_IDENTITY: 'Some interviews cannot be reliably assigned. Clarify the employee identifier and interview grouping in the instructions, then analyse again.',
          SIMPLE_ISSUE_MAPPING: 'The file analysis needs another check. Clarify your instructions if needed, then analyse again.',
          SIMPLE_CORRECT: 'Review the issue',
          SIMPLE_RETRY: 'Retry analysis',
          SIMPLE_DIAGNOSTIC_DETAILS: 'Show technical details',
          SIMPLE_HEADERS_TITLE: 'Check detected questions',
          COMPACT_HEADERS_COUNT: '{{count}} texts · {{sheets}} sheets',
          COMPACT_HEADERS_SHEETS: 'Applies to these sheets',
          COMPACT_HEADERS_DETAILS: 'Read all {{count}} questions and labels',
          COMPACT_HEADERS_HIDE_DETAILS: 'Show examples only',
          HEADERS_EXPAND_FIRST: 'Open the complete list of questions before confirming.',
          OPTIONAL_HEADER_REVIEW: 'Optional',
          OPTIONAL_HEADER_REVIEW_HELP: 'This optional check controls how questions are displayed in the report. The AI receives the complete source text even before this check.',
          HEADER_CHECK: {
            TITLE: 'Review the detected questions',
            SUMMARY: '{{answers}} answers across {{affected}} of {{total}} interviews need their question labels confirmed.',
            HELP: 'Review the shared questions once for this file, not once per employee. Without confirmation, the associated answers would be missing from the reports.',
            EXAMPLE: 'Answer example from interview {{number}}',
            ALL_CHECKED: 'All {{count}} interviews were checked. The examples are illustrative; the counts cover the whole file.',
            REVIEW_ALL: 'Review all shared headings and titles ({{count}} sheets)',
            CONFIRM: 'I confirm that all headings and sheet titles in this review are shared labels, not employee-specific answers. This confirms the structure, not the answers.',
            CONFIRM_HELP: 'Open the complete heading list, review it, then confirm once for the file. Empty placeholder headings are available only in technical details.',
            PREPARE: 'Confirm and prepare drafts',
            REQUIRED: 'Some answers still need their question labels reviewed. Refresh the preview and resolve the highlighted issues before preparing drafts.',
            REFRESH: 'Refresh the preview to check all interviews for missing question labels. No extra approval is needed if the check finds no affected answers.',
            UNRESOLVED: 'Some populated answers have no usable question label. Correct the source headings or clarify their association in the import instructions before preparing drafts.',
            UNRESOLVED_COUNT: '{{count}} populated answers have no usable question label. Header approval cannot fix them. Correct the source headings or clarify their association in the import instructions.',
            CHANGED: 'The refreshed result could not be confirmed as unchanged. No drafts were prepared automatically. Refresh and review the latest result before continuing.',
          },
          HEADER_NOTICE_TITLE: 'The question and column labels need your review',
          HEADER_NOTICE_HELP: 'Some question labels have not been confirmed. Their answers may be omitted from the final report even when they appear in the source preview. Review the complete labels for each sheet below, confirm that they contain no individual answers, then recalculate the preview. The original answers are preserved.',
          HEADER_NOTICE_ACTION: 'Review the questions and labels',
          HEADER_NOTICE_REFRESH_TITLE: 'A note about the file’s column labels',
          HEADER_NOTICE_REFRESH_HELP: 'The analysis reported unrecognized column labels, but their review details are not available here. Refresh the preview to check their current review status.',
          SIMPLE_HEADERS_HELP: 'Check that these texts are the file’s questions or headers, rather than answers. This checks the draft structure, not what the AI is allowed to read.',
          SIMPLE_HEADERS_PROGRESS: '{{done}} of {{total}} sheets checked',
          SIMPLE_HEADERS_CONTENT: 'Complete detected questions and titles',
          SIMPLE_HEADERS_ACK: 'These texts are questions or headers, not individual answers.',
          SIMPLE_HEADERS_CONFIRM: 'Confirm and continue',
          NOT_A_HEADING: 'Correct this detection',
          WRONG_LABEL_ORIGIN_HELP: 'Choose the location to correct. No source value will be deleted.',
          WRONG_LABEL_HEADER_ROW: 'Header row shown in this review: {{row}}.',
          WRONG_LABEL_HEADER_HELP: 'Review the selected header row using the source samples below if available. Employee answers must remain interview content, not shared headings. No cell, value or row has been removed. Correct the settings, then check again.',
          WRONG_LABEL_TITLE_HELP: 'This is a worksheet title, not a cell or an A1 reference. Review the appropriate scope and layout for this sheet. If its title contains an employee answer or personal information, correct the source file and analyze it again. This action does not rename the sheet or remove any content.',
          SIMPLE_HEADERS_DONE: 'Questions checked.',
          SIMPLE_HEADERS_NEXT: 'Check the next sheet',
          SIMPLE_CHECKED: 'checked',
          SIMPLE_HEADERS_REOPEN: 'Review again',
          SIMPLE_HEADERS_ALL_DONE: 'Questions checked.',
          SIMPLE_HEADERS_FIRST: 'Continue to prepare the drafts. Without instructions, question-label review is optional.',
          SIMPLE_REFRESH_FIRST: 'Check the detection again after changing settings.',
          SIMPLE_EXAMPLES_TITLE: 'Examples of detected interviews',
          SIMPLE_EXAMPLES_HELP: '{{shown}} examples out of {{total}} interviews. Only the first 3 are sampled here; all private drafts remain available for correction before import.',
          SIMPLE_SELECT_EXAMPLE: 'Choose an interview example',
          SIMPLE_EXAMPLE_NUMBER: 'Example {{number}}',
          SIMPLE_IDENTITY_MISSING: 'Employee to identify',
          SIMPLE_TO_COMPLETE: 'To complete in the draft',
          SIMPLE_VIEW_CONTENT: 'Read the extracted content',
          SIMPLE_SAMPLE_LIMIT: 'Samples show at most the first 3 interviews, not the complete workbook. Counts include all detected interviews.',
          SIMPLE_REPEAT_WARNING: '{{repeatedEmployeeCount}} source identities appear in several interviews. Check that these are genuinely separate interviews, not objective or training rows.',
          SIMPLE_NOTES: '{{count}} notes to review',
          SIMPLE_CONTENT_SCOPE: 'Draft content: {{included}} sheets retained, {{ignored}} not used for interviews',
          SIMPLE_INCLUDED: 'Used',
          SIMPLE_EXCLUDED: 'Not retained in the drafts',
          SIMPLE_SHEET: 'Sheet',
          SIMPLE_ADVANCED: 'Advanced settings',
          SIMPLE_ADVANCED_TITLE: 'Correct the detection settings',
          SIMPLE_ADVANCED_HELP: 'Use these settings only when the detected layout needs correction. Work on one sheet, then refresh the preview.',
          SIMPLE_CLOSE_SETTINGS: 'Back to the review',
          SIMPLE_PREVIEW_NEEDED: 'Continue with the detected structure to prepare private drafts. This does not import interviews.',
          SIMPLE_REVIEW_HEADERS: 'Check questions',
          SIMPLE_CHECKING: 'Checking and preparing...',
          SIMPLE_REFRESH: 'Prepare drafts',
          SIMPLE_CREATE: 'Create {{count}} drafts',
          SIMPLE_FINAL_ACK: 'I have checked the proposed content and notes for these {{count}} drafts.',
          SIMPLE_CREATING: 'Creating drafts...',
          TITLE: 'Review Excel import',
          SOURCES_TITLE: 'Excel files',
          DELETE_SOURCE_TITLE: 'Delete Excel source file',
          DELETE_SOURCE_CONFIRM: 'Delete this source file and its unconfirmed layout? No interview drafts have been generated from it.',
          AWAITING_HELP: 'Review each workbook layout before generating its interview drafts. Source files are not interviews.',
          SOURCE_HELP: 'No source download. Review the layout and server-generated samples to create individual interview PDFs.',
          NO_INTERVIEWS_YET: 'No interview drafts yet. Complete the workbook layout review above.',
          GENERATED_COUNT: '{{count}} interview draft(s) generated. Review them below.',
          REVIEW_LAYOUT: 'Review layout',
          HELP: 'Choose how each sheet becomes interviews, map identity and date fields, then generate a preview. No interviews are created until you explicitly confirm.',
          SHEET_BOUNDS: '{{rows}} rows / {{columns}} columns',
          IDENTITY_SUMMARY: '{{recordCount}} proposed interviews / {{distinctEmployeeCount}} identified collaborators',
          IDENTITY_DETAILS: '{{identifiedRecordCount}} proposed interviews have an employee identifier. These counts come from the mapped source identities, not verified employee matches.',
          REPEATED_EMPLOYEES_WARNING: '{{repeatedEmployeeCount}} collaborators have multiple proposed interviews (up to {{maxRecordsPerEmployee}} per collaborator). Multiple interviews per employee can be legitimate for different dates or periods, but objectives and training history must not be counted as separate interviews. Review the field bindings and grouping before confirming.',
          CONFLICTING_FIELD_HELP: 'Conflicting bindings assign different values to the same field within one interview. Correct the incorrect field binding, then request a new preview. Do not split one interview into separate objectives or training-history interviews just to remove the conflict.',
          CONFLICTING_FIELD_LOCATION: 'sheet "{{sheet}}", cell {{cell}}',
          CONFLICTING_FIELD_BINDINGS: '{{field}}: conflicting bindings from {{first}} and {{second}}.',
          MISSING_INTERVIEW_IDENTITY_HELP: 'Some proposed interviews have no employee identity. Map an employee identifier (employee number, email or name), and group continuation details with their interview. Objectives and training history must not become separate interviews. Do not guess identities; request a new preview after correcting the layout.',
          AMBIGUOUS_INTERVIEW_SEGMENTATION_HELP: 'Employee identities or interview boundaries are ambiguous. Resolve homonyms and conflicting aliases with a source employee number or email before using dates. For the same identified employee, rejoin details of one interview or map the actual date or evaluated period of genuinely separate interviews. Objective and training dates are not interview dates. Nothing is merged automatically; correct the layout and request a new preview.',
          IDENTITY_RECORD_SOURCES: 'Proposed interview {{record}}: {{sources}}.',
          INVALID_JOIN_MODE_HELP: 'Joined main lists must use rows or grouped mode with a complete ordered interview key. Supporting sheets must use grouped mode. Forms remain independent. Review these settings without discarding source details.',
          INVALID_SHEET_ROLE_HELP: 'Each included sheet needs an explicit main-interview or supporting-detail role. Ignored sheets must have no role.',
          ROLE_REQUIRED_HELP: 'Choose which sheets define interviews and which contain supporting details before continuing.',
          PRIMARY_SHEET_REQUIRED_HELP: 'Choose a main interview list. Supporting details cannot create interviews.',
          INVALID_PRIMARY_SHEET_COUNT_HELP: 'Each joined group must have exactly one main interview list. Independent forms may each be a main source.',
          INVALID_SUPPORTING_SHEET_HELP: 'Supporting sheets must use grouped mode and join exactly one main interview list using complete ordered keys.',
          UNMATCHED_SUPPORTING_KEY_HELP: 'Some supporting rows do not match a main interview. Correct the indicated source ranges or complete matching keys; do not discard the rows or create extra interviews.',
          SUPPORTING_IDENTITY_MISMATCH_HELP: 'Supporting details identify a different employee from their main interview. Correct ownership or key references without overwriting identities.',
          DUPLICATE_PRIMARY_KEY_HELP: 'Several main interview rows share a lookup key. Review the complete interview identifier and period while keeping genuinely separate interviews separate.',
          NONCONTIGUOUS_GROUP_KEY_HELP: 'The same employee key reappears in separate answer blocks. Check the main interview list first, then match the duplicate interviews if requested. Do not merge separate interviews or remove answer rows.',
          PRIMARY_SELECTION_MISMATCH_HELP: 'The detected main sheets do not match your choice. Analyze again using the selected interview list or review the sheet roles.',
          INCOMPATIBLE_JOIN_KEYS_SHEETS: 'Sheets {{sheets}} and {{lastSheet}} do not use the same number of join-key columns.',
          INCOMPATIBLE_JOIN_KEYS_FALLBACK: 'Some joined sheets do not use the same number of join-key columns.',
          INCOMPATIBLE_JOIN_KEYS_HELP: 'Review the join-key columns in the layout. Choose the same identifier components, in the same order, across these sheets. Column letters may differ.',
          ORPHAN_CONTINUATION_FALLBACK: 'A row contains data but has no grouping key, so its interview cannot be determined. Review the key-column references, data start row, continuation setting and blank separators in the layout, then request a new preview. Do not guess the employee or carry a key across a blank separator.',
          ORPHAN_CONTINUATION_LOCATION: 'Sheet "{{sheet}}", row {{row}}.',
          ORPHAN_CONTINUATION_ROW: 'Row {{row}}.',
          ORPHAN_CONTINUATION_CONTEXT: 'Grouping-key cells: {{keys}}. Selected data rows: {{start}}-{{end}}.',
          ORPHAN_CONTINUATION_DISABLED: 'This row has data but no grouping key. Continuation rows are disabled; the preceding complete key is on row {{row}}, with no blank separator in between. Review enabling continuation rows only if this row belongs to that preceding interview, then request a new preview. Nothing is enabled automatically.',
          ORPHAN_CONTINUATION_NO_KEY: 'This row has data but no grouping key, and no preceding complete key is available in the selected data range. Check the key-column references and data start row against the source layout. Enabling continuation alone cannot identify the interview; never guess the employee.',
          ORPHAN_CONTINUATION_SEPARATOR: 'This row has data but no grouping key. Blank separator row {{row}} cleared the preceding interview ownership. Check the layout, grouping-key references and row boundaries. Do not carry a key across the separator; enabling continuation alone cannot resolve this row.',
          SHEET_SAMPLES: 'View sheet cell samples',
          SHEET_SAMPLES_HELP: 'These limited cell samples help identify columns and form coordinates. They are not the complete sheet; values and rows may be omitted or shortened.',
          HEADER_REVIEW_TITLE: 'Review shared labels in row {{row}}',
          HEADER_REVIEW_HELP: 'These unrecognized cells would be repeated in every interview from this sheet. Review their complete text. If any cell contains an employee answer or personal information, correct the header row instead of approving it.',
          HEADER_REVIEW_ACK: 'I confirm that these cells are shared question or column labels only, with no employee-specific information. Recalculate the preview after confirming.',
          HEADER_REVIEW_TOO_LARGE: 'The complete questions cannot be reviewed safely. Clarify where the questions are in your instructions and analyse again, or correct the source file. No labels have been approved.',
          PREPARE_BLOCKED: {
            BUSY: 'Please wait for the current operation to finish.',
            ANALYSIS: 'Click “Analyse with these instructions” to retry the file analysis before preparing drafts.',
            HEADERS: 'The detected questions cannot be used safely. Check the source file and analyse it again.',
            PREVIEW: 'Click “Recheck the file” to verify the current file before preparing drafts. This does not use AI.',
            EMPTY: 'No interviews were detected. Check the source file or clarify the interview list in your instructions, then analyse again.',
            INTERPRETATION: 'Tick the interpretation confirmation above before preparing private drafts.',
          },
          HIDDEN_SHEET: 'This sheet is hidden in the workbook. Check whether it should be ignored.',
          MERGES: 'Merged cells',
          MODE: 'Layout mode',
          REASON: 'Layout explanation',
          MODES: { ignore: 'Ignore sheet', rows: 'One interview per row', grouped: 'Group rows by key', form: 'One form per sheet', blocks: 'Repeated fixed-height forms' },
          MODE_HELP: {
            ignore: 'This sheet is explicitly excluded from the import.',
            rows: 'Each data row creates one interview.',
            grouped: 'Rows with matching keys form one interview. Cross-sheet joins must be explicitly configured.',
            form: 'This sheet contains a single interview form.',
            blocks: 'Each fixed-height block contains one interview. References use cells in the first block and shift by the block height.',
          },
          HEADER_ROW: 'Header row (optional)',
          START_ROW: 'First data row (optional)',
          END_ROW: 'Last data row (optional)',
          BLOCK_ROWS: 'Rows per block',
          ROWS_HELP: 'Row numbers start at 1. Start and end rows are inclusive. Leave optional bounds empty to use server defaults.',
          DATE_FORMAT: 'Date order',
          DATE_FORMATS: { dmy: 'Day / Month / Year', mdy: 'Month / Day / Year', ymd: 'Year / Month / Day' },
          JOIN_GROUP: 'Cross-sheet join group (optional)',
          KEY_COLUMNS: 'Key columns, separated by commas',
          KEY_COLUMNS_EXAMPLE: 'A, C',
          CONTINUATION_ROWS: 'Treat blank-key rows as continuation of the preceding interview',
          JOIN_HELP: 'Each joined group needs exactly one main list. Supporting sheets add details only to matching main interviews. Use every interview-key component in the same order across sheets; column letters may differ. Forms remain independent.',
          FIELDS: 'Field mappings',
          TARGET: 'Interview field',
          REFERENCE: 'Source reference',
          COLUMN_REF_HELP: 'Use column letters, for example A or BC. Do not include row numbers.',
          CELL_REF_HELP: 'Use absolute cell locations in the first form, for example B4 or $B$4. Later blocks shift by the configured number of rows.',
          ADD_FIELD: 'Add field mapping',
          REMOVE_FIELD_TITLE: 'Delete field mapping',
          REMOVE_FIELD_CONFIRM: 'Delete this field mapping? A new preview will be required.',
          TARGETS: {
            employeeName: 'Collaborator full name', employeeFirstName: 'Collaborator first name', employeeLastName: 'Collaborator last name',
            employeeEmail: 'Collaborator email', employeeNumber: 'Employee number', managerName: 'Manager full name',
            managerFirstName: 'Manager first name', managerLastName: 'Manager last name', managerEmail: 'Manager email',
            interviewDate: 'Interview date', evaluatedPeriod: 'Evaluated period',
          },
          INVALID_MAPPING: 'Choose explicit sheet roles and at least one main interview source. Each supporting sheet must join exactly one main list. Check row bounds, references, complete keys and block height.',
          REVIEW_ERROR: 'Layout review could not be completed',
          PREVIEW_TITLE: 'Interview preview',
          PREVIEW_REQUIRED: 'Generate a fresh preview. Every layout edit clears the preview and its confirmation.',
          PREVIEW_COUNT: '{{total}} interview(s) in total / {{shown}} sample(s) shown',
          SAMPLES_HELP: 'The server supplies text samples for the first 3 interviews only, not the complete set. Counts include all detected interviews; private preparation does not import real interviews.',
          IGNORED_SHEETS: 'Ignored sheets',
          SOURCE_ROWS: '{{sheet}}: rows {{start}} to {{end}} (inclusive)',
          TRUNCATED: 'Only this on-screen sample is shortened. The original source content remains complete.',
          ACKNOWLEDGEMENT: 'I reviewed the layout, warnings and samples and confirm generation of all {{count}} interview drafts.',
          PREVIEW_ACTION: 'Recheck the file',
          CONFIRM_ACTION: 'Generate interview drafts',
          PREVIEW_SUCCESS: 'Checks updated. Review any remaining labels or corrections before continuing.',
          PREVIEW_ERROR: 'Unable to preview this layout. Check the details and try again.',
          CONFIRM_SUCCESS: 'Interview drafts generated. They can now be reviewed and validated.',
          CONFIRM_ERROR: 'Unable to generate interview drafts. Your layout remains editable. Generate a new preview before confirming again.',
          STALE_PREVIEW: 'The preview or source state has changed. Generate a new preview, or close and refresh the source list.',
          DUPLICATE_WORKBOOK_TITLE: 'File already prepared',
          DUPLICATE_WORKBOOK: 'This file has already been prepared in this campaign. Close this window and return to the existing import batch to review its drafts or previously imported interviews. Preparing this copy again would create duplicates.',
        },
        MODAL: {
          TITLE: 'Review interview draft',
          REVIEW_HELP: 'Complete the information, review the objectives, and consult the original answers without losing your changes.',
          REVIEW_NAVIGATION: 'Interview review sections',
          CORRECTIONS_TITLE: 'Corrections',
          CORRECTIONS_HELP: 'Check the people and planning details below. You can save your progress before everything is complete.',
          PEOPLE_HELP: 'Link each person to an existing account. An extracted name alone does not identify an account.',
          ACCOUNT_SELECTED: 'Account selected',
          ACCOUNT_REQUIRED: 'Account to select',
          PLANNING_HELP: 'Keep the original interview details. Time and notice months are optional and remain unknown when left blank.',
          OBJECTIVES_HELP: 'Review each objective and its details, then explicitly confirm your review.',
          OBJECTIVES_REVIEW_HELP: 'This confirmation is saved with the private draft. Editing an objective clears it.',
          OBJECTIVE_SELECTION: {
            TITLE: 'Objectives to import',
            HELP: 'Choose which objectives to keep, complete your list, then confirm it. Nothing is imported at this step.',
            CREATE: 'Add manually',
            SELECTED_COUNT: 'Selected: {{count}}',
            SELECTED_LABEL: 'in the import list',
            CANDIDATES_LABEL: 'suggestions to add',
            CANDIDATES_TITLE: 'Suggested objectives',
            CANDIDATES_HELP: 'Add useful suggestions to your list above. Suggestions left here will not be imported.',
            SOURCE_BADGE: 'File wording',
            AI_BADGE: 'AI suggestion',
            AI_ADDED_BADGE: 'AI interpretation',
            MANUAL_BADGE: 'Added manually',
            EDITABLE_BADGE: 'Draft values',
            ADD_TO_LIST: 'Add to list',
            REMOVE: 'Remove from list',
            SOURCE_ADD_HELP: 'Adds the original title and comment. Other fields still need review.',
            AI_ADD_HELP: 'Adds only the proposed title, for review. No AI status, progress or comment is copied.',
            READ_SOURCE_COMMENT: 'Read the original comment',
            READ_AI_COMMENT: 'Read the AI proposal (unverified)',
            EMPTY_TITLE: 'Your import list is empty',
            EMPTY_WITH_CANDIDATES: 'Suggestions are available below. Add the ones you want to keep, or create an objective manually.',
            EMPTY_WITHOUT_CANDIDATES: 'You can create an objective manually or confirm an import without objectives. An empty list does not prove the interview contains no aspirations or plans.',
            CONFIRM_LIST: 'I confirm the {{count}} objectives in this list',
            CONFIRM_EMPTY: 'I confirm an import without objectives',
            REVIEW_HELP: 'This confirms only your list. It does not add suggestions or trigger the final import.',
            TITLE_REQUIRED: 'Enter a title for this objective.',
            COMMENT_PLACEHOLDER: 'Optional comment to review or complete.',
            COMPARE_SOURCE: 'Compare with the original text',
            USE_SOURCE_COMMENT: 'Use this original comment',
            AI_DETAILS: 'View the information proposed by AI',
            AI_DETAILS_HELP: 'Unverified information kept separately. The AI comment never replaces your comment.',
            READ_INTERVIEW: 'Read the original interview text',
            REFERENCES_TITLE: 'View the file, references and original proposals',
            PARTIAL_SOURCE: 'Some file rows have no title. Identified objectives remain available.',
            PARTIAL_RESTORE_HELP: 'The source contains incomplete rows. Add identified objectives individually rather than replacing your list with a partial source.',
            SOURCE_NOT_INCLUDED: 'The objective sheet is not included in the verified source. This does not mean there are no objectives; your list remains unchanged.',
            INCOMPLETE_TITLE: 'Source rows to clarify',
            UNLABELLED_FIELD: 'File value',
            DEFAULTS_HELP: 'Supported suggestions may already be selected in this private draft. Remove any you do not want; they return to suggestions and can be added again. Save to keep your choice, then explicitly confirm your review.',
            SELECT_SUPPORTED: 'Select supported suggestions',
            ORIGINAL_PASSAGE: 'Original interview passage',
            CONCRETE_TARGETS: 'Concrete targets in the source',
            NO_TARGETS: 'No concrete target stated in this passage.',
            EVIDENCE_HELP: 'These are original words, not proof of attainment. Your editable values remain separate; no status, year or percentage is inferred.',
            EVIDENCE_UNAVAILABLE: 'Original source passage unavailable or not uniquely matched. Review this idea manually; no citation or result is assumed.',
            USE_SOURCE_PASSAGE: 'Use this original passage as the comment',
          },
          OBJECTIVE_GUIDANCE: {
            OPTIONAL_UNAVAILABLE: 'Additional AI suggestions are unavailable. Objectives from the verified columns remain available and can be reviewed and confirmed.',
            SOURCE_COLUMNS: 'Confirmed columns: {{extractedCount}} objectives extracted out of {{expectedCount}} nonempty title cells. Exceptions to review: {{exceptionCount}}. Original titles and mapped fields are copied without AI selection.',
            TITLE: 'Objective proposals guided by your instructions',
            HELP: 'Review what the analysis proposes to create and what it leaves out. Excluding an objective from creation does not remove its history from the interview report.',
            PROPOSAL_BADGE: 'AI-guided proposal',
            NOT_CURRENT: 'The guided analysis is incomplete or no longer matches this draft. Existing choices are preserved, but cannot be confirmed until the analysis and source are current.',
            SELECTION_ISSUES: 'Some existing choices no longer match an eligible proposal. Correct the selection and save it before confirming it. Your previous choices have not been deleted.',
            YEAR_CONFLICT: 'Nonblocking warning: the selected reference year differs from the source year or current confirmed instructions. The confirmed period classification governs, while source text and deadlines are retained. This warning does not prevent interview import after confirmation.',
            REVIEW_REQUIRED: 'Review and save the guided objective selection before confirming the import.',
            DECISIONS: 'Review the analysis decisions ({{count}})',
            NO_DECISIONS: 'No objective candidates were identified in the permitted source content. Check the source before confirming an empty list.',
            DECISION_INCLUDE: 'Eligible proposal',
            DECISION_EXCLUDE: 'Excluded from creation',
            DECISION_REVIEW: 'Needs review; not selected',
            REASON: 'AI explanation',
            REASONS: {
              unrelated_field_evidence: 'The cited passages do not establish one unambiguous objective and its associated measures.',
              ambiguous_source_year: 'The source year references do not establish one clear objective year.',
              source_year_requires_evidence: 'The source year context needs verification before an instruction year can be used.',
              missing_year: 'No supported objective year or permitted year context is available.',
              model_exclude: 'The analysis proposes excluding this item from objective creation.',
              model_review: 'The analysis requires individual review before this item can be selected.',
              category_excluded: 'This category is outside the objective-selection policy.',
              source_ineligible: 'This passage is not eligible to create an objective under the current policy.',
              assessed_history: 'This is an assessed or historical item, not a new objective to create.',
              unknown_phase: 'The source does not clearly establish a new or planned objective.',
              target_year_excluded: 'The source year is outside the requested objective year.',
              incomplete_coverage: 'The analysis did not cover all required source passages.',
              other: 'An additional source or selection check requires review.',
            },
            NO_KPI: 'No supported KPI provided; no target invented',
            YEAR_SOURCE: 'Year supported by the source',
            YEAR_INSTRUCTION_CONTEXT: 'Year supplied by your instructions, not stated in the source',
            YEAR_UNKNOWN: 'Year not established',
            MANUAL_HELP: 'In this mode, only eligible source-backed proposals can be added. You can edit or remove selected proposals; existing unsupported choices stay visible for correction.',
            DEFAULTS_HELP: 'Only eligible proposals are preselected. This does not approve or import them. Check the titles, source passages, KPIs and years before confirming your list.',
            CANDIDATE_HELP: 'The title is an AI proposal based on the source, not necessarily a literal workbook title. Supporting passages and supplied KPI values remain available for review.',
            PART_LABEL: 'Source column heading',
            PART_QUESTION: 'Source question',
            PART_YEAR: 'Source year reference',
          },
          OBJECTIVE_CLASSIFICATION: {
            ISSUE_AT_INDEX: 'Saved objective {{index}}: {{message}}',
            PHASE_LABEL: 'Objective period',
            PHASE_ASSESSED: 'Assessment of previous objectives',
            PHASE_PLANNED: 'Defined objectives',
            PHASE_UNKNOWN: 'Period to clarify',
            YEAR_LABEL: 'Classification year (when missing from the source)',
            YEAR_UNKNOWN: 'Year not specified',
            YEAR_INVALID: 'Enter a whole year between 1900 and 3000, or leave it empty.',
            SOURCE_DEADLINE: 'Original deadline',
            SOURCE_YEAR: 'Original year wording',
            SOURCE_HELP: 'Current confirmed instructions govern period classification where applicable. Original year wording, source text and deadlines are preserved. Changing the application interview date does not rebase these objectives.',
            REPORT_ONLY_UNKNOWN: 'Report only: while the phase or classification year is unknown, this item remains in the interview report and is not created in the Objectives menu, including planned objectives without a year. This does not prevent interview import after confirmation.',
            REPORT_ONLY_HISTORY: 'Report only: this assessed or historical item remains in the interview report and is not created as a new objective in the Objectives menu. This does not prevent interview import after confirmation.',
            RESULT_ATTAINED: 'Attained',
            RESULT_PARTIAL: 'Partially attained',
            RESULT_NOT_ATTAINED: 'Not attained',
            RESULT_UNKNOWN: 'Result not specified',
            BATCH_ACCEPTED: 'This list was accepted under the batch policy. This is not a claim that every item was manually checked.',
            BATCH_REVIEW: 'Accepted by batch policy',
          },
          OBJECTIVE_PROVENANCE: {
            SOURCE_TITLE: 'Original source objectives',
            SOURCE_HELP: 'Exact source wording, kept read-only for comparison. Values selected for import are in your main list.',
            SOURCE_COMMENT: 'Original goal comment',
            NOT_PROVIDED: 'Not provided',
            DEADLINE: 'Source deadline',
            IMPORTANCE: 'Source importance',
            EVIDENCE: 'Source references (private)',
            ASSESSMENT_TITLE: 'Original assessment notes',
            ASSESSMENT_HELP: 'These notes may discuss several objectives. They are not automatically assigned to one goal.',
            STALE: 'The source has changed. Earlier evidence is reference-only; restoring and applying AI suggestions are disabled.',
            UNAVAILABLE: 'Verified source objectives are unavailable. Current draft values are unchanged.',
            RESTORE: 'Restore source objectives',
            RESTORE_HELP: 'Explicitly replace the saved objective list with source defaults. Existing drafts are never reset automatically.',
            RESTORE_DIRTY: 'Save your changes and reopen this draft before restoring source objectives. Unsaved edits will not be discarded.',
            RESTORE_CONFIRM: 'Replace all saved objectives with the original source defaults? Custom objectives and edits will be removed, status and progress reset, and objective review cleared. People, planning and notification choices stay unchanged. This saves the private draft only.',
            RESTORE_SUCCESS: 'Source objectives restored in the private draft. Review them before import.',
            RESTORE_ERROR: 'Unable to restore source objectives. Current values have been kept.',
            AI_TITLE: 'AI proposals (unverified)',
            AI_HELP: 'These are suggestions, not original source text. Nothing is applied automatically. The explicit action copies only status and progress, never the AI comment.',
            AI_COMMENT: 'AI comment (unverified)',
            APPLY_TARGET: 'Matching source goal:',
            APPLY: 'Apply suggested status / progress',
            NO_COMPLETION: 'No usable status or progress is suggested.',
            UNMATCHED: 'No unique source goal matches. Review and edit the draft manually; no objective will be created or changed automatically.',
            EFFECTIVE_TITLE: 'Editable draft objectives',
          },
          REVIEW_CHECKED: 'Reviewed',
          REVIEW_PENDING: 'To review',
          OBJECTIVE_NUMBER: 'Objective {{number}}',
          UNTITLED_OBJECTIVE: 'Untitled objective',
          CONTENT_HELP: 'Consult the interview answers here. Technical details and direct text editing remain under Advanced.',
          AI_CONTENT_HELP: 'Review the interview content structured by AI from this Excel record. Objectives are reviewed separately; source cells remain available under technical details.',
          SOURCE_REFERENCE_HELP: 'Original spreadsheet cells are kept for verification. They are not the analyzed interview content shown in the report.',
          SAVE_HELP: 'Saves only this private draft. The final interview import is a separate action.',
          LOADING: 'Loading the latest draft...',
          NOT_FOUND: 'This draft no longer exists or is unavailable. Close and refresh the list.',
          READ_ONLY: 'Processing or imported interviews are read-only.',
          STALE_ERROR: 'A current draft version is required. Close and reopen this review to refresh it before saving. Unsaved changes are not applied automatically.',
          CONTENT_TITLE: 'Interview content',
          SOURCE_NOT_CURRENT: 'The extracted text was edited or cannot be verified against the source. The text above is the current content; the original source below is not current.',
          ORIGINAL_SOURCE: 'Original source',
          ORIGINAL_SOURCE_HELP: 'Reference only. These original answers do not replace the current edited text.',
          ORIGINAL_ROW: 'Original row values (no inferred questions or respondent)',
          TECHNICAL_DETAILS: 'Technical details and provenance',
          CORRECT_PEOPLE: 'Correct collaborator and manager',
          CORRECT_PLANNING: 'Correct historical interview details',
          LOCATION_MISSING: 'Not specified',
          EDIT_EXTRACTED_TEXT: 'Advanced: edit extracted text',
          EDIT_TEXT_HELP: 'This is the single editable source of interview content. Saving updates the private draft document and workflow, not a real interview. Original structured answers remain reference-only after a text edit.',
          SAVE_PRIVATE: 'Save private draft',
          DELETE_OBJECTIVE_TITLE: 'Remove objective from this draft',
          DELETE_OBJECTIVE_CONFIRM: 'Remove this objective from the private draft? The change is applied only when you save the draft.',
          LOAD_ERROR: 'Unable to load draft.',
          COLLABORATOR: 'Collaborator',
          MANAGER: 'Manager',
          EXTRACTED: 'Extracted',
          DATE: 'Date and time',
          DATE_ONLY: 'Date',
          TIME_ONLY: 'Time (optional)',
          LOCATION: 'Location',
          LOCATION_ONSITE: 'On site',
          LOCATION_REMOTE: 'Remote',
          LOCATION_FORM: 'Form',
          INTERVIEW_LINK: 'Video link',
          NOTICE_MONTHS: 'Notice in months (optional)',
          RAW_TEXT: 'Extracted text',
          VALIDATION_ERRORS_TITLE: 'Items to fix',
          VALIDATION_ERRORS_HELP: 'These items must be fixed before importing this interview.',
          OBJECTIVE_WARNINGS_TITLE: 'Nonblocking objective warnings',
          OBJECTIVE_WARNINGS_HELP: 'Review these warnings and explicitly confirm your objective list. These warnings alone do not prevent interview import after confirmation; source-integrity and acceptance checks still apply. Current confirmed instructions govern the period, while original source text and deadlines are retained. Warnings refer to the saved list; save your edits to refresh them.',
          CLOSE_SAVED_REVIEW: 'Review complete, close',
          OBJECTIVES: 'Objectives',
          ADD_OBJECTIVE: 'Add objective',
          OBJECTIVE_TITLE: 'Title',
          SCOPE_INDIVIDUAL: 'Individual',
          SCOPE_COLLECTIVE: 'Collective',
          KPI: 'KPI',
          TARGET_YEAR: 'Reference year',
          STATUS: 'Status',
          PROGRESS: 'Progress',
          COMMENT: 'Comment',
          NO_OBJECTIVES: 'No extracted objective.',
          OBJECTIVES_REVIEWED: 'I reviewed the objectives to include when this interview is explicitly imported',
          INVALID_FORM: 'Complete the required fields.',
          SAVE_SUCCESS: 'Draft updated.',
          SAVE_WITH_VALIDATION_ERRORS: 'Private draft saved. Fix the listed items before import.',
          SAVE_WITH_OBJECTIVE_WARNINGS: 'Private draft saved successfully. Nonblocking objective warnings remain visible for review. Confirm and save your list if needed, then close this review. Final interview import is a separate action.',
          SPREADSHEET_FONT_ERROR: 'The individual PDF could not be generated. Your source answers are preserved. Retry preparation after the rendering issue is corrected.',
          NOT_ANALYZED: 'Not analyzed',
          SAVE_ERROR: 'Error updating draft.',
        },
      },
      ASSISTANT: {
        PLACEHOLDER: 'Ask the assistant a question...',
        CLEAR_SELECTION: 'Clear selection',
      },
      DOCUMENTS: {
        TAB_TITLE: 'Documents',
        VIEW_ERROR: 'Unable to open the document. Please try again.',
        UPLOAD: 'Upload a document',
        UPLOAD_SUCCESS: 'Document uploaded successfully',
        UPLOAD_ERROR: 'Error while uploading document',
        SAVE_ERROR: 'Error while saving document',
        LOAD_ERROR: 'Unable to load documents',
        DELETE_TITLE: 'Delete document',
        DELETE_CONFIRM: 'Do you really want to delete "{{name}}"?',
        DELETE_SUCCESS: 'Document deleted successfully',
        DELETE_ERROR: 'Error deleting document',
      },
      HISTORY: {
        TAB_TITLE: 'Summary & Evolution',
        SUBTITLE: 'Overall synthesis and evolution of the collaborator, based on their completed interviews.',
        BADGE_INTERVIEWS: 'source interview(s)',
        SUMMARY_TITLE: 'Global summary',
        EVOLUTION_TITLE: 'Evolution',
        AXES_PROGRESSION_TITLE: 'Progression areas',
        PAST_INTERVIEWS_TITLE: 'Past interviews',
        COMPUTED_AT: 'Saved analysis from',
        LOADING: 'Loading summary…',
        NEVER_COMPUTED: 'No saved summary available.',
        LIST_LOADING: 'Loading past interviews...',
        LIST_ERROR: 'Unable to load past interviews. Reopen this tab to try again.',
        RELOAD_LIST: 'Reload past interviews',
        UNAVAILABLE: 'Analysis unavailable.',
        ERROR_CAPACITY: 'This interview history contains too much information for AI analysis. You can still view each interview individually.',
        ERROR_TIMEOUT: 'The analysis could not finish within the allotted time. You can try again later. Any saved summary remains accessible.',
        ERROR_BUSY: 'The analysis service is temporarily busy. You can try again later. Past interviews remain accessible.',
        ERROR_SOURCES_CHANGED: 'The source interviews changed during analysis. Run the analysis again to include these changes.',
        ERROR_SUPPORT: 'The analysis could not be completed. Contact your administrator. Past interviews and any saved summary remain accessible.',
        BTN_REFRESH: 'Refresh',
        REFRESHING: 'Computing…',
        REFRESH_SUCCESS: 'Summary recomputed successfully',
        REFRESH_ERROR: 'Error while computing the summary',
        NO_CREDITS: 'Insufficient AI credits to recompute the summary.',
        NO_INTERVIEWS: 'No completed interviews for this collaborator.',
        BTN_VIEW: 'View',
        COL_DATE: 'Date',
        COL_TEMPLATE: 'Type / Template',
        LOAD_ERROR: 'Unable to load the history summary',
      },
      MY_INTERVIEWS: {
        SEARCH_PERSON_LABEL: 'Person',
        SEARCH_PERSON_PLACEHOLDER: 'Search for an employee or manager',
        FILTER_STATUS: 'Status',
        // The filter displays the name while retaining the campaign UUID as its stable value.
        FILTER_CAMPAIGN: 'Campaign',
        FILTER_CAMPAIGN_ALL: 'All campaigns',
        FILTER_TAKEOVER: 'Ownership',
        FILTER_TAKEOVER_ALL: 'All',
        FILTER_TAKEOVER_TAKEN: 'Taken over',
        FILTER_TAKEOVER_NOT_TAKEN: 'Not taken over',
        DELETE_SUCCESS: 'Interview deleted successfully',
        DELETE_ERROR: 'Error deleting the interview',
        FETCH_ERROR: 'Unable to retrieve the latest version of this interview',
        RESCHEDULE_TITLE: "Reprogrammer l'entretien",
        RESCHEDULE_SUBTITLE: "Choisissez une nouvelle date et heure pour l'entretien avec {{ name }}.",
        RESCHEDULE_DATE_LABEL: 'Nouvelle date',
        RESCHEDULE_TIME_LABEL: 'Nouvelle heure',
        RESCHEDULE_SAVE: 'Enregistrer les modifications',
        RESCHEDULE_SUCCESS: 'Entretien reprogrammé avec succès',
        RESCHEDULE_ERROR: "Erreur lors de la reprogrammation de l'entretien",
        RESCHEDULE_TOOLTIP: "Reprogrammer l'entretien",
        EXTRACT_OBJECTIVES_TOOLTIP: 'Extract objectives into the Objectives module',
        EXTRACTION_TITLE: 'Extract interview objectives',
        EXTRACTION_SUBTITLE: '{{ interviewType }} · {{ employeeName }}',
        EXTRACTION_LOADING: 'Loading interview objectives…',
        // Final synchronization exposes provenance and a required server-validated reference year.
        EXTRACTION_EMPTY: 'No importable objectives were found in this interview.',
        // Explain the modal-wide year without implying that existing objective years will be replaced.
        EXTRACTION_REFERENCE_YEAR: 'Current reference year',
        EXTRACTION_REFERENCE_YEAR_HELP: 'Used only for objectives without a target year: this year when the manager can evaluate, or the following year when the manager cannot evaluate.',
        EXTRACTION_IMPORT_SELECTED: 'Add selected objectives',
        EXTRACTION_CANCEL: 'Cancel',
        EXTRACTION_SCOPE_LABEL: 'Scope',
        EXTRACTION_SOURCE_FIELD: 'Source field',
        EXTRACTION_ALREADY_IMPORTED: 'Already imported',
        EXTRACTION_EXISTS: 'Already exists in Objectives',
        EXTRACTION_SELECT_ALL: 'Select all',
        EXTRACTION_CLEAR_SELECTION: 'Clear selection',
        EXTRACTION_IMPORT_SUCCESS: '{{ count }} objective(s) added successfully',
        EXTRACTION_IMPORT_EMPTY: 'No selected objective to add',
        EXTRACTION_IMPORT_ERROR: 'Error while importing objectives',
        EXTRACTION_ASSIGNED_TO: 'Assigned collaborator',
        EXTRACTION_UPDATED_FROM_INTERVIEW: 'Changes detected in this interview',
        EXTRACTION_UPDATE: 'Update',
        EXTRACTION_SYNC_SELECTED: 'Add / update selection',
        EXTRACTION_SYNC_SUCCESS: '{{ total }} objective(s) synchronized successfully ({{ imported }} added, {{ updated }} updated)',
        EXTRACTION_LOAD_ERROR: 'Unable to load the objectives available for synchronization.',
        EXTRACTION_NOTHING_CHANGED: 'No objective required synchronization.',
        EXTRACTION_SELECTED_SUMMARY: '{{ imported }} to create · {{ updated }} to update',
        EXTRACTION_SELECT_OBJECTIVE_ARIA: 'Select objective {{ objective }}',
        EXTRACTION_TARGET_YEAR: 'Final reference year',
        EXTRACTION_TARGET_YEAR_PLACEHOLDER: 'Select a year',
        EXTRACTION_INVALID_YEAR: 'A valid reference year is required.',
        EXTRACTION_OUT_OF_RANGE_YEAR: 'The stored year is outside the standard range and is preserved as an available option.',
        EXTRACTION_BLOCKED: 'Unavailable',
        EXTRACTION_BLOCKED_REASON: 'This objective source is no longer assigned to the interview collaborator or is unavailable.',
        EXTRACTION_IMPORTED_HISTORY: 'Assessed objectives, objectives without an established year, and unaccepted classifications remain in interview history. They are not created as active objectives.',
        EXTRACTION_SOURCE_IMPORTED: 'Imported objective',
        EXTRACTION_SOURCE_CREATED: 'Interview objective',
        EXTRACTION_DONE: 'Objectives extracted',
        EXTRACTION_DONE_TOOLTIP: 'At least one objective from this interview has already been extracted into the Objectives module',
        SKILL_EXTRACTION_TOOLTIP: 'Extract skills into the employee profile',
        SKILL_EXTRACTION_TITLE: 'Extract interview skills',
        SKILL_EXTRACTION_SUBTITLE: '{{ interviewType }} · {{ employeeName }}',
        SKILL_EXTRACTION_LOADING: 'Loading evaluated skills…',
        SKILL_EXTRACTION_EMPTY: 'No importable skills were found in this interview.',
        SKILL_EXTRACTION_COUNT: '{{ count }} skill(s)',
        SKILL_EXTRACTION_UPDATE_EXPLANATION: 'The proposed value is the manager evaluation. Changing it updates both this evaluation in the completed interview and the skill in the employee profile.',
        SKILL_EXTRACTION_SELECT_ALL: 'Select all',
        SKILL_EXTRACTION_CLEAR_SELECTION: 'Clear selection',
        SKILL_EXTRACTION_SELECT_ARIA: 'Select skill {{ skill }}',
        SKILL_EXTRACTION_NO_DOMAIN: 'No domain',
        SKILL_EXTRACTION_SOURCE_STANDARD: 'Shared catalog',
        SKILL_EXTRACTION_SOURCE_CUSTOM: 'Enterprise catalog',
        SKILL_EXTRACTION_SOURCE_INTERVIEW: 'Created in the interview',
        SKILL_EXTRACTION_CURRENT_PROFILE: 'Assigned profile evaluation',
        SKILL_EXTRACTION_MANAGER_EVALUATION: 'Manager evaluation',
        SKILL_EXTRACTION_COLLABORATOR_EVALUATION: 'Employee evaluation',
        SKILL_EXTRACTION_INFORMATION_ONLY: 'For information only',
        SKILL_EXTRACTION_PROPOSED_EVALUATION: 'Proposed manager evaluation',
        SKILL_EXTRACTION_CHOOSE_EVALUATION: 'Choose an evaluation',
        SKILL_EXTRACTION_NOT_EVALUATED: 'Not evaluated',
        SKILL_EXTRACTION_ACTION_CREATE: 'Add',
        SKILL_EXTRACTION_ACTION_UPDATE: 'Update',
        SKILL_EXTRACTION_ACTION_CREATE_AND_ADD: 'Create and add',
        SKILL_EXTRACTION_ACTION_NONE: 'Up to date',
        SKILL_EXTRACTION_ACTION_BLOCKED: 'Blocked',
        SKILL_EXTRACTION_BLOCKED_REASON: 'Reason:',
        SKILL_EXTRACTION_BLOCKED_GENERIC: 'This skill cannot be imported.',
        SKILL_EXTRACTION_BLOCKED_MISSING_MANAGER_EVALUATION: 'Manager evaluation is missing',
        SKILL_EXTRACTION_BLOCKED_INVALID_MANAGER_EVALUATION: 'Manager evaluation is invalid',
        SKILL_EXTRACTION_BLOCKED_SKILL_SOURCE_NOT_ALLOWED: 'Skill source is not allowed',
        SKILL_EXTRACTION_BLOCKED_CATALOG_SKILL_NOT_FOUND: 'Skill was not found in the catalog',
        SKILL_EXTRACTION_BLOCKED_CUSTOM_SKILL_CREATION_DISABLED: 'Custom skill creation is disabled',
        SKILL_EXTRACTION_BLOCKED_MISSING_SKILL_LABEL: 'Skill label is missing',
        SKILL_EXTRACTION_BLOCKED_DUPLICATE_USER_COMPETENCE_ROWS: 'Multiple matching profile skills exist',
        SKILL_EXTRACTION_BLOCKED_DUPLICATE_INTERVIEW_SKILL_TARGET: 'This skill appears more than once in the interview',
        SKILL_EXTRACTION_IMPORT_ONE: 'Import this skill',
        SKILL_EXTRACTION_IMPORT_SELECTED: 'Import selection',
        SKILL_EXTRACTION_CANCEL: 'Cancel',
        SKILL_EXTRACTION_LOAD_ERROR: 'Unable to load skills available for import.',
        SKILL_EXTRACTION_IMPORT_EMPTY: 'No valid skill is selected.',
        SKILL_EXTRACTION_IMPORT_SUCCESS: '{{ count }} skill(s) imported successfully.',
        SKILL_EXTRACTION_IMPORT_ERROR: 'Error while importing skills.',
        SKILL_EXTRACTION_NOTHING_CHANGED: 'No skill was changed.',
        PREPARE_SIGNATURE_TOOLTIP: 'Prepare for signature',
        FINAL_DECISION_TOOLTIP: 'Accept or refuse',
        VIEW_DOCUMENT_TOOLTIP: 'View document',
        TAKE_CONTROL: 'Take control',
        TAKE_CONTROL_TOOLTIP: 'Take control of this interview',
        TAKE_CONTROL_SUCCESS: 'You have taken control of the interview',
        TAKE_CONTROL_ERROR: 'Error taking control',
        IMPORTED_PDF_NOT_FOUND: 'The imported PDF could not be found for this interview.',
        IMPORTED_PDF_OPEN_ERROR: 'Unable to open the imported PDF.',
        PREPARATION_SIMULATOR_TOOLTIP: 'Prepare this interview with AI',
        PREPARATION_SIMULATOR_TITLE: 'Preparation simulator',
        PREPARATION_SIMULATOR_SUBTITLE: '{{ interviewType }} · {{ employeeName }}',
        PREPARATION_SIMULATOR_INTRO_TITLE: 'Prepare your arguments before the conversation',
        PREPARATION_SIMULATOR_INTRO_TEXT: 'The simulator can act as the interview lead, challenge you, and help you phrase a clear request.',
        PREPARATION_SIMULATOR_PRIVACY: 'Only information visible to you',
        PREPARATION_SIMULATOR_LOADING: 'Loading preparation context…',
        PREPARATION_SIMULATOR_THINKING: 'The simulator is preparing its response…',
        PREPARATION_SIMULATOR_INPUT_PLACEHOLDER: 'Explain your goal, mindset, or the request you want to prepare...',
        PREPARATION_SIMULATOR_COMPOSER_HINT: 'Enter to send, Shift + Enter for a new line',
        PREPARATION_SIMULATOR_STARTERS_LABEL: 'Examples to get started',
        PREPARATION_SIMULATOR_STARTER_MINDSET: 'I want to talk about my mindset',
        PREPARATION_SIMULATOR_STARTER_SALARY: 'I want to prepare a salary increase request',
        PREPARATION_SIMULATOR_STARTER_ARGUMENTS: 'Help me build my arguments',
        PREPARATION_SIMULATOR_SEND: 'Send',
        PREPARATION_SIMULATOR_YOU: 'You',
        PREPARATION_SIMULATOR_AI: 'Simulator',
        PREPARATION_SIMULATOR_LOAD_ERROR: 'Unable to start the preparation simulator',
        PREPARATION_SIMULATOR_SEND_ERROR: 'Error while sending the message to the simulator',
        PREPARATION_SIMULATOR_CREDIT_ERROR: 'Insufficient AI credits to send this message to the simulator.',
        PREPARATION_SIMULATOR_SETTING_TITLE: 'Interview preparation simulator',
        PREPARATION_SIMULATOR_SETTING_DESCRIPTION: 'Allows collaborators to prepare their interviews with the chatbot when the AI module is active.',
        PREPARATION_SIMULATOR_SETTING_ENABLED: 'Enabled',
      },
      MEETING_TEMPLATE: {
        DEFAULT_TITLE: 'Document template',
        NAME_PLACEHOLDER: 'Template name',
        ADDITIONAL_MANAGERS_LABEL: 'Additional managers',
        ADDITIONAL_MANAGERS_HELP: 'Maximum 2 (in addition to the main manager)',
        WAITING_VALIDATION:
          'This document is waiting to be completed by {{ employee }}. Once the other party validates it, it will be available for your edits and validation.',
        FIELD_LABEL: 'Field label',
        FIELD_LABEL_PLACEHOLDER: 'Enter a label (optional)',
        QUESTION_TITLE: 'Question title',
        QUESTION_TITLE_PLACEHOLDER: 'Enter the question title',
        // Translate the workflow field picker, including the static 9-box component name.
        ADD_QUESTION: 'Add a question',
        QUESTION_TYPE_PLACEHOLDER: 'Question type',
        DRAG_TO_REORDER: 'Drag to reorder',
        HELP_TEXT: 'Help',
        HELP_TEXT_PLACEHOLDER: 'Enter help text (optional)',
        CARD_TYPE_LABEL: 'Card type',
        CARD_TITLE_LABEL: 'Title',
        CARD_SECTION_LABEL: 'Section',
        CARD_SECTION_PLACEHOLDER: 'Optional section name',
        CARD_HEADER_THEME_LABEL: 'Header theme',
        CARD_HEADER_THEME_HELP: 'Choose the background and text colors for this card header.',
        CARD_HEADER_THEME_DEFAULT: 'Default',
        CARD_HEADER_THEME_SAND: 'Sand',
        CARD_HEADER_THEME_AMBER: 'Amber',
        CARD_HEADER_THEME_SAGE: 'Sage',
        CARD_HEADER_THEME_TEAL: 'Teal',
        CARD_HEADER_THEME_SKY: 'Sky',
        CARD_HEADER_THEME_BLUE: 'Blue',
        CARD_HEADER_THEME_INDIGO: 'Indigo',
        CARD_HEADER_THEME_VIOLET: 'Violet',
        CARD_HEADER_THEME_ROSE: 'Rose',
        CARD_HEADER_THEME_SLATE: 'Slate',
        CARD_HEADER_THEME_ENTERPRISE_PRIMARY: 'Company primary',
        CARD_HEADER_THEME_ENTERPRISE_SECONDARY: 'Company secondary',
        CARD_HEADER_THEME_ENTERPRISE_TERTIARY: 'Company tertiary',
        CARD_HEADER_THEME_CURRENT_CUSTOM: 'Current theme',
        TYPE_DYNAMIC: 'Dynamic type',
        TYPE_FEEDBACK: 'Feedback request',
        SEARCH_INTERVIEW_TYPE: 'Search interview type',
        SEARCH_DOC_TEMPLATE: 'Search document template',
        WARNING_TITLE: 'Warning: Manual edits',
        MANUAL_EDITS_WARNING:
          'You have made manual edits in the final document. If you go back to the cards and edit them, all your manual edits in the editor will be lost. Do you want to continue?',
        CONTINUE_AND_LOSE_EDITS: 'Continue and lose edits',
        SAVE_SUCCESS: 'Document saved successfully',
        SAVE_ERROR: 'Error saving document',
        TEMPLATE_SAVE_SUCCESS: 'Template saved successfully',
        CUSTOM_REPORT: {
          TITLE: 'Custom AI report',
          DESCRIPTION: 'Configure an additional document based on the completed interview, separate from the standard summary and the preparation assistant.',
          INSTRUCTIONS_LABEL: 'Instructions and expected content',
          INSTRUCTIONS_PLACEHOLDER: 'Describe the purpose, sections and format. For example: prepare a salary negotiation briefing using achievements and evidence from the interview.',
          MANAGER_LABEL: 'Make this report available to managers',
          EMPLOYEE_LABEL: 'Make this report available to the employee',
          ENABLED_LABEL: 'Activate automatic report generation for this template',
          GENERATION_HELP: 'Enable this option to automatically create a report when future interviews are completed. Turning it off keeps your instructions and access settings. You can still test the report before enabling it.',
          ACCESS_HELP: 'Generated reports are always available to administrators of your enterprise; checkboxes only control additional manager/employee access.',
          VISIBILITY_HELP: 'Saved reports are available in Interviews and My tasks / My interviews according to the access settings saved with each interview.',
          VIEW_SAVED: 'Custom report',
          LOADING_SAVED: 'Loading report...',
          SAVED_UNAVAILABLE: 'This custom report is no longer available to you. Refresh the interview list.',
          SAVED_ERROR: 'Unable to load the custom report. Please try again.',
          SNAPSHOT_HELP: 'These settings apply to new interviews created from this template. Existing interviews keep their saved settings.',
          GLOBAL_HELP: 'This is a shared template. Duplicate it to customize the report settings for your company.',
          SAVE_SETTINGS: 'Save settings',
          SAVING: 'Saving...',
          SAVE_SUCCESS: 'Custom report settings saved.',
          SAVE_ERROR: 'Unable to save the custom report settings. Your changes have been kept.',
          PREVIEW: 'Preview report',
          PREVIEW_TITLE: 'Custom report preview',
          PREVIEW_HELP: 'Generate a private test using the saved instructions and a completed interview. No n8n is needed. The preview is not saved or shared and does not replace the interview summary. A successful preview uses AI credits.',
          SAVE_FIRST: 'Save this template and your report instructions before testing. Changes to visibility or automatic generation do not prevent testing.',
          SELECT_INTERVIEW: 'Completed interview',
          SELECT_PLACEHOLDER: 'Select a completed interview',
          SEARCH_LABEL: 'Search by employee or interview type',
          SEARCH: 'Search',
          LOADING_INTERVIEWS: 'Loading completed interviews...',
          NO_INTERVIEWS: 'No completed interviews match this search.',
          LIST_ERROR: 'Unable to load completed interviews. Search again to retry.',
          PREVIOUS_PAGE: 'Previous',
          NEXT_PAGE: 'Next',
          PAGE: 'Page {{page}}',
          GENERATE: 'Generate preview',
          GENERATING: 'Generating the report preview...',
          CLOSE_PREVIEW: 'Cancel preview',
          PREVIEW_ERROR: 'Unable to generate the preview. Please try again.',
          QUOTA_ERROR: 'There are not enough AI credits to generate a preview.',
          INSTRUCTIONS_ERROR: 'This template no longer has saved report instructions. Reload the template and save instructions before previewing.',
          SOURCE_ERROR: 'This interview has no usable content for the preview or is no longer available.',
          STATUS_ERROR: 'This interview is no longer completed. Select another completed interview.',
          TOO_LARGE_ERROR: 'The instructions or interview content are too long for this preview.',
          LIMIT_ERROR: 'Too many preview requests. Please wait before trying again.',
          TIMEOUT_ERROR: 'The AI service took too long to respond. Please try again.',
        },
        // Keep all interview modal backdrop labels and feedback scoped to the template editor.
        MODAL_BACKGROUND: {
          TITLE: 'Modal background image',
          HELP: 'This image will appear behind the modal for future interviews created from this template.',
          UPLOAD: 'Upload an image',
          SELECT: 'Select an image',
          DECODING: 'Validating image...',
          CHANGE: 'Replace image',
          REMOVE: 'Remove image',
          PREVIEW_ALT: 'Interview modal background image preview',
          ACCEPTED_FORMATS: 'PNG, JPEG, or WebP, up to 5 MB.',
          INVALID_TYPE: 'Select a PNG, JPEG, or WebP image.',
          OVERSIZE_FILE: 'The image must not exceed 5 MB.',
          INVALID_FILE: 'The browser could not decode this image. Select a valid image file.',
          REMOVE_CONFIRMATION_TITLE: 'Remove background image',
          REMOVE_CONFIRMATION_MESSAGE: 'Remove this template background image when you next save?',
          UPLOAD_SAVE_FAILURE: 'Unable to save the background image. No image change was applied.',
          NO_IMAGE: 'No background image configured',
          REMOVAL_PENDING: 'Removal will be applied when you save',
        },
        SKILL_SEARCH_LABEL: 'Search for a skill',
        SKILL_SEARCH_PLACEHOLDER: 'Start typing to search for skills...',
        SKILL_LOADING: 'Loading skills...',
        SKILL_START_SEARCH: 'Start typing to display available skills.',
        SKILL_NO_RESULTS: 'No skills match your search.',
        SKILL_CREATE_ERROR: 'Unable to create the custom skill.',
        SKILL_SELECTED_LABEL: 'Selected skills',
        SKILL_DOMAIN_LABEL: 'Domain',
        SKILL_EMPTY_SELECTION: 'No skills selected yet',
        SKILL_LEVEL_ARIA: 'Skill level selection',
        SKILL_LEVEL_BEGINNER: 'Beginner',
        SKILL_LEVEL_INTERMEDIATE: 'Intermediate',
        SKILL_LEVEL_ADVANCED: 'Advanced',
        SKILL_LEVEL_EXPERT: 'Expert',
        SKILL_MANAGER_CAN_ADD: 'Allow manager to add skills during evaluation',
        SKILL_MANAGER_CAN_ADD_HELP: 'If enabled, the manager can choose additional skills beyond those listed above.',
        SKILL_COLLAB_CAN_ADD: 'Allow collaborator to add skills during evaluation',
        SKILL_COLLAB_CAN_ADD_HELP:
          'If enabled, the collaborator can choose additional skills beyond those listed above.',
        SKILL_AUTOLOAD_COLLAB: 'Auto-load the collaborator skills',
        SKILL_AUTOLOAD_COLLAB_HELP: 'At interview time, automatically imports this collaborator current skills (merged with the defined list).',
        SKILL_AUTOLOAD_SOURCES: 'Auto-load sources',
        SKILL_AUTOLOAD_PROFILE: 'Collaborator profile skills',
        SKILL_AUTOLOAD_JOB_DESCRIPTION: 'Skills from the assigned job description',
        SKILL_COLLAB_CAN_EVALUATE: 'Allow collaborator to evaluate skills',
        SHOW_EVALUATION: 'Show evaluation options',
        SHOW_EVALUATION_HELP: 'If enabled, evaluation options will be displayed for this field.',
        COMMENT_MANDATORY: 'Comment is mandatory',
        COMMENT_MANDATORY_HELP: 'If enabled, a comment is required for each item in this field.',
        // Objective template tabs configure definitions and per-collaborator imports without exposing a global catalogue.
        OBJECTIVE_COLLAB_CAN_ADD: 'Allow collaborator to add objectives',
        OBJECTIVE_AUTOLOAD_COLLAB: 'Auto-load the collaborator objectives',
        OBJECTIVE_AUTOLOAD_COLLAB_HELP: 'Keep the target collaborator objectives matching the configured years current while the interview is active.',
        OBJECTIVE_MANAGER_CAN_EVALUATE: 'Allow manager to evaluate objectives',
        OBJECTIVE_COLLAB_CAN_EVALUATE: 'Allow collaborator to evaluate objectives',
        OBJECTIVE_TARGET_YEAR_LABEL: 'Default reference year (You can modify this for each objective)',
        OBJECTIVE_TARGET_YEAR_PLACEHOLDER: 'e.g. 2026',
        OBJECTIVE_TABS_ARIA: 'Objective configuration mode',
        OBJECTIVE_CREATE_TAB: 'Create',
        OBJECTIVE_CREATE_DESCRIPTION: 'Define objectives provided by this template. The selected reference year is applied by default to each new objective.',
        OBJECTIVE_IMPORT_TAB: 'Import',
        OBJECTIVE_IMPORT_DESCRIPTION: 'Configure which existing objectives will be resolved separately for each target collaborator when their interview is planned.',
        OBJECTIVE_IMPORT_YEARS_LABEL: 'Years to import',
        OBJECTIVE_IMPORT_YEARS_PLACEHOLDER: 'Select one or more years',
        OBJECTIVE_IMPORT_ALL_YEARS: 'All years',
        OBJECTIVE_IMPORT_SELECTED_COUNT: '{{count}} year(s) selected',
        OBJECTIVE_IMPORT_NO_YEARS: 'No objective year is currently available for this enterprise.',
        OBJECTIVE_IMPORT_YEAR_REQUIRED: 'Select at least one import year or All years.',
        OBJECTIVE_IMPORT_REMOVE_YEAR_ARIA: 'Remove import year',
        OBJECTIVE_TEXT_OPTIONS: "Objective evaluation options",
        OBJECTIVE_PERCENTAGE_HINT: "Percentages per option:",
        ADD_CUSTOM_INTRO_CARD: 'Add a customised introduction card',
        ADD_CUSTOM_INTRO_CARD_DESC:
          'If enabled, a customised introduction card will be added at the beginning of the document.',
        CUSTOM_INTRO_CONTENT_LABEL: 'Introduction content',
        INTRODUCTION_CARD_TITLE: 'Introduction',
        OBJECTIVE_ADD_LABEL: 'Add an objective',
        OBJECTIVE_ADD_BTN: 'Add',
        OBJECTIVE_PLACEHOLDER: 'Enter an objective then press Enter',
        OBJECTIVE_SELECTED_LABEL: 'Defined objectives',
        OBJECTIVE_EMPTY_SELECTION: 'No objectives defined yet',
        OBJECTIVE_SCOPE_LABEL: 'Scope',
        OBJECTIVE_SCOPE_INDIVIDUAL: 'Individual',
        OBJECTIVE_SCOPE_COLLECTIVE: 'Collective',
        OBJECTIVE_SCOPE_ARIA: 'Objective scope selection',
        OBJECTIVE_EDIT_LABEL: 'Edit objective',
        OBJECTIVE_SAVE_LABEL: 'Save',
        OBJECTIVE_CANCEL_EDIT: 'Cancel',
        FORMATION_FIELD_LABEL: 'Training',
        FORMATION_MANAGER_CAN_ADD: 'Allow manager to add trainings',
        FORMATION_COLLAB_CAN_ADD: 'Allow collaborator to request trainings',
        FORMATION_COMMENT_MANDATORY: 'Mandatory comment',
        FORMATION_ADMIN_DATES_HINT: 'The manager fills in the dates if left empty here.',
        FORMATION_ADD_FROM_CATALOG: 'Add a training from the catalog',
        FORMATION_SEARCH_CATALOG: 'Search a training...',
        FORMATION_NO_RESULTS: 'No training found',
        FORMATION_PRESELECTED: 'Pre-selected trainings',
        FORMATION_ASSIGNED: 'Propose',
        FORMATION_REQUESTED: 'Request',
        FORMATION_PRESELECTED_BADGE: 'Pre-selected',
        FORMATION_START_DATE: 'Start',
        FORMATION_END_DATE: 'End',
        FORMATION_ALREADY_ASSIGNED: 'Already assigned',
        FORMATION_STATUS_FINISHED: 'Finished',
        FORMATION_STATUS_EXPIRED: 'Expired',
        FORMATION_STATUS_IN_PROGRESS: 'In progress',
        FORMATION_STATUS_NOT_STARTED: 'Not started',
        FORMATION_STARTED_ON: 'Started on',
        FORMATION_FINISHED_ON: 'Finished on',
        FORMATION_EXPIRED_ON: 'Deadline passed on',
        FORMATION_ALREADY_ASSIGNED_HINT: 'Trainings already assigned to the collaborator',
        FORMATION_COMMENT_PLACEHOLDER: 'Add a comment...',
        FORMATION_COMMENT_MANDATORY_PLACEHOLDER: 'Mandatory comment...',
        FORMATION_MANAGER_LIST: 'Trainings assigned by the manager',
        FORMATION_COLLAB_LIST: 'Trainings requested by the collaborator',
        FORMATION_NO_ENTRIES: 'No training',
        FORMATION_REMOVE: 'Remove',
        TRANSLATION_ENABLE: 'Enable multilanguage',
        TRANSLATION_SOURCE_LANG: 'Source language',
        TRANSLATION_TARGET_LANG: 'Target language',
        TRANSLATION_PREVIEW_LANG: 'Language',
        TRANSLATION_BTN: 'Translate',
        TRANSLATION_BTN_LOADING: 'Translating…',
        TRANSLATION_SUCCESS: 'Translation generated successfully',
        TRANSLATION_ERROR: 'Error during translation',
        TRANSLATION_NO_CREDIT: 'Not enough AI credits to translate',
        TRANSLATION_NO_STRINGS: 'No text to translate in this template',
        VIEWER_LANG_SWITCHER: 'Display language',
        PREVIEW: 'Preview',
        PREVIEW_NO_CARDS: 'Add a card before opening the preview',
        PREVIEW_NOTICE: 'Temporary template preview. Answers are discarded when closed.',
        PREVIEW_ROLE_LABEL: 'Preview role',
        PREVIEW_FEEDBACK_NOTICE: 'Feedback actions are unavailable in template preview.',
        // Labels for simulated cross-feedback content without real creation or delivery.
        PREVIEW_FEEDBACK_FORMAT: 'Meeting format',
        PREVIEW_FEEDBACK_IN_PERSON: 'In person',
        PREVIEW_FEEDBACK_VIDEO: 'Video conference',
        // Cross-feedback forms are asynchronous and distinct from meeting formats.
        PREVIEW_FEEDBACK_FORM: 'Form',
        PREVIEW_FEEDBACK_CONTRIBUTOR: 'Sample contributor',
        PREVIEW_COLLABORATOR: 'Sample collaborator',
        PREVIEW_MANAGER: 'Sample manager',
        PREVIEW_OBJECTIVE: 'Sample development objective',
        PREVIEW_SKILL: 'Sample skill',
        PREVIEW_DOMAIN: 'Sample domain',
        PREVIEW_FORMATION: 'Sample training',
        PREVIEW_USER: 'Sample user',
        PREVIEW_SELECT_COLLABORATOR: 'Select a collaborator',
        // State the audience and action explicitly so administrators understand which button this controls.
        CROSS_FEEDBACK_ALLOW_SUMMARY_SHARING: 'Allow managers to share the feedback summary with the collaborator',
        CROSS_FEEDBACK_ALLOW_SUMMARY_SHARING_HELP: 'When disabled, the manager cannot share the report with the evaluated employee.',
      },
      // Keep all 9-box presentation text static, translated, and separate from persisted A1-C3 answer codes.
      NINE_BOX: {
        FIELD_TYPE: '9-box grid',
        INSTRUCTION: 'Select the box that best represents the employee’s performance and potential.',
        GRID_ARIA: 'Nine-box performance and potential grid',
        PERFORMANCE: 'Performance',
        POTENTIAL: 'Potential',
        LOW: 'Low',
        HIGH: 'High',
        NO_SELECTION: 'No box selected',
        CELLS: {
          A3: {
            TITLE: 'Enigma',
            DESCRIPTION: 'Poor performance with high potential',
          },
          A2: {
            TITLE: 'Future Star',
            DESCRIPTION: 'Good or average performance with high potential',
          },
          A1: {
            TITLE: 'Future Leader',
            DESCRIPTION: 'Superior performance, ready for promotion',
          },
          B3: {
            TITLE: 'Inconsistent',
            DESCRIPTION: 'Low performance with average potential',
          },
          B2: {
            TITLE: 'Average performance, average potential',
            DESCRIPTION: 'Or in role for less than 3 to 6 months (management team)',
          },
          B1: {
            TITLE: 'Performer',
            DESCRIPTION: 'High performance with moderate potential',
          },
          C3: {
            TITLE: 'Underperformer',
            DESCRIPTION: 'Poor performance with limited opportunities (recruit)',
          },
          C2: {
            TITLE: 'Good/average performance',
            DESCRIPTION: 'Limited potential',
          },
          C1: {
            TITLE: 'Trusted employee',
            DESCRIPTION: 'High performance with low potential',
          },
        },
      },
      FIELD_VISIBILITY: 'Field visibility',
      FIELD_LABEL: 'Field label',
      FIELD_LABEL_PLACEHOLDER: 'Enter a label',
      VISIBLE_FOR_ADMIN: 'Visible for admin',
      VISIBLE_FOR_MANAGER: 'Visible for manager',
      VISIBLE_FOR_COLLABORATOR: 'Visible for employee',
      ADVANCED_PARAMETERS: 'Advanced parameters',
      FIELD_EDITABLE_BY: 'Field editable by',
      // Describe independent role rules so all four optional/required combinations are unambiguous.
      FIELD_RESPONSE_RULES: 'Response requirements by role',
      FIELD_RESPONSE_RULES_HELP: 'Choose separately whether the manager and employee must answer this field.',
      FIELD_ROLE_MANAGER: 'Manager response',
      FIELD_ROLE_COLLABORATOR: 'Employee response',
      EDITABLE_OPTIONAL: 'Optional',
      EDITABLE_MANDATORY: 'Mandatory',
      EDITABLE_HIDDEN: 'Not visible',
      MANAGER_OPTIONAL_ANSWER: 'Optional question',
      MANAGER_REQUIRED_ANSWER: 'Required question',
      MANAGER_READONLY: 'Read-only question',
      COLLAB_OPTIONAL_ANSWER: 'Optional answer',
      COLLAB_REQUIRED_ANSWER: 'Required answer',
      COLLAB_READONLY: 'Read only',
      FIELD_ANSWER_MODE: 'Answer mode',
      ANSWER_SINGLE_COLLAB: 'Single answer (Employee)',
      ANSWER_SINGLE_MANAGER: 'Single answer (Manager)',
      ANSWER_MULTIPLE: 'Multiple answers (Manager + Employee)',
      WORKFLOW_PARAMETERS: 'Interview parameters',
      WORKFLOW_PARAMS_TITLE: 'General parameters',
      WORKFLOW_PARAMS_DESC: 'Configure global interview settings',
      COLLAB_CAN_VIEW_WORKFLOW: 'Employee can view the entire interview',
      COLLAB_CAN_VIEW_WORKFLOW_DESC: 'If enabled, the employee will be able to see all sections of the form',
      VISIBLE_BY_COLLABORATOR: 'Visible by employee',
      VISIBLE_BY_COLLABORATOR_DESC: 'If enabled, the interview will be visible to the employee',
      MANAGER_CAN_VIEW_BEFORE_VALIDATION: 'Manager can view interview before employee validation',
      MANAGER_CAN_VIEW_BEFORE_VALIDATION_DESC:
        'If enabled, the manager will have access to content before the employee validates',
      ALLOW_MANAGER_AI_ASSISTANCE: 'Allow manager to choose AI assistance',
      ALLOW_MANAGER_AI_ASSISTANCE_DESC:
        'If enabled, the manager can activate or deactivate AI assistance when completing the interview, otherwise AI assistance will be disabled by default without the possibility to activate it.',
      IA_GUIDELINE_TITLE: 'Default AI Instructions',
      IA_GUIDELINE_DESC: 'Define the default instructions for the AI assistant when generating content for this interview template.',
      IA_GUIDELINE_PLACEHOLDER: 'Ex: Use a professional and supportive tone. Focus on the employee\'s development goals...',
      PREPARATION_QUESTIONS_TITLE: 'Preparation Questions',
      PREPARATION_QUESTIONS_DESC: 'Define the questions the manager must answer before using the AI assistant. These answers will guide the AI in its suggestions.',
      PREPARATION_QUESTIONS_SUGGESTIONS_TITLE: 'Suggestions',
      PREPARATION_QUESTIONS_SUGGESTION_1: 'What key message do you want your collaborator to remember at the end of this interview?',
      PREPARATION_QUESTIONS_SUGGESTION_2: 'What is your mindset approaching this interview (e.g., confident, uncertain, tense)?',
      PREPARATION_QUESTIONS_SUGGESTION_3: 'What reactions from your collaborator do you anticipate, and how do you plan to respond as a manager?',
      PREPARATION_QUESTIONS_SUGGESTION_4: 'How high is the priority to retain this collaborator in the company? (Scale 1 to 5, where 5 = key collaborator to retain absolutely)',
      PREPARATION_QUESTION_PLACEHOLDER: 'Enter the question...',
      ADD_PREPARATION_QUESTION_PLACEHOLDER: 'Add a new preparation question...',
      PREPARATION_QUESTIONS_SECTION_TITLE: 'Preparation Questions',
      PREPARATION_QUESTIONS_SECTION_DESC: 'Please answer the following questions to help the AI assistant better support you.',
      PREPARATION_ANSWER_PLACEHOLDER: 'Enter your answer...',
      AI_ASSISTANT_TITLE: 'AI Assistant',
      AI_ASSISTANT_TAB: 'AI Assistant',
      AI_ASSISTANT_DISCLAIMER: 'The final version of the interview is the responsibility of the manager.',
      AI_ASSISTANT_CHOICE_MADE: 'Your choice',
      AI_ASSISTANT_CHOICE_YES: 'AI assistance enabled',
      AI_ASSISTANT_CHOICE_NO: 'AI assistance disabled',
      AI_ASSISTANT_CHANGE_CHOICE: 'You can change your choice by clicking on one of the options below.',
      AI_CHAT: {
        CARD_LABEL: 'Section',
        QUESTION_LABEL: 'Question',
        PROGRESS: 'Progress',
        CANCEL_AI_ASSISTANCE: 'Cancel AI assistance',
        CONTINUE_INTERVIEW: 'Continue to interview',
        SIDEBAR_INPUT_PLACEHOLDER: 'Type your message...',
        SEND_TO_AI: 'Send to AI',
        CANCEL_CONFIRMATION_TITLE: 'Cancel AI assistance',
        CANCEL_CONFIRMATION_MESSAGE: 'Are you sure you want to cancel AI assistance? Your answers to the preparation questions will be lost.',
        INPUT_PLACEHOLDER: 'Type your answer...',
        COMPLETION_MESSAGE: 'Thank you for your answers! You can now continue with the interview.',
      },
      AI_TEXT: {
        CONTEXTUALISER: 'Rephrase',
        VERIFIER: 'Verify',
        CONTEXTUALISER_TITLE: 'Rephrase text',
        VERIFIER_TITLE: 'Verify text',
        SELECTED_TEXT: 'Selected text',
        INSTRUCTION_LABEL: 'Instructions / Context',
        INSTRUCTION_HINT: 'Add instructions or context to guide the AI response.',
        INSTRUCTION_PLACEHOLDER: 'Add instructions for the AI...',
        GENERATE: 'Generate',
        RESULT_LABEL: 'Result',
        RESULT_PLACEHOLDER: 'The generated text will appear here...',
        CANCEL: 'Cancel',
        INSERT: 'Insert',
        ERROR_NO_CONVERSATION: 'Unable to contact the AI. Please try again.',
        ERROR_GENERATING: 'Error while generating the text',
      },
      // Voice-dictation translations cover the modal, controls, and every related toast.
      VOICE_DICTATION: {
        OPEN: 'Enter text by voice',
        TITLE: 'Voice dictation',
        START: 'Start recording',
        STOP: 'Stop recording',
        READY: 'Ready to record',
        RECORDING: 'Recording in progress…',
        RECORDING_HINT: 'Speak normally. The live transcription remains editable.',
        UNSUPPORTED_HINT: 'Native voice transcription is not available in this browser.',
        TRANSCRIPTION_LABEL: 'Transcription',
        TRANSCRIPTION_PLACEHOLDER: 'The live transcription will appear here…',
        INSTRUCTION_LABEL: 'AI instructions',
        INSTRUCTION_PLACEHOLDER: 'Tell the AI how to rephrase this text…',
        REFORMULATE_WITH_AI: 'Rephrase with AI',
        ACCEPT: 'Accept',
        EMPTY_TRANSCRIPTION: 'Add or dictate text before rephrasing it.',
        UNSUPPORTED: 'Native voice transcription is not supported by this browser.',
        HTTPS_REQUIRED: 'Voice transcription requires a secure HTTPS connection.',
        PERMISSION_DENIED: 'Microphone access was denied. Allow it in your browser settings.',
        MICROPHONE_UNAVAILABLE: 'No available microphone could be used.',
        RECOGNITION_ERROR: 'Voice transcription was interrupted. Please try again.',
        START_ERROR: 'Unable to start voice recording.',
        REFORMULATION_ERROR: 'An error occurred while rephrasing the text with AI.',
      },
      ALLOW_CONCURRENT_EDITING: 'Allow simultaneous editing by manager and employee',
      ALLOW_CONCURRENT_EDITING_DESC:
        'If enabled, the manager and employee can fill the interview at the same time without waiting for the other to validate',
      EDITABLE_BY_MANAGER: 'Editable by interview manager',
      COLLAB_CAN_REFUSE: 'Employee can refuse to complete the interview',
      COLLAB_CAN_REFUSE_DESC: 'If enabled, the employee will be able to refuse to complete the form',
      MANAGER_CAN_REFUSE: 'Manager can refuse to complete the interview',
      MANAGER_CAN_REFUSE_DESC: 'If enabled, the manager will be able to refuse to complete the form',
      CROSS_FEEDBACK_AUTO_CANCEL: 'Automatically cancel unfinished cross-feedbacks after the interview ends',
      CROSS_FEEDBACK_AUTO_CANCEL_DESC: 'If enabled, unfinished cross-feedbacks are automatically cancelled when the interview ends. Cross-feedback can be requested after the interview date regardless of this option.',
      REFUSE_CONSEQUENCES: 'Detail the consequences of refusal',
      REFUSE_CONSEQUENCES_PLACEHOLDER:
        'If you do not agree with the interview conclusions, you can refuse it. A meeting with HR will then be organized.',
      REFUSE_INTERVIEW: 'Refuse Interview',
      REFUSE_INFO: 'You can refuse this interview. Please review the following information:',
      CONSEQUENCES: 'Consequences',
      REFUSE_PROCEED: 'Continue',
      REFUSE_REASON_PROMPT: 'Please indicate the reason for your refusal (optional).',
      REFUSE_REASON_LABEL: 'Reason for refusal',
      REFUSE_REASON_PLACEHOLDER: 'Explain why you are refusing this interview...',
      REFUSE_CONFIRM: 'Confirm Refusal',
      REFUSE_SUCCESS: 'Interview refused successfully',
      REFUSE_ERROR: 'Error refusing the interview',
      REFUSED: 'Refused',
      REFUSED_BY_EMPLOYEE: 'Refused by employee',
      REFUSED_BY_MANAGER: 'Interview refused by contributor',
      REFUSED_BY_COLLAB: 'Report refused by employee',
      PENDING_COLLAB_VALIDATION: 'Pending collaborator validation',
      PENDING_COLLAB_VALIDATION_TOOLTIP: 'Pending validation from {{name}}',
      COLLABORATOR_VALIDATED_TOOLTIP: '{{name}} validated',
      MANAGER_VALIDATED_TOOLTIP: '{{name}} validated',
      PENDING_MANAGER_VALIDATION: 'Pending manager validation',
      PENDING_MANAGER_VALIDATION_TOOLTIP: 'Pending validation from {{name}}',
      CANCEL_VALIDATION: {
        BUTTON_TITLE: 'Cancel validation',
        TITLE: 'Cancel validation',
        WARNING: 'Warning: this action is irreversible and will require a new validation.',
        MESSAGE: "Choose which validation you want to cancel:",
        RESET_MANAGER: 'Cancel manager validation',
        RESET_COLLAB: 'Cancel manager and collaborator validation',
        RESET_COLLAB_ONLY: 'Cancel collaborator validation',
        CONFIRM_TITLE: 'Confirm validation cancellation',
        CONFIRM_MANAGER_MESSAGE: 'Do you really want to cancel the manager validation?',
        CONFIRM_COLLAB_MESSAGE: 'Do you really want to cancel both manager and collaborator validations?',
        CONFIRM_COLLAB_ONLY_MESSAGE: 'Do you really want to cancel the collaborator validation?',
        CONFIRM_ACTION: 'Confirm',
        SUCCESS_MANAGER: 'Interview has been reset to before manager validation',
        SUCCESS_COLLAB: 'Interview has been reset to before collaborator validation',
        ERROR: 'Error cancelling validation',
      },
      PURGE_CROSS_FEEDBACK: {
        BUTTON_TITLE: 'Purge cross feedbacks',
        BUTTON_TOOLTIP: 'Permanently delete completed cross feedbacks before a date',
        TITLE: 'Purge cross feedbacks',
        WARNING: "<strong>Sensitive and irreversible action.</strong> All <strong>completed cross feedbacks</strong> performed before the chosen date will be permanently deleted, including their attached documents (S3 storage). This action cannot be undone.",
        DATE_LABEL: 'Delete completed cross feedbacks before:',
        DATE_HINT: 'Only cross feedbacks (interviews linked to a parent) whose status is "Completed" and whose interview date is before this date will be deleted.',
        CONFIRM_LABEL: 'To confirm, type the word DELETE:',
        CONFIRM_PLACEHOLDER: 'DELETE',
        CONFIRM_BUTTON: 'Delete permanently',
        SUCCESS: '{{count}} cross feedback(s) deleted successfully',
        ERROR: 'Error deleting cross feedbacks',
      },
      PRIORITY_MODAL: {
        TITLE: 'Priority explanation',
        PRIORITY_LEVEL_LABEL: 'Priority level',
        EXPLANATION_LABEL: 'Explanation',
        TOOLTIP: 'View the priority explanation',
        NO_EXPLANATION: 'No explanation available for now.',
        PRIORITY: {
          NORMAL: 'Normal',
          IMPORTANT: 'Important',
          URGENT: 'Urgent',
        },
      },
      TO_FILL_BY_YOU: 'To be filled by you',
      YOUR_SIGNATURE_REQUIRED: 'Your signature required',
      PENDING_COLLAB_SIGNATURE: 'Pending collaborator signature',
      TO_SIGN_BY_YOU: 'To be signed by you',
      SIGNED_BY_YOU: 'Signed by you',
      LATE: 'Late',
      STATS: {
        IN_PROGRESS: 'Interviews in progress',
        IN_PROGRESS_SHORT: 'in progress',
        LATE: 'Late interviews',
        LATE_SHORT: 'late',
        CURRENT_FILTER_HINT: 'Based on the displayed filters',
        LATE_HINT: 'Planned or pending validation after the expected date',
        CAMPAIGNS_HINT: 'Total for displayed campaigns',
      },
      STATUS_DRAFT: 'Draft',
      STATUS_PLANNED: 'Planned',
      STATUS_STARTED: 'Started',
      STATUS_COMPLETED: 'Completed',
      STATUS_CANCELLED: 'Cancelled',
      STATUS_REVISION: 'CR refused / Under revision',
      FILL_DOCUMENT: 'Fill document',
      REFUSED_NO_REASON: 'No reason provided',
      VIEW_REFUSAL_REASON: 'View refusal reason',
      REFUSAL_REASON_TITLE: 'Refusal Reason',
      CARD_VISIBLE_FOR_COLLABORATOR: 'Card visible for collaborator',
      CARD_VISIBLE_ONLY_FOR_MANAGER: 'Card visible only if collaborator is a manager',
      PARAGRAPH_EDITOR: {
        TOOLBAR: 'Paragraph formatting',
        PLACEHOLDER: 'Write paragraph content...',
        UNDO: 'Undo',
        REDO: 'Redo',
        BOLD: 'Bold',
        ITALIC: 'Italic',
        UNDERLINE: 'Underline',
        STRIKE: 'Strikethrough',
        BULLET_LIST: 'Bullet list',
        ORDERED_LIST: 'Numbered list',
        LINK: 'Add link',
        CLEAR: 'Clear formatting',
        APPLY: 'Apply',
        REMOVE: 'Remove',
        CANCEL: 'Cancel',
        LINK_ERROR: 'Use a relative, HTTPS, fragment, or email link.',
        HINT: 'Select text to apply formatting. Pasted content is cleaned automatically.',
        EDIT: 'Edit',
        DONE: 'Done',
      },
      TARGET: {
        CAN_READ: 'Allow the target to read the interview content',
        MUST_VALIDATE: 'Require the target to validate before the manager',
      },
      WORKFLOW_TAB: 'Interview',
      CARD_TABS: {
        PREVIOUS: 'Previous interview section',
        NEXT: 'Next interview section',
      },
      FILL_WORKFLOW: {
        TITLE: 'Fill the interview',
        COLLABORATOR: 'Collaborator',
        MANAGER: 'Manager',
        SAVE_AND_VALIDATE: 'Save & Validate',
        NO_WORKFLOW: 'No interview available',
        VIEW_ANSWER: 'View answer',
        EDITOR_PLACEHOLDER: 'Click to start writing...',
        PREVIEW_SAVE_AND_PREVIEW: 'Save & Preview',
        PREVIEW_FINALIZE_COLLAB: 'Finalize and send',
        PREVIEW_FINALIZE_MANAGER: 'Finalize and send for signature',
        PREVIEW_PREVIEW_ONLY: 'Preview',
        PREVIEW_AND_VALIDATE: 'Preview and validate',
        PREVIEW_RUN_AI_AUDIT: 'Verifiy',
        AI_AUDIT_IN_PROGRESS: 'AI audit in progress...',
        FINAL_ACCEPT: 'Accept',
        FINAL_REFUSE: 'Refuse',
        FINAL_ACCEPT_SUCCESS: 'Interview accepted successfully',
        FINAL_ACCEPT_ERROR: 'Error while accepting the interview',
        FINAL_REFUSE_SUCCESS: 'Interview refused - Pending manager revision',
        FINAL_REFUSE_ERROR: 'Error while refusing the interview',
        REVISE_AND_RESUBMIT: 'Revise and resubmit',
        REVISE_SUCCESS: 'Interview resubmitted to collaborator for validation',
        REVISE_ERROR: 'Error while resubmitting the revised interview',
        FINAL_DECISION_ACCEPTED: 'Interview accepted by {{name}} on {{date}}.',
        FINAL_DECISION_REFUSED: 'Interview refused by the contributor on {{date}}.',
        MARK_COMPLETED: 'Mark as completed',
        UNMARK_COMPLETED: 'Mark as not completed',
        COMPLETED: 'Completed',
        DRH_REQUEST: 'Request HR meeting',
        DRH_REQUEST_SUCCESS: 'Your HR meeting request has been sent.',
        DRH_REQUEST_ERROR: 'Error while sending HR meeting request.',
      },
      PREVIEW: {
        OPEN: 'Preview document',
        TITLE: 'Interview report',
        DESCRIPTION: 'This is a consolidated view of all questions and answers. This layout is used for PDF export.',
        EXPORT_PDF: 'Export PDF',
        EXPORTING: 'Exporting...',
        DEFAULT_TITLE: 'Interview',
        UNLABELED_FIELD: 'Unlabeled field',
        UNLABELED_OBJECTIVE: 'Unlabeled objective',
        UNLABELED_SKILL: 'Unnamed competency',
        COLLAB_ANSWER: 'Employee answer',
        MANAGER_ANSWER: 'Interview Manager answer',
        OBJECTIVE_INDEX: 'Objective {{number}}',
        NO_ANSWER: 'No answer provided',
        PLACEHOLDER_COLLAB: 'Employee answer will be visible after validation.',
        PLACEHOLDER_MANAGER: 'Interview Manager answer will be visible after validation.',
        ERROR_BUILD: 'Error while building preview.',
        ERROR_EXPORT: 'Error while exporting PDF.',
      },
      VALIDATION: {
        // Manager-created objective years block preview/finalization but not draft autosave.
        VALIDATION_ERROR: 'Validation required',
        MANDATORY_FIELDS_MISSING: 'Please fill in all mandatory fields before previewing:',
        MANDATORY_CONTENT_MISSING: 'Mandatory content is missing',
        CLICK_MISSING_FIELD: 'Click a missing field to jump directly to it.',
        FIELD_REQUIRED: 'This field is required',
        COMMENT_REQUIRED: 'Comment required',
        OBJECTIVE_YEAR_LABEL: 'Reference year',
        OBJECTIVE_YEAR_PLACEHOLDER: 'Select a year',
        OBJECTIVE_YEAR_REQUIRED: 'year required',
        OBJECTIVE_YEAR_LOCKED_HELP: 'Select a reference year to unlock the other objective controls.',
      },
      PDF_HEADER: {
        EMPLOYEE: 'Employee',
        MANAGER: 'Interview Manager',
        CONTRIBUTOR: 'Contributor',
        DATE: 'Interview Date',
      },
      SELECT_DOCS: 'Select documents',
      NO_DOC_AVAILABLE: 'No documents available',
      NO_OBJECTIVES_ADDED: 'No objectives added',
      NO_SKILLS_SELECTED: 'No skills selected',
      NO_USERS_SELECTED: 'No users selected',
      NO_FORMATIONS_SELECTED: 'No training courses selected',
      NO_FORMATIONS_FOUND: 'No training courses found',
      SELECTED_SKILLS: 'Selected Skills',
      SELECTED_FORMATIONS: 'Selected Training Courses',
      SEARCH_FORMATIONS: 'Search for training courses',
      SEARCH_SKILLS: 'Search for skills',
      FORMATION_DEFAULT_NAME: 'Training course',
      SELECT_SIRH_ELEMENT: 'Select an HRIS element',
      SKILLS_INFO: 'Search and add relevant skills for this interview',
      SKILLS_SEARCH_PLACEHOLDER: 'Search for a skill...',
      COMMENT_PLACEHOLDER: 'Add a comment...',
      COMMENT_MANDATORY_PLACEHOLDER: 'Comment required...',
      ADD_SKILL: 'Add skill',
      INVALID_SKILL: 'Invalid skill',
      SKILL_ALREADY_EXISTS: 'This skill has already been added',
      DATA_SAVED_SUCCESS: 'Data saved successfully',
      ERROR_LOADING: 'Error loading data',
      ERROR_SAVING_DATA: 'Error saving data',
        ERROR_SUBMIT: 'Error submitting the interview',
        ERROR_VALIDATE: 'Error validating the interview',
        MANAGER_VALIDATION_WAITING_FOR_COLLABORATOR: 'The collaborator must validate the interview before you can validate it.',
      SUCCESS_SUBMITTED: 'Interview submitted successfully',
      SUCCESS_VALIDATED: 'Interview validated successfully',
      EVALUATE_SKILLS: 'Evaluate Skills',
      ADD_MORE_SKILLS: 'Add More Skills',
      SELECT_LEVEL: 'Select a level',
      SELECT_MIN: 'Select at least {{min}} item(s)',
      SELECT_MAX: 'Select at most {{max}} item(s)',
      SELECT_BETWEEN: 'Select between {{min}} and {{max}} item(s)',
      ENTER_SCORE: 'Enter a score',
      SKILL_SOURCE_ADMIN: 'Selected by admin',
      SKILL_SOURCE_COLLABORATOR: 'Added by collaborator',
      SKILL_SOURCE_MANAGER: 'Added by manager',
      CANNOT_DELETE_ADMIN_SKILL: 'You cannot delete a skill selected by the administrator',
      SKILL_REMOVED: 'Skill removed',
      SKILL_ADDED: 'Skill added successfully',
      // Description controls are shared by manager and collaborator interview views.
      SKILL_DESCRIPTION_SHOW: 'Show skill description',
      SKILL_DESCRIPTION_HIDE: 'Hide skill description',
      SKILL_DESCRIPTION_UNAVAILABLE: 'No description is available for this skill.',
      COLLABORATOR_EVALUATION: 'Collaborator evaluation',
      COLLABORATOR_COMMENT: 'Collaborator comment',
      OBJECTIVE_EVALUATION: 'Evaluation',
      OBJECTIVE_SCOPE_INDIVIDUAL: 'Individual',
      OBJECTIVE_SCOPE_COLLECTIVE: 'Collective',
      OBJECTIVE_ACHIEVEMENT_STATUS: 'Achievement status',
      OBJECTIVE_KPI_METRIC: 'KPI Metric',
      OBJECTIVE_KPI_METRIC_PLACEHOLDER: 'Enter the performance indicator...',
      // Mirror the manager-owned synchronization decision while preserving independently emphasized labels.
      OBJECTIVE_OFFICIAL: 'Official',
      OBJECTIVE_NON_OFFICIAL: 'Non-official',
      OBJECTIVE_OFFICIAL_SWITCH_ARIA: 'Set whether the employee objective is official',
      OBJECTIVE_NON_OFFICIAL_HELP: 'The objective remains informational only and is not added to the employee’s objectives.',
      OBJECTIVE_OFFICIAL_HELP: 'The objective is added to the employee’s objective list. You can edit its title and KPIs before validation.',
      ACHIEVEMENT_NOT_ACHIEVED: 'Not achieved',
      ACHIEVEMENT_PARTIALLY_ACHIEVED: 'Partially achieved',
      ACHIEVEMENT_ACHIEVED: 'Achieved',
      ACHIEVEMENT_EXCEEDED: 'Exceeded',
      EVALUATION_LEVELS: {
        NOT_ACHIEVED: 'Not achieved',
        PARTIALLY_ACHIEVED: 'Partially achieved',
        ACHIEVED: 'Achieved',
        EXCEEDED: 'Exceeded',
      },
      MIN_SELECTIONS_LABEL: 'Minimum Selections',
      MIN_SELECTIONS_HELP: 'Minimum number of selections required (default: 1)',
      MAX_SELECTIONS_LABEL: 'Maximum Selections',
      MAX_SELECTIONS_HELP: 'Maximum number of selections allowed (0 = unlimited)',
      MAX_SELECTIONS_REACHED: 'Maximum of {{max}} selection(s) reached',
      UNLIMITED: 'Unlimited',
      RATING_ALLOW_COMMENT: 'Allow comment',
      SKILLS_EVALUATION_FORMAT: 'Skills evaluation format',
      SKILLS_EVALUATION_FORMAT_DESC: 'Choose the evaluation format that will be used for all "Skill" type fields',
      SKILLS_FORMAT_STARS: 'Stars (star rating)',
      SKILLS_FORMAT_TEXT: 'Text (text options)',
      SKILLS_TEXT_OPTIONS: 'Text evaluation options',
      SKILLS_AUTOSYNC: {
        TITLE: 'Skills synchronization',
        LABEL: 'Automatically sync skills after validation',
        DESC:
          'When an interview is validated, the level of each evaluated skill (1 to 5 rating) updates the collaborator skills repository. If disabled, no skill is modified.',
        ENABLED: 'Enabled',
        DISABLED: 'Disabled',
        SAVED: 'Synchronization option updated',
        LOAD_ERROR: 'Failed to load the synchronization option',
        SAVE_ERROR: 'Failed to save the synchronization option',
        DOMAIN_FILTER_LABEL: 'Filter by domain',
        ALL_DOMAINS: 'All domains',
        DOMAIN_SEARCH_PLACEHOLDER: 'Search and select domains...',
        ALLOWED_DOMAINS_HINT: 'Select the allowed domains for this field. If none are selected, all domains are available. The manager and collaborator can only add skills from the selected domains.',
      },
      AVAILABLE_OPTIONS: 'Available options',
      NEW_OPTION_PLACEHOLDER: 'New option...',
      SELECTED_COUNT: '{{count}} / {{max}} selection(s)',
      DOCUMENT_HEADER_CONFIG: 'Administrative Information',
      DOCUMENT_HEADER_CONFIG_DESC: 'Select the administrative information to display in the generated document.',
      CUSTOM_VALUE: 'Custom value',
      FROM_DATABASE: 'Automatically filled',
      USE_DATABASE: 'Automatically filled',
      USE_CUSTOM_VALUE: 'Custom value',
      CUSTOM_VALUE_LABEL: 'Custom value',
      CUSTOM_VALUE_HELP: 'This value will be displayed for all interviews using this template',
      AUTO_FILLED_INFO:
        'Automatically filled when creating the interview. If data is missing, the field will appear empty.',
      HEADER_FIELD_EMPLOYEE_NAME: 'Employee name',
      HEADER_FIELD_EMPLOYEE_NAME_DESC: 'Full name of the employee (first and last name)',
      HEADER_FIELD_EMPLOYEE_NAME_PLACEHOLDER: 'E.g.: John Doe',
      HEADER_FIELD_EMPLOYEE_FUNCTION: 'Function',
      HEADER_FIELD_EMPLOYEE_FUNCTION_DESC: 'Function or position held by the employee',
      HEADER_FIELD_EMPLOYEE_FUNCTION_PLACEHOLDER: 'E.g.: Full Stack Developer',
      HEADER_FIELD_EMPLOYEE_TITLE: 'Title',
      HEADER_FIELD_EMPLOYEE_TITLE_DESC: 'Professional title of the employee',
      HEADER_FIELD_EMPLOYEE_TITLE_PLACEHOLDER: 'E.g.: Senior Engineer',
      HEADER_FIELD_EMPLOYEE_SITE: 'Site',
      HEADER_FIELD_EMPLOYEE_SITE_DESC: 'Work site or location of the employee',
      HEADER_FIELD_EMPLOYEE_SITE_PLACEHOLDER: 'E.g.: Paris - La Défense',
      HEADER_FIELD_SENIORITY: 'Seniority with employer',
      HEADER_FIELD_SENIORITY_DESC: 'Employee seniority in the company (if data available)',
      HEADER_FIELD_SENIORITY_PLACEHOLDER: 'E.g.: 5 years',
      HEADER_FIELD_SALARY_COEFFICIENT: 'Coefficient (number between 350 and 900)',
      HEADER_FIELD_SALARY_COEFFICIENT_DESC: 'Salary coefficient according to collective agreement',
      HEADER_FIELD_SALARY_COEFFICIENT_PLACEHOLDER: 'E.g.: 450',
      HEADER_FIELD_MANAGER_NAME: 'Manager name',
      HEADER_FIELD_MANAGER_NAME_DESC: 'Full name of the manager responsible for the interview',
      HEADER_FIELD_MANAGER_NAME_PLACEHOLDER: 'E.g.: Mary Smith',
      HEADER_FIELD_INTERVIEW_DATE: 'Interview date',
      CAMPAIGNS: {
        TITLE: 'Interview Campaigns',
        DESCRIPTION: 'Create and manage campaigns to schedule interviews in bulk',
        CREATE_CAMPAIGN: 'Create Campaign',
        EDIT_CAMPAIGN: 'Edit Campaign',
        // Keep campaign mutation fallbacks translated when the failure is unrelated to payroll authorization.
        CREATE_ERROR: 'Unable to create the campaign',
        UPDATE_ERROR: 'Unable to update the campaign',
        CREATE_FIRST_CAMPAIGN: 'Create your first campaign',
        CAMPAIGN_NAME: 'Campaign Name',
        CAMPAIGN_NAME_PLACEHOLDER: 'E.g.: Annual Reviews 2025',
        CAMPAIGN_DESCRIPTION: 'Description',
        CAMPAIGN_DESCRIPTION_PLACEHOLDER: 'Describe the purpose of this campaign...',
        INTERVIEW_TYPE: 'Interview Type',
        SELECT_INTERVIEW_TYPE: 'Select an interview type',
        DOCUMENT_TEMPLATE: 'Document Template',
        SELECT_DOCUMENT_TEMPLATE: 'Select a template (optional)',
        NO_TEMPLATES_AVAILABLE: 'No templates available for this interview type',
        STATUS: 'Status',
        STATUS_ACTIVE: 'Active',
        STATUS_INACTIVE: 'Inactive',
        STATUS_COMPLETED: 'Completed',
        CREATED_BY: 'Created by',
        CREATED_AT: 'Created on',
        INTERVIEWS_COUNT: 'Interviews created',
        DRAFTS: {
          TITLE: 'Draft interviews',
          DESCRIPTION: 'You currently have {{ count }} draft(s) ready to convert.',
          ADD_BUTTON: 'New draft',
          LAUNCH_ALL: 'Launch campaign',
          LOAD_ERROR: 'Unable to load campaign drafts',
          EMPTY_TITLE: 'No drafts yet',
          EMPTY_DESCRIPTION: 'Once you create campaign drafts, they will appear here.',
          CONVERT_BUTTON: 'Convert draft to interview',
          CONVERT_SUCCESS: '{{ count }} interview(s) created from the draft',
          CONVERT_ERROR: 'Unable to convert this draft',
          LAUNCH_SUCCESS: '{{ total }} interview(s) created from drafts',
          LAUNCH_ERROR: 'Unable to launch campaign drafts',
          LAUNCH_CONFIRM_TITLE: 'Launch campaign?',
          LAUNCH_CONFIRM_MESSAGE: 'Launching this campaign will send the emails immediately and the campaign will become locked from further edits. Do you want to continue?',
          LAUNCH_CONFIRM_ACTION: 'Launch now',
          TABLE: {
            COLLABORATOR: 'Collaborator',
            CONTRIBUTOR: 'Contributor',
            CREATED_AT: 'Creation date',
            INTERVIEW_DATE: 'Interview date',
            LOCATION: 'Location',
            INTERVIEW_TYPE: 'Interview type',
            CREATED_BY: 'Created by',
            ACTIONS: 'Actions',
          },
          // Batch actions have distinct labels because they do not launch the entire campaign.
          BULK: {
            SELECTED: '{{ count }} draft(s) selected',
            SELECT_ALL: 'Select all drafts in this campaign',
            SELECT_DRAFT: 'Select draft for {{ target }}',
            EDIT_ACTION: 'Edit selection',
            CONVERT_ACTION: 'Convert selection',
            DELETE_ACTION: 'Delete selection',
            EDIT_TITLE: 'Edit selected drafts',
            EDIT_HELP: 'Check only the fields to change for the {{ count }} selected draft(s). Other values remain unchanged.',
            NON_ATOMIC: 'Drafts are processed one at a time. If one fails, earlier successful changes are kept.',
            TIME: 'Interview time',
            LINK_HELP: 'An empty link clears existing links. On-site meetings also clear video links.',
            SAVE: 'Save changes',
            INVALID_FORM: 'Select at least one field and enter a valid value (notice from 1 to 12 months and an http(s) link).',
            BUSY_DRAFT: 'Wait for the current draft operation to finish before processing the entire selection.',
            DELETE_TITLE: 'Delete selected drafts',
            DELETE_CONFIRM: 'Delete only the selected drafts? Other drafts will not be affected.',
            CONVERT_TITLE: 'Convert selected drafts',
            CONVERT_CONFIRM: 'Convert only the selected drafts to interviews? Calendar invitations and emails may be sent.',
            UPDATE_SUCCESS: '{{ count }} draft(s) updated.',
            UPDATE_PARTIAL: '{{ success }} draft(s) updated, {{ failed }} failed. Failed drafts remain selected.',
            UPDATE_ERROR: 'No selected draft could be updated.',
            DELETE_SUCCESS: '{{ count }} draft(s) deleted.',
            DELETE_PARTIAL: '{{ success }} draft(s) deleted, {{ failed }} failed. Failed drafts remain selected.',
            DELETE_ERROR: 'No selected draft could be deleted.',
            CONVERT_SUCCESS: '{{ count }} interview(s) created from the selection.',
            CONVERT_PARTIAL: '{{ count }} interview(s) created, {{ failed }} draft(s) failed. Failed drafts remain selected.',
            CONVERT_ERROR: 'No selected draft could be converted to an interview.',
            CALENDAR_WARNING: '{{ count }} converted draft(s) had calendar invitations that could not reach every participant.',
            UNEXPECTED_ERROR: 'Processing the selection was interrupted. Refresh the drafts before trying again.',
          },
          IMPORT: {
            // The draft-only wording distinguishes this action from creating or launching a campaign.
            BUTTON: 'Import drafts',
            TITLE: 'Import drafts',
            HELP: 'Automatically creates drafts from an Excel file containing employee / manager pairings.',
            EYEBROW: 'Import with AI',
            FILE: 'Excel file',
            FILE_HELP: 'One XLSX file, up to 10 MB. This import does not send any interviews.',
            INSTRUCTIONS: 'Import instructions for AI',
            INSTRUCTIONS_HELP: 'Specify which sheets to use and any relevant interpretation rules.',
            ANALYZE: 'Analyze',
            ANALYZING: 'Analyzing…',
            QUESTIONS: 'Clarifications needed',
            ANSWER: 'Your answer',
            CONTINUE: 'Continue analysis',
            REVIEW: 'Review drafts',
            INHERITED: 'The type and template are inherited from the campaign.',
            DEFAULTS: 'Notice: 1 month. On-site. Document visible to the employee.',
            SOURCE: 'Excel source',
            EXCLUDED: 'Data excluded according to the instructions',
            APPLY_FIELD: 'Apply: {{ field }}',
            APPLY: 'Apply to rows that are not ignored or created',
            SELECT_ALL: 'Select the {{ count }} ready rows',
            SELECT_ROW: 'Select row {{ row }}',
            IGNORE: 'Ignore',
            RESTORE: 'Restore',
            CREATE_ONE: 'Create this draft',
            CREATE_SELECTED: 'Create drafts',
            COUNTS: '{{ ready }} ready, {{ blocked }} incomplete, {{ ignored }} ignored, {{ created }} created',
            PROGRESS: 'Creating {{ current }} of {{ total }}',
            RESULT: '{{ success }} draft(s) created, {{ failed }} failure(s), {{ unknown }} result(s) to check',
            NO_ROWS: 'No interviews found within the requested scope.',
            UNRESOLVED: 'Select the employee and the manager.',
            MATCH_UNAVAILABLE: 'Automatic matching is unavailable. Select people manually.',
            INVALID_SCHEDULE: 'Enter a valid date and a time in HH:mm format.',
            INVALID_FILE: 'Select a valid XLSX file.',
            UNSAFE_FILE: 'This workbook cannot be read safely. Use a simple XLSX without external content.',
            LIMIT_EXCEEDED: 'The file or result exceeds this import’s limits. Reduce the requested scope.',
            AI_ERROR: 'The analysis failed. No drafts were created by the analysis.',
            ACCESS_ERROR: 'Your session or permissions do not allow this operation.',
            CAMPAIGN_CHANGED: 'The campaign is unavailable or its settings have changed. Reopen the import.',
            LOG_ERROR: 'AI logging is unavailable. The analysis cannot be validated.',
            UNKNOWN_RESULT: 'A creation result is uncertain. Check the campaign drafts before importing again.',
            UNSAVED_WARNING: 'Uncreated rows will be lost when closing this window. Already created drafts will be kept.',
            CLOSE: 'Close',
            CANCEL: 'Cancel',
            STATUS: {
              READY: 'Ready',
              BLOCKED: 'Incomplete',
              IGNORED: 'Ignored',
              CREATING: 'Creating',
              CREATED: 'Created',
              FAILED: 'Failed',
              UNKNOWN: 'To check',
            },
          },
          TARGET_UNKNOWN: 'Unknown target',
          TARGET_SINGLE: 'Specific collaborator',
          TARGET_ALL: 'Entire organisation',
          TARGET_SITE: '{{ total }} site(s) selected',
          TARGET_SERVICE: '{{ total }} service(s) selected',
          TARGET_TEAM: '{{ total }} team(s) selected',
          TARGET_ADMIN_PAIE: 'Payroll administrators',
          TARGET_MANAGER_PAIE: 'Payroll managers',
          TARGET_BADGE_ALL: 'All',
          SHOW_TARGETS: 'View targets',
          HIDE_TARGETS: 'Hide targets',
          SHOW_COLLABORATORS: 'View collaborators',
          TARGET_DETAILS: {
            ALL: 'All collaborators in the company',
            ADMIN_PAIE: 'Payroll administrators',
            MANAGER_PAIE: 'Payroll managers',
            SITE: 'Site',
            SERVICE: 'Service',
            TEAM: 'Team',
            NO_SELECTION: 'No target selected',
            COUNT_LABEL: '{{ total }} person(s)',
            UNKNOWN: 'Unknown (#{{ id }})'
          },
          CREATE_SUCCESS: 'Draft created successfully',
          DELETE_SUCCESS: 'Draft deleted successfully',
          DELETE_ERROR: 'Unable to delete this draft',
          DELETE_CONFIRM_TITLE: 'Delete draft',
          DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete the draft for {{ target }}?',
          MODAL: {
            TITLE: 'Create a draft interview',
            EDIT_TITLE: 'Edit draft interview',
            MISSING_CAMPAIGN: 'Missing campaign context. Please reopen the page.',
            TARGET_TYPE: 'Target type',
            TARGET_SINGLE: 'Single collaborator',
            TARGET_SITE: 'Site(s)',
            TARGET_SERVICE: 'Service(s)',
            TARGET_TEAM: 'Team(s)',
            TARGET_ADMIN_PAIE: 'Payroll administrators',
            TARGET_MANAGER_PAIE: 'Payroll managers',
            TARGET_ALL: 'Entire company',
            TARGET_SELECT: 'Select targets',
            TARGET_CAN_READ: 'Targets can read the document',
            TARGET_MUST_VALIDATE: 'Targets must validate before launch',
            PLACEHOLDER_SINGLE: 'Search for a collaborator',
            PLACEHOLDER_SITE: 'Select one or more sites',
            PLACEHOLDER_SERVICE: 'Select one or more services',
            PLACEHOLDER_TEAM: 'Select one or more teams',
            PLACEHOLDER_ADMIN_PAIE: 'All payroll administrators will be included',
            PLACEHOLDER_MANAGER_PAIE: 'All payroll managers will be included',
            PLACEHOLDER_ALL: 'All collaborators will be included',
            COLLABORATOR: 'Collaborator',
            COLLAB_CAN_READ: 'Collaborator can read and edit the document',
            MANAGER: 'Manager',
            INTERVIEW_TYPE: 'Interview type',
            DOC_TEMPLATE: 'Document template',
            EDIT_DOC: 'Edit document',
            DATE: 'Interview date',
            NOTICE_MONTHS: 'Notice period (months)',
            LOCATION: 'Location',
            LOCATION_ONSITE: 'On site',
            LOCATION_REMOTE: 'Remote',
            LOCATION_FORM: 'Form',
            INTERVIEW_LINK: 'Video link',
            MUST_SIGN: 'Requires electronic signature',
            SAVE: 'Save draft',
            UPDATE: 'Update draft',
            SAVE_SUCCESS: 'Draft saved successfully',
            SAVE_SUCCESS_MULTIPLE: '{{ count }} drafts created successfully',
            SAVE_ERROR: 'Unable to save the draft',
            UPDATE_SUCCESS: 'Draft updated successfully',
            UPDATE_ERROR: 'Unable to update the draft',
            INVALID_FORM: 'Please complete the required fields',
            TARGET_REQUIRED: 'Please select at least one target',
            DEFAULT_TEMPLATE_NAME: 'Document',
            PAYROLL_INFO_ADMIN: '{{ total }} payroll admin(s) will access this campaign.',
            PAYROLL_INFO_MANAGER: '{{ total }} payroll manager(s) will access this campaign.',
          },
        },
        SEARCH_PLACEHOLDER: 'Search for a campaign...',
        NO_CAMPAIGNS: 'No campaigns created yet',
        NO_RESULTS: 'No campaigns match your search',
        LOCKED_EDIT_FORBIDDEN: 'This campaign has already been launched and can no longer be edited.',
        EXPORT: {
          BUTTON: 'Export campaign',
          SUCCESS: 'Campaign exported successfully',
          ERROR: 'Unable to export this campaign',
          EMPTY: 'No interview data is available for export',
          WARNING: '{{ count }} interview(s) could not be exported completely',
          DEFAULT_SHEET_TITLE: 'Interview card',
          SHEET_SUMMARY: '{{ count }} interview(s) grouped in this card',
          PERSON_BLOCK_TITLE: 'Interview #{{ index }}',
          CONTENT_TITLE: 'Card content',
          HEADER: {
            INTERVIEW_TYPE: 'Interview type',
            STATUS: 'Status',
            SENIORITY_VALUE: '{{ count }} {{ suffix }}',
          },
          COLUMNS: {
            QUESTION: 'Question',
            COLLABORATOR: 'Employee answer',
            MANAGER: 'Interview manager answer',
          },
        },
        TABS: {
          DRAFTS: 'Drafts',
          INTERVIEWS: 'Interviews',
        },
        ANALYZE_WITH_TOM: 'Analyze with Tom',
        FILTERS_TITLE: 'Analysis Filters',
        FILTER_CAMPAIGN: 'Campaign',
        FILTER_SERVICE: 'Service',
        FILTER_TEAM: 'Team',
        FILTER_MANAGER: 'Manager',
        FILTER_INTERVIEW_TYPE: 'Interview Type',
        FILTER_SUMMARY: 'Applied Filters',
        START_ANALYSIS: 'Start Analysis',
        ANALYZING: 'Analyzing...',
        ANALYSIS_RESULT: 'Analysis Results',
        ANALYSIS_CAMPAIGN_NAME: 'Campaign Name',
        TOTAL_INTERVIEWS: 'Total Interviews',
        APPLIED_FILTERS: 'Applied Filters',
        TOM_WELCOME_TITLE: 'Campaign copilot',
        TOM_WELCOME_BODY: 'I am ready to analyze {{campaign}}. Adjust the filters on the left, then ask a question or launch a global analysis.',
        TOM_ALL_CAMPAIGNS: 'All campaigns',
        TOM_ALL_CAMPAIGNS_FILTER_REQUIRED: 'When analyzing all campaigns, at least one additional filter is required.',
        TOM_SINGLE_CAMPAIGN_FILTER_REQUIRED: 'When analyzing a single campaign, at least one additional filter is required.',
        TOM_REQUIRED_FILTERS_NOTE: 'Campaign selection is required. To start Tom, choose at least one of these filters: service, team, or manager. Interview type remains optional.',
        TOM_FILTERS_SUBTITLE: 'Filters are applied before the AI call, not only in the display.',
        TOM_FILTER_CHANGE_CONFIRM_TITLE: 'Reset Tom conversation?',
        TOM_FILTER_CHANGE_CONFIRM: 'Changing these filters will reset the current conversation with Tom. Do you want to continue?',
        TOM_FILTER_CHANGE_CONFIRM_ACTION: 'Reset conversation',
        TOM_FILTER_CHANGE_CANCEL_ACTION: 'Keep current filters',
        TOM_DEFAULT_PROMPT: 'Analyze this campaign with the current filters.',
        TOM_FILTERED_INTERVIEWS_COUNT: '{{count}} filtered interviews',
        TOM_SUGGESTED_PROMPTS: 'Suggested prompts',
        TOM_PROMPT_SUMMARY: 'Summarize the main themes in this campaign.',
        TOM_PROMPT_MANAGERS: 'Which managers need attention first?',
        TOM_PROMPT_RISKS: 'What risks appear across teams?',
        TOM_PROMPT_ACTIONS: 'Suggest 3 actions for HR and managers.',
        TOM_HIGHLIGHTS: 'Key signals',
        TOM_PATTERNS: 'Patterns',
        TOM_RISKS: 'Risks',
        TOM_RECOMMENDATIONS: 'Recommended actions',
        TOM_COVERAGE: 'Coverage and limits',
        TOM_INPUT_PLACEHOLDER: 'Ask Tom a follow-up question about this campaign...',
        TOM_INPUT_HINT: 'Tom answers only from the filtered campaign data.',
        TOM_RESPONDING: 'Tom is analyzing the filtered interviews...',
        TOM_SEND: 'Send',
        TOM_CLEAR_FILTERS: 'Clear',
        TOM_FILTERS_LOAD_ERROR: 'Unable to load analysis filters',
        TOM_ERROR_MESSAGE: 'Tom could not complete the analysis. Please try again.',
        TOM_EMPTY_CAMPAIGN: 'No interviews to analyze',
        SELECT_CAMPAIGN_TO_ANALYZE: 'Select a campaign to analyze',
        SELECT_CAMPAIGN_DESCRIPTION: 'Choose the campaign you want to analyze with Tom.',
        NO_CAMPAIGNS_WITH_INTERVIEWS: 'No campaigns with interviews available for analysis',
      },
      CROSS_FEEDBACK: {
        TITLE: 'Cross Feedback',
        DEADLINE_LABEL: 'Deadline to complete the cross feedback',
        DOCUMENT_NAME: 'Document',
        COLLABORATOR: 'Employee',
        RESPONSABLE: 'Manager',
        CONTRIBUTEUR: 'Contributor',
        DATE: 'Date',
        STATUS: 'Status',
        NOT_CREATED: 'Not created',
        SELECT_COLLABORATOR: 'Select an employee',
        SELECT_RESPONSABLE: 'Select a manager',
        CREATE: 'Create',
        CREATE_INTERVIEW: 'Create interview',
        VIEW_INTERVIEW: 'View interview',
        REMOVE_INTERVIEW: 'Remove interview',
        CREATE_ALL: 'Create all interviews',
        SEND_ALL: 'Send all interviews',
        CREATE_NEW_INTERVIEW: 'Request a feedback',
        SUGGEST_MANAGERS: 'Suggest contributors',
        INTERVIEW_TYPE: 'Interview type',
        DOCUMENT_TEMPLATE: 'Document template',
        SELECT_MANAGERS: 'Select contributors',
        SEARCH_MANAGER: 'Search contributors',
        SEND_INTERVIEWS: 'Send requests',
        ERROR_NO_CONFIG: 'Missing configuration for cross interviews. Please contact your administrator.',
        ERROR_NO_TEMPLATE: 'No document template configured for this cross feedback.',
        ERROR_NO_TYPE: 'No interview type configured for this cross feedback.',
        ADD_INTERVIEW: 'Add an interview',
        NO_DOCUMENTS: 'No documents configured for this cross interview',
        STATUS_PLANNED: 'Planned',
        STATUS_SCHEDULED: 'Scheduled',
        STATUS_IN_PROGRESS: 'In Progress',
        STATUS_COLLAB_SUBMITTED: 'Submitted by Employee',
        STATUS_MANAGER_VALIDATED: 'Validated by Manager',
        STATUS_CANCELED: 'Canceled',
        STATUS_REFUSED: 'Refused',
        STATUS_REQUESTED: 'Requested',
        STATUS_RECEIVED: 'Received',
        ERROR_MISSING_INFO: 'Please provide employee, manager and date',
        ERROR_CREATE: 'Error creating cross feedback interview. Please try again.',
        ERROR_CREATE_WITH_MANAGER: 'Error creating cross feedback for {{manager}}. Please try again.',
        SUCCESS_CREATED: 'Interview created successfully',
        SUCCESS_CREATED_ALL: '{{count}} interview(s) created successfully',
        NO_INTERVIEWS_TO_CREATE: 'No interviews to create',
        NO_TYPES_CONFIGURED: 'No interview types configured for this card',
        INTERVIEW_ADDED: 'Interview added successfully',
        INTERVIEW_REMOVED: 'Interview removed successfully',
        CANNOT_REMOVE_CREATED: 'Cannot remove an already created interview',
        DELETE_INTERVIEW: 'Delete interview',
        CONFIRM_DELETE: 'Are you sure you want to delete the cross interview for {{manager}}?',
        SUCCESS_DELETED: 'Cross interview deleted successfully',
        ERROR_DELETE: 'Error deleting cross feedback interview. Please try again.',
        ERROR_DELETE_WITH_MANAGER: 'Error deleting cross feedback for {{manager}}. Please try again.',
        ERROR_NOT_FOUND: 'Cross feedback interview not found. It may have been already deleted.',
        ERROR_CANNOT_DELETE: 'Cannot delete this interview. Only planned or scheduled interviews can be deleted.',
        SUGGEST_MANAGERS_TITLE: 'Suggest Contributors',
        SUGGEST_MANAGERS_DESC:
          'You can suggest contributors for cross interviews. Your manager will be able to see your suggestions.',
        SAVE_SUGGESTIONS: 'Save Suggestions',
        SUGGESTIONS_SAVED: 'Suggestions saved successfully',
        COLLAB_SUGGESTIONS: 'Employee Suggestions',
        SELECT_ALL: 'Select All',
        SUGGESTION_SELECTED: '{{name}} added to selection',
        SUGGESTION_DESELECTED: '{{name}} removed from selection',
        ALREADY_SELECTED: '{{name}} is already selected',
        ALL_SUGGESTIONS_SELECTED: '{{count}} suggestion(s) added to selection',
        ALL_SUGGESTIONS_DESELECTED: '{{count}} suggestion(s) removed from selection',
        ALL_ALREADY_SELECTED: 'All suggestions are already selected',
        ERROR_INVALID_DATE: 'Invalid date selected for cross feedback deadline.',
        ERROR_DATE_PAST: 'The date cannot be in the past',
        ERROR_DATE_EXCEEDS_PARENT: 'The date cannot exceed the parent interview date',
        UPDATE_DATE: 'Update date',
        UPDATE_DATE_SUCCESS: 'Cross feedback date updated successfully',
        UPDATE_DATE_ERROR: 'Error updating the cross feedback date. Please try again.',
        RELAUNCH_INTERVIEW: 'Send a reminder',
        RELAUNCH_SUCCESS: 'Reminder sent to {{manager}} successfully',
        RELAUNCH_SKIPPED: 'The reminder was not sent because the recipient account is inactive or reminder emails are disabled.',
        RELAUNCH_ERROR: 'Error relaunching the contributor. Please try again.',
        // Labels for the anonymous AI cross-feedback report.
        SUMMARY_TITLE: 'Cross-feedback report',
        SUMMARY_GENERATE: 'Generate AI report',
        SUMMARY_GENERATED: 'The AI report has been generated.',
        SUMMARY_GENERATE_ERROR: 'Unable to generate the AI report.',
        SUMMARY_SAVED: 'The report was saved as a private draft.',
        SUMMARY_SAVE_ERROR: 'Unable to save the report.',
        SUMMARY_SHARE: 'Share with the collaborator',
        SUMMARY_SHARED: 'The report was shared with the collaborator.',
        SUMMARY_SHARE_ERROR: 'Unable to share the report.',
        SUMMARY_SHARED_BADGE: 'Shared',
        SUMMARY_PRIVATE_BADGE: 'Private draft',
        SUMMARY_ANONYMOUS_NOTICE: 'This report is anonymous and must not identify contributors.',
      },

      EDIT: {
        dateAutorisationDemande: 'Authorization date or authorization request date',
        titreAutorisation: 'Authorization title',
        numeroOrdreTitre: 'Title order number',
        dateDelivranceTitre: 'Title issue date',
        dateExpirationTitre: 'Title expiration date',
      },
    },

    SUIVITEMPSPARAMETRE: {
      ENATTENTEINS: 'Waiting for registration',

      ACTIF: 'Active',
      ENATTENTE: 'Pending',
      PARAMETRE: 'Time Tracking Setup',
      AUTOVALIDATION: 'Auto validation of times',
      TEXT1: '',
      EXIGERVALIDATION: 'Who is authorized to validate and report times',
      TEXT2: '',
      RESPONSABLEEQUIPE: 'Team leader',
      RESPONSABLESERVICE: 'Service manager',
      RESPONSABLESITE: 'Site manager',
      MANAGER: 'Manager',
      EXIGERVALIDATIONPAUSE: 'Require break validation',
      TEXT3:
        'If enabled, breaks declared by employees will need to be manually validated. Select the level of responsibility for this validation: Team Leader, Department Manager, Site Manager or Manager.',
      //Who is authorized to declare working hours
      QUIESTAUTORISE: 'Who is authorized to declare working hours',
      TEXT4:
        'Define employees or groups of employees who have permission to declare their working hours. This can include all employees or a specific group depending on company needs.',
      //Dashboard display
      DASHBOARDAFFICHAGE: 'Employees can record their hours directly ',
      TEXT5: 'If enabled, employees can record their hours directly. If disabled, this feature will not be available.',
      //Auto-validate declarations within normal working hours
      AUTOVALIDATIONHORAIRES: 'Auto-validate declarations that fall within normal working hours',
      TEXT6:
        "If enabled, a time declaration is automatically validated as soon as the declared hours fall within the employee's habitual working hours (Work schedule list) and they are not on approved leave that day. Otherwise, it remains pending manual validation.",
      ACTIVER_POINTEUSE: 'Enable the time clock for selected contract types',
      POINTEUSE_CONTRACT_INFO:
        'Only employees with one of these contract types at this site will have access to the time clock.',
      // Site-specific settings
      SITE_SETTINGS: 'Site-specific settings',
      SITE_SETTINGS_INFO: 'Configure which sites can display the time clock and which contract types are authorized',
      SELECT_SITE: 'Select a site',
      SELECT_SITE_PLACEHOLDER: '-- Choose a site --',
      SELECT_CONTRACT_TYPES: 'Authorized contract types',
      SAVE_SITE_SETTINGS: 'Save',
      REMOVE_SITE_SETTINGS: 'Remove',
      CONFIGURED_SITES: 'Configured sites',
      SELECT_SITE_ERROR: 'Please select a site',
      SELECT_CONTRACT_ERROR: 'Please select at least one contract type',
      NOMBRE_JOURS_ANNUEL: 'Working days under flat-rate agreement',
      NOMBRE_JOURS_ANNUEL_PLACEHOLDER: '260',
      NOMBRE_JOURS_ERROR: 'Please enter a valid number of days (between 1 and 366)',
      MAX_JOURS_CONSECUTIFS: 'Maximum consecutive working days not to exceed',
      MAX_JOURS_CONSECUTIFS_PLACEHOLDER: '6',
      MAX_JOURS_CONSECUTIFS_ERROR: 'Please enter a valid number of consecutive days (between 1 and 365)',
      JRTT_DISCLAIMER: 'The number of JRTT days are not automatic',
      // RTT Management
      RTT_MANAGEMENT: 'RTT Management',
      RTT_MANAGEMENT_INFO: 'Manage working days, paid leave and RTT count by site and group',
      SELECT_YEAR: 'Select a year',
      SITE: 'Site',
      GROUPE: 'Group',
      JOURS_TRAVAILLES_FORFAIT: 'Working days under flat-rate',
      CONGES_PAYES: 'Paid leave',
      NOMBRE_RTT: 'Number of RTT',
      ACTIONS: 'Actions',
      NO_RTT_DATA: 'No RTT data available for this year',
      RTT_MISSING_HOLIDAYS: 'No public holidays found for this site — check the site country code',
      // Time entry reminders
      RAPPEL_TITLE: 'Time entry reminders',
      RAPPEL_INFO: 'Configure how often employees receive a reminder to fill in their working hours',
      RAPPEL_FREQUENCE: 'Reminder frequency',
      RAPPEL_JAMAIS: 'Never',
      RAPPEL_QUOTIDIEN: 'Every day',
      RAPPEL_HEBDO: 'Every week',
      RAPPEL_MENSUEL: 'Every month',
      RAPPEL_JOUR_SEMAINE: 'Day of the week',
      RAPPEL_JOURS_AVANT: 'Days before the last working day of the month',
      RAPPEL_JOURS_AVANT_SUFFIX: 'days before the last working day',
      RAPPEL_HEURE: 'Send time',
      LUNDI: 'Monday',
      MARDI: 'Tuesday',
      MERCREDI: 'Wednesday',
      JEUDI: 'Thursday',
      VENDREDI: 'Friday',
      SAMEDI: 'Saturday',
      DIMANCHE: 'Sunday',
    },
    AUTH,
    REMUNERATION: {
      ...REMUNERATION_TRANSLATIONS,
      TITLE: 'Compensation management',
      BTN_COLUMNS: 'Column order',
      BTN_TABS: 'Tabs',
      BTN_REPORTING: 'Reporting',
      BTN_EXPORT: 'Export',
      BTN_ADD_COLUMN: 'Add a column',
      BTN_RESET_WIDTHS: 'Reset widths',
      SETTINGS: {
        TITLE: 'Compensation Settings',
        DESCRIPTION: 'Manage payroll administrators who have access to all company compensation data.',
        VISIBILITY_SETTINGS: 'Display Settings',
        VISIBLE_COLLABORATEUR: 'Show "My Compensation" to employees',
        VISIBLE_COLLABORATEUR_DESC: 'When enabled, employees can view their compensation',
        VISIBLE_MANAGER: 'Show "Compensation Management" to managers',
        VISIBLE_MANAGER_DESC: 'When enabled, managers can access compensation management for their teams',
        HIDE_MONTHLY_VIEW_MANAGER: 'Hide monthly view for payroll managers',
        HIDE_MONTHLY_VIEW_MANAGER_DESC: 'Payroll managers will only see the annual view',
        HIGHLIGHT_EDITABLE_COLUMNS: 'Highlight editable columns',
        HIGHLIGHT_EDITABLE_COLUMNS_DESC: 'Display editable column values with a yellow color',
        DEFAULT_YEAR_MANAGER: 'Default year for managers',
        DEFAULT_YEAR_MANAGER_DESC: 'Set the default year displayed for payroll managers',
        DEFAULT_YEAR_UPDATED: 'Default year updated successfully',
        MANAGERS: 'Compensation Managers',
        ADMIN_PAIES: 'Payroll Administrators',
        SELECT_USER_ADMIN: 'Select a user to add as payroll administrator',
        CHOOSE_USER: 'Choose a user',
        ADD_ADMIN: 'Add Payroll Admin',
        NO_ADMIN_PAIES: 'No payroll administrators configured',
        SELECT_COLLABORATOR: 'Select a collaborator',
        CHOOSE_COLLABORATOR: 'Choose a collaborator',
        SELECT_MANAGER: 'Select a manager',
        CHOOSE_MANAGER: 'Choose a manager',
        ADD_MANAGER: 'Add Manager',
        NO_MANAGERS: 'No managers configured',
        COLLABORATOR: 'Collaborator',
        MANAGER: 'Manager',
        LAST_UPDATE: 'Last update',
        SELECT_USER: 'Please select a user',
        SELECT_COLLAB_MANAGER: 'Please select a collaborator and a manager',
        ADMIN_ADDED: 'Payroll administrator added successfully',
        ADMIN_REMOVED: 'Payroll administrator removed successfully',
        MANAGER_ADDED: 'Manager added successfully',
        MANAGER_REMOVED: 'Manager removed successfully',
        CONFIRM_REMOVE_ADMIN: 'Remove this payroll administrator?',
        CONFIRM_REMOVE_ADMIN_DESC:
          'Are you sure you want to remove this payroll administrator? This action cannot be undone.',
        CONFIRM_REMOVE_MANAGER: 'Remove this employee?',
        CONFIRM_REMOVE_MANAGER_DESC:
          'Are you sure you want to remove this employee from your list of managed employees for the Compensation module?',
        CONFIRM_REMOVE_MANAGER_COLLAB:
          'Are you sure you want to remove {{name}} from your list of managed employees for the Compensation module?',
        MANAGED_EMPLOYEES_MODULE: 'List of Managed Employees - Compensation Module',
        NO_MANAGED_EMPLOYEES: 'No managed employees for the Compensation module',
        CONTRACT_VISIBILITY: 'Visible Contracts',
        CONTRACT_VISIBILITY_DESC: 'Select the contract types that will be visible in compensation management',
        NO_CONTRACTS: 'No contracts available',
        CONTRACTS_SELECTED: 'contract(s) selected',
        SUPER_MANAGER_PAIES: 'Super Payroll Manager',
        SUPER_MANAGER_ADDED: 'User successfully added as super payroll manager',
        SUPER_MANAGER_REMOVED: 'User successfully removed from super payroll managers',
      },
      LOADING: {
        DEFAULT: 'Loading...',
        FETCHING_DATA: 'Fetching data...',
        PROCESSING_DATA: 'Processing data...',
      },
      FILTERS: {
        VIEW_TYPE: 'View type',
        MONTHLY: 'Monthly',
        YEARLY: 'Yearly',
        YEAR: 'Year',
        START_DATE: 'Start date',
        END_DATE: 'End date',
        ALL_SERVICES: 'All services',
        SERVICES_SELECTED: 'service(s) selected',
        SELECT_SERVICES: 'Select services',
        CLEAR_SELECTION: 'Clear selection',
        SELECT_ALL: 'Select all',
        SEARCH_PLACEHOLDER: 'Search',
        ALL_SITES: 'All sites',
      },
      PAGINATION: {
        ROWS_PER_PAGE: 'Rows per page',
        SHOWING: 'Showing',
        TO: '-',
        OF: 'of',
        RESULTS: 'result',
        RESULTS_PLURAL: 'results',
        FILTERED_ON: 'filtered on',
      },
      TABLE: {
        MATRICULE: 'Employee ID',
        LAST_NAME: 'Last name',
        FIRST_NAME: 'First name',
        SITE_COUNTRY_FLAG: 'Site country',
        EMPTY: 'No data available yet',
        COLUMN_FIXED_SALARY: 'Fixed salary N-1 (2025) in €',
        COLUMN_FIXED_EVAL: '% fixed salary evaluation',
        COLUMN_LOCAL_CURRENCY: 'Fixed salary N-1 (2025) in local currency',
        COLUMN_BONUS_EVAL: '% bonus evaluation',
        COLUMN_VARIABLE_PAY: 'Variable pay',
        COLUMN_STOCK_VALUE: 'Stock value',
        COLUMN_ALLOWANCE: 'Allowances',
        COLUMN_PERFORMANCE_INDEX: 'Performance index',
        COLUMN_COMMISSION: 'Commission',
        COLUMN_PAY_FREQUENCY: 'Pay frequency',
      },
      CORE_INFO: {
        TITLE: 'CORE employee information',
        TOGGLE_LABEL: 'Show details',
      },
      SUMMARY: {
        COLUMN_NAME: 'Column name',
        SUM: 'Sum',
        AVERAGE: 'Average',
      },
      EDIT_MONTHLY_VALUE: 'Edit monthly value',
      EDIT_PERIOD_VALUES: 'Edit period values',
      VALUE: 'Value',
      ENTER_VALUE: 'Enter a value',
      UNSAVED_CHANGES_TITLE: 'Unsaved Changes',
      UNSAVED_CHANGES_MESSAGE: 'You have unsaved changes. If you continue, these changes will be lost.',
      UNSAVED_CHANGES_HINT: 'Click "Save" at the top of the page to save your changes before changing views.',
      DISCARD_CHANGES: 'Discard Changes',
      VALIDATION: {
        MUST_BE_NUMBER: 'Value must be a valid number',
        MUST_BE_DATE: 'Value must be a date in YYYY-MM-DD format',
        INVALID_DATE: 'The entered date is not valid',
      },
      COLUMN: 'Column',
      MONTH: 'Month',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      ADD_PERIOD: 'Add period',
      ADD_FIRST_PERIOD: 'Add first period',
      NO_PERIODS: 'No periods defined',
      PERIOD_OVERLAP_ERROR: 'This period overlaps with another period',
      EXPORT: {
        FILENAME: 'Compensations',
        SHEET_NAME: 'Compensations',
        SUMMARY: 'Summary',
        SUCCESS: 'Table exported successfully',
        ERROR: 'Error exporting table',
      },
      SUMMARY_AVERAGE: {
        INCLUDE_ZEROS: 'Include zero values in averages',
        HELP: 'Enterprise-wide preference for green summary tables only.',
        ADMIN_ONLY: 'Only enterprise administrators can change this preference.',
        LOADING: 'Loading the enterprise preference...',
        SAVING: 'Saving the enterprise preference...',
        SAVED: 'The enterprise average preference was saved.',
        UNAVAILABLE: 'Averages are unavailable until the saved preference is confirmed. Reload the page.',
        LOAD_ERROR: 'The enterprise average preference could not be loaded. Reload the page.',
        SAVE_ERROR: 'Saving the enterprise average preference could not be confirmed. Reload the page before trying again.',
      },
      DELETE_COLUMN: {
        TITLE: 'Delete column',
        BUTTON: 'Delete column',
        DESCRIPTION: 'This permanently removes the column from every tab of your enterprise, along with its stored monthly and period values, notes, and tab settings. Referenced columns cannot be deleted; saved documents and interview snapshots are not erased.',
        IRREVERSIBLE: 'This action cannot be undone.',
        CONCURRENCY_NOTICE: 'Delete only when no remuneration import or update is running.',
        NAME_CONFIRM_LABEL: 'Type the displayed column name to confirm:',
        CONFIRM: 'Delete',
        IN_PROGRESS: 'Deleting...',
        SUCCESS: 'The column and its stored remuneration values were deleted.',
        ERROR: 'Deletion could not be confirmed. Refresh the column list before trying again.',
        DEPENDENCIES: 'This column is still used by other calculations, references, or documents. Remove those references before deleting it.',
        SHARED: 'A shared column definition cannot be deleted for one enterprise.',
        NOT_ALLOWED: 'Only payroll administrators can permanently delete an enterprise-owned column.',
        UNAVAILABLE: 'Select an enterprise-owned column and wait for any current operation to finish. Payroll administrator access is required.',
        UNSUPPORTED_SCHEMA: 'Related data could not be checked safely. Deletion was stopped; contact your administrator.',
        NOT_FOUND: 'This column is no longer available. Refresh the column list.',
        NAME_MISMATCH: 'Enter the displayed column name exactly to confirm deletion.',
        UNCONFIRMED: 'Deletion could not be confirmed. Do not assume the data was removed; refresh the column list before retrying.',
      },
      REORGANIZE: {
        TITLE: 'Reorganize your columns',
        DESCRIPTION:
          'Drag categories or columns to change their order. Columns stay within their current category.',
        SCOPE_SUMMARY: 'Columns: this tab. Categories: all tabs of your enterprise.',
        HELP: 'Help',
        COLUMN_COUNT: 'Columns: {{count}} (including hidden columns)',
        DRAG_CATEGORY: 'Drag to reorder this category',
        DRAG_COLUMN: 'Drag to reorder within this category',
        EXPAND_CATEGORY: 'Expand {{name}}',
        COLLAPSE_CATEGORY: 'Collapse {{name}}',
        EDIT_CATEGORY: 'Rename category: {{name}}',
        EDIT_COLUMN: 'Rename column: {{name}}',
        CATEGORY_NAME: 'Category name',
        COLUMN_NAME: 'Column name',
        YEAR_SELECTED: 'Selected year',
        YEAR_PREVIOUS: 'Previous year',
        YEAR_TWO_YEARS_BEFORE: 'Two years earlier',
        YEAR_NEXT: 'Following year',
        YEAR_BEFORE_COUNT: '{{count}} years earlier',
        YEAR_AFTER_COUNT: '{{count}} years later',
        YEAR_TEXT_BEFORE: 'Text before the year',
        YEAR_TEXT_BETWEEN: 'Text between the years',
        YEAR_TEXT_AFTER: 'Text after the year',
        YEAR_PREVIEW: 'Preview:',
        YEAR_RULE_HELP: 'The year follows the selected period. Edit the surrounding text, then click Save.',
        YEAR_PREVIEW_UNAVAILABLE: 'The preview will be available when the selected year is loaded.',
        YEAR_LABEL_UNSUPPORTED: 'The automatic year for this label could not be read. Its name has not been changed.',
        YEAR_LABEL_INVALID: 'Use these fields only to rename the text. The automatic year cannot be changed here.',
        SUPER_CATEGORY: 'Section',
        NO_SUPER_CATEGORY: 'No section',
        SUPER_CATEGORY_HELP: 'Use the pen icon to rename a section, category, or column, then click Save.',
        EDIT_SUPER_CATEGORY: 'Rename section: {{name}}',
        SUPER_CATEGORY_NAME: 'Section name',
        INVALID_SUPER_CATEGORY_NAME: 'Enter a section name.',
        SUPER_CATEGORY_NAME_EXISTS: 'Another section already uses this name. Choose a different name.',
        SUPER_CATEGORY_SCOPE_REQUIRED: 'Section information could not be loaded correctly. Close and reopen this window before trying again.',
        SUPER_CATEGORY_SAVE_ERROR: 'Some changes could not be saved. Keep this window open and click Save again to finish renaming the section. Changes already saved are kept.',
        BTN_CONFIRM: 'Confirm',
        SUCCESS: 'Columns reorganized successfully',
        HIDDEN_COLUMN: 'Hidden column',
        SELECT_TAB: 'Select a tab before reorganizing its columns.',
        DUPLICATE_CONFIGURATION: 'Duplicate category or column settings must be reviewed before reorganizing this tab.',
        SCOPE_HELP: 'Column changes apply only to this tab. Category and section changes also apply to other tabs where they appear.',
        INVALID_ORDER: 'Enter a valid whole-number order.',
        SAVE_ERROR: 'Not all changes could be saved. Some may already be saved; review your changes before retrying.',
      },
      COLUMN_MANAGEMENT: {
        TITLE: 'Column Management',
        REORGANIZE: 'Reorder columns',
        ADD: 'Add Column',
        PARAMETERIZE: 'Configure tabs',
        EDIT: 'Edit Column',
      },
      PARAM_COLUMN: {
        TITLE: 'Configure tabs',
        DESCRIPTION: 'Select a column and define its display settings for the chosen tab.',
        SELECT_REQUIRED: 'Please select a column and a tab',
        SELECT_COLUMN: 'Select a column',
        SELECT_COLUMN_PLACEHOLDER: 'Choose a column...',
        SELECT_ONGLET: 'Select a tab',
        SELECT_ONGLET_PLACEHOLDER: 'Choose a tab...',
        SECTION_GENERAL: 'General information',
        LABEL: 'Label',
        ORDER: 'Order',
        SECTION_VISIBILITY: 'Visibility',
        HIDDEN_COLUMN: 'Hidden column',
        VISIBLE_BY_MANAGERS: 'Visible by managers',
        EDITABLE_BY_MANAGERS: 'Editable by managers',
        HISTORICAL_EDITING_DISABLED: 'This editing option is disabled for historical columns.',
        VISIBLE_BY_COLLABORATORS: 'Visible by collaborators',
        VISIBLE_IN_SUMMARY: 'Visible in employee summary card',
        SECTION_CALCULATION: 'Calculation',
        AUTO_SUM: 'Automatic sum',
        LABEL_SUM: 'Sum label',
        AUTO_AVERAGE: 'Automatic average',
        LABEL_AVERAGE: 'Average label',
        BTN_SAVE: 'Save',
        SUCCESS: 'Settings saved successfully',
        ERROR: 'Error saving settings',
        COLUMN_AVAILABLE: 'Column available in tab',
        DELETE_SUCCESS: 'Column removed from tab successfully',
        DELETE_ERROR: 'Error removing column from tab',
        LOAD_REQUIRED: 'Load the settings for the selected column and tab before saving.',
        DUPLICATE_CONFIGURATION: 'Multiple settings exist for this column and tab. They must be reviewed before saving.',
        INVALID_ORDER: 'Enter a whole-number order between -32768 and 32767. Clearing an existing order is not supported here.',
        INVALID_LABEL: 'Enter a nonempty column label.',
        INVALID_COLOR: 'Enter a valid hexadecimal color. Clearing an existing color is not supported here.',
      },
      EDIT_COLUMN: {
        TITLE: 'Edit Column',
        METADATA_BASELINE_REQUIRED: 'Reselect the column before saving so its existing settings can be preserved.',
        DESCRIPTION: 'Edit the column definition. Manage tab-specific display settings in Configure tabs.',
        BASE_NAME: 'Default name',
        NAME_PLACEHOLDER: 'e.g. Proposed bonus',
        SEARCH: 'Search by name or column code',
        STANDARD_COLUMN: 'Standard',
        DEFINITION_SCOPE: 'Changes apply to this column across tabs. Existing tab customizations are kept.',
        RUBRIC_HELP: 'Changing this code can affect payroll mappings and calculations that use it.',
        LOAD_ERROR: 'Column settings could not be loaded. Close and reopen this window to try again.',
        BASE_VALUES_UNAVAILABLE: 'The original column settings are unavailable or inconsistent. Reselect the column before saving.',
        SELECT_REQUIRED: 'Select the column you want to edit.',
        SHARED_READ_ONLY: 'This standard column cannot be modified here. Its display can be customized in Configure tabs.',
        OWNERSHIP_UNKNOWN: 'Editing availability could not be verified. Reopen this window after the settings have been loaded.',
        SAVE_ERROR: 'The changes could not be saved. Your draft has been kept.',
        CATEGORY_CREATED_RETRY: 'The category was created, but the column could not be saved. Retry Save to finish without creating another category.',
        CREATION_UNCONFIRMED: 'The creation result could not be confirmed. Close and reopen this window, then check whether the item already exists before creating it again.',
        ATTACHMENT_RETRY: 'The column was created, but its tab settings could not be saved. Retry to finish; closing this window will not undo the created column.',
        RETRY_ATTACHMENT: 'Retry tab settings',
        SAVING: 'Saving...',
        NO_CHANGES: 'No changes to save.',
        SELECT_COLUMN: 'Select column',
        SELECT_PLACEHOLDER: 'Choose a column to edit...',
        NEW_NAME: 'New name',
        BTN_SAVE: 'Save',
      },
      ADD_COLUMN: {
        TITLE: 'Add custom column',
        DESCRIPTION:
          'Add a new column to the table, integrating it into an existing category or creating a new category to organize it.',
        SECTION_GENERAL: 'General Information',
        SECTION_CATEGORY: 'Category',
        SECTION_VISIBILITY: 'Visibility',
        SECTION_CALCULATION: 'Calculation',
        COLUMN_NAME: 'New column name',
        INSERT_YEAR_TOKEN: 'Insert year',
        INSERT_YEAR_TOKEN_HELP: 'Use {{token}} in the text to place the year exactly where you want.',
        DYNAMIC_YEAR_DISPLAY: 'Dynamic display',
        DYNAMIC_YEAR_DISPLAY_TOGGLE: 'Enable dynamic label',
        DYNAMIC_YEAR_DISPLAY_HELP: 'Automatically adds a year to the label.',
        DYNAMIC_YEAR_OFFSET_LABEL: 'Year offset relative to N',
        DYNAMIC_YEAR_OFFSET_HELP: '0 = same year, -1 = previous year, +1 = next year.',
        DYNAMIC_YEAR_REFERENCE_PREVIEW: 'Reference',
        DYNAMIC_YEAR_DISABLED_INFO: 'Dynamic label is disabled. The name will stay exactly as entered.',
        LABEL_PREVIEW: 'Label preview',
        LABEL_PREVIEW_CONTEXT_DYNAMIC: 'View {{displayedYear}} · {{reference}} · Label {{resolvedYear}}',
        LABEL_PREVIEW_CONTEXT_STATIC: 'Current displayed year in the view: {{displayedYear}}',
        TYPE: 'Type',
        TYPE_TEXT: 'Text',
        TYPE_NUMBER: 'Number',
        TYPE_CURRENCY: 'Currency',
        TYPE_PERCENTAGE: 'Percentage',
        CURRENCY_SYMBOL: 'Currency symbol',
        CURRENCY_EURO: 'Euro',
        CURRENCY_DOLLAR: 'US Dollar',
        CURRENCY_POUND: 'British Pound',
        CURRENCY_YEN: 'Japanese Yen',
        CURRENCY_FRANC: 'Swiss Franc',
        CURRENCY_RUPEE: 'Indian Rupee',
        CURRENCY_REAL: 'Brazilian Real',
        CURRENCY_RUBLE: 'Russian Ruble',
        CURRENCY_KRONA: 'Krona (SEK/NOK/DKK)',
        CURRENCY_ZLOTY: 'Polish Zloty',
        PAYROLL_CODE: 'Payroll code',
        CODE_COLUMN: 'Column code',
        CODE_COLUMN_HELP: 'Unique code generated automatically: lowercase letters, numbers and underscores only. Spaces are replaced by underscores.',
        CHECKING_CODE: 'Checking availability...',
        CODE_AVAILABLE: 'Code available',
        CODE_ALREADY_EXISTS: 'The code "{{code}}" already exists for column "{{label}}"',
        HIDDEN_COLUMN: 'Hidden column',
        EXISTING_CATEGORY: 'Existing category',
        SELECT_CATEGORY: 'Select a category',
        ADD_NEW_CATEGORY: 'Add new category',
        NEW_CATEGORY: 'New category',
        NEW_CATEGORY_PLACEHOLDER: 'Type category name...',
        VISIBLE_BY_MANAGERS: 'Visible by managers',
        EDITABLE_BY_MANAGERS: 'Editable by managers',
        VISIBLE_BY_COLLABORATORS: 'Visible by collaborators',
        VISIBLE_IN_SUMMARY: 'Visible in employee summary card',
        AUTO_SUM: 'Automatic sum',
        AUTO_SUM_TOOLTIP: 'Automatically calculates the sum of this column',
        AUTO_AVERAGE: 'Automatic average',
        LABEL: 'Label',
        LABEL_SUM: 'Sum label',
        LABEL_SUM_PLACEHOLDER: 'E.g.: Total salaries, Sum of bonuses...',
        LABEL_AVERAGE: 'Average label',
        LABEL_AVERAGE_PLACEHOLDER: 'E.g.: Average salaries, Average bonuses...',
        CALCULATION_PERIOD: 'Calculation period',
        CALCULATION_PERIOD_TOOLTIP: 'Defines whether the column is calculated monthly or over the entire period',
        MENSUELLE: 'Monthly',
        PERIODIQUE: 'Periodic',
        USE_FORMULA_FRONT: 'Use calculation formula',
        USE_FORMULA_FRONT_TOOLTIP: 'This column will be automatically calculated from other columns',
        FORMULA_BUILDER: 'Formula builder',
        SELECT_COLUMN_A: 'Select column A',
        SELECT_COLUMN_B: 'Select column B',
        SELECT_COLUMN: 'Select a column',
        ADD_COLUMN_TO_FORMULA: 'Add a column to the formula',
        ADD_COLUMN_BTN: 'Add',
        ADVANCED_MODE: 'Advanced mode',
        TOGGLE_ADVANCED_MODE: 'Switch to advanced mode for complex formulas',
        ADVANCED_MODE_HELP: 'Write your formula with parentheses and constants. E.g.: ((col1 + col2) / col3) * 100',
        ADVANCED_FORMULA_PLACEHOLDER: 'E.g.: ((fixed_salary + bonus) / (salary_n_1 + bonus_n_1) - 1) * 100',
        CLICK_TO_INSERT: 'Click to insert',
        OPERATORS: 'Operators',
        FORMULA_PREVIEW: 'Formula preview',
        NO_FORMULA_COLUMNS: 'No numeric columns available to create a formula. Add numeric columns first.',
        USE_FORMULA_COLUMN: 'Historical column',
        USE_FORMULA_COLUMN_TOOLTIP: 'This column will display historical data from another column with a time offset',
        FORMULA_COLUMN_BUILDER: 'Historical column configuration',
        SOURCE_COLUMN: 'Source column',
        SELECT_SOURCE_COLUMN: 'Select source column',
        DELTA_MONTH: 'Offset (months)',
        DELTA_MONTH_PLACEHOLDER: 'E.g.: -12 for N-1',
        DELTA_MONTH_HELP: 'Number of months offset. E.g.: -12 for previous year, -1 for previous month',
        NO_SOURCE_COLUMNS: 'No source columns available. Add columns first.',
        CALCULATED_COLUMN: 'Calculated column',
        CALCULATED_TOOLTIP: 'This column will be calculated automatically according to a formula',
        CALCULATED_FROM_HISTORY: 'Calculated from history',
        HISTORY_TOOLTIP: 'Uses historical data to calculate the value',
        SELECT_COLUMN_PLACEHOLDER: 'Choose a column...',
        HISTORY_TYPE: 'History type',
        HISTORY_TYPE_PLACEHOLDER: 'Choose a type...',
        HISTORY_TYPE_SUM: 'Sum',
        HISTORY_TYPE_AVERAGE: 'Average',
        HISTORY_TYPE_LAST: 'Last value',
        HISTORY_TYPE_FIRST: 'First value',
        BTN_ADD: 'Add column',
        VALIDATION_ERROR: 'Please fill in all required fields',
        API_NOT_READY: 'API not available - Column will be added once API is ready',
      },
      MES_REMUNERATIONS: {
        TITLE: 'My compensation space',
        YEAR_LABEL: 'Displayed year',
        NET_SALARY: 'Your cumulative net salary',
        EVOLUTION: 'Evolution',
        EVOLUTION_SUBTITLE: 'Compared to the same date last year',
        OTHER_BENEFITS: 'Other benefits',
        COMPANY_INVESTMENT: 'Total company investment',
        BONUSES: 'Bonuses',
        EMPLOYER_CHARGES: 'Employer charges',
        NO_DATA_FOR_YEAR: 'No data available for this year',
        ERROR_LOADING_DATA: 'Error loading compensation data',
        NO_BENEFITS_TITLE: 'No benefits available',
        NO_BENEFITS_TEXT:
          'No benefits data has been recorded for the year {{year}}. Benefits will be displayed as soon as they become available.',
      },
      MESSAGES: {
        COLUMN_CREATED: 'Column created successfully',
        COLUMN_UPDATED: 'Column updated successfully',
        COLUMN_DELETED: 'Column deleted successfully',
        CATEGORY_CREATED: 'Category created successfully',
        CATEGORY_UPDATED: 'Category updated successfully',
        VALUE_CREATED: 'Value created successfully',
        VALUE_UPDATED: 'Value updated successfully',
        VALUE_DELETED: 'Value deleted successfully',
      },
      ADD_COMMENT: 'Add comment',
      DISTRIBUTION: 'Distribution',
      TEXT_EDITOR: {
        OPEN: 'Open text editor',
        TITLE: 'Edit text',
        PLACEHOLDER: 'Enter the complete text...',
        HINT: 'Ctrl+Enter to apply to the table',
        APPLY: 'Apply',
        CHARACTERS: 'characters',
      },
      COMMENT_MODAL: {
        TITLE: 'Add comment',
        MOTIF: 'Reason',
        MOTIF_PLACEHOLDER: 'Enter the reason for this change...',
        YEARLY_VIEW_NOTE: 'The comment will be saved for December of the selected year',
      },
      DISTRIBUTION_MODAL: {
        TITLE: 'Value distribution',
        DESCRIPTION: 'Choose how to distribute this value over the year',
        DISTRIBUTION_TYPE: 'Distribution type',
        DECEMBER_ONLY: 'December only',
        DECEMBER_ONLY_DESC: 'The value will be applied only to December',
        ALL_MONTHS: 'All months (same value)',
        ALL_MONTHS_DESC: 'The same value will be applied to each month of the year',
        DIVIDED_EQUALLY: 'Equal distribution',
        DIVIDED_EQUALLY_DESC: 'The value will be divided equally over the 12 months',
      },
    },
    USER: {
      DETAILS: {
        PERSO_INFO: 'Personal Informations',
        presentation: 'Presentation',
        CHANGE_PASS: 'Change password',
        CONGE: 'Holiday',
        NOM: 'Last Name',
        PRENOM: 'First Name',
        AVAIL: 'Availabilities',
        PLANNING: 'Travel schedule',
        PLANNING_WORK_MODE: 'Work modes',
        succ: 'Profil changed successfully',
        allow: 'Allowed file types',
        btn: 'Update',
        COLLAB: 'Collaborator',
        ENTRE: 'Enterprise',
        EQUIPE: 'Team',
        SITE: 'Site',
        SERVICE: 'Service',
        RESERVATION: 'the maximum number of bookable meeting for this month has been reached.',
        FORMATIONS: 'Trainings',
        COMPETENCES: 'Skills',
        EMAIL_PERSONNELLE: 'Personal email',
        TELEPHONE: 'Personal Phone',
      },
    },
    EuipeTransverse: {
      Gerer: {
        Nom: 'New  Transverse Team',
        List: 'Transverse Team list',
      },
      DELETE: {
        TITLE: ' Delete transverse team',
        DESC_1: 'deletion transverse team ...',
        DESC_2: 'Are you sure to permanently delete this transverse team ?',
        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
    },
    COLLAB: {
      DETAILS: {
        TITLE: 'List of collaborators',
        NEW_COLLABORATOR: 'New collaborator',
        PROPOSERCANDIDAT: 'Suggest candidates',
        ADDFROMDOC: 'Fill from a document',
        inscription: 'Registration by link',
        RUP: 'Download RUP',
        RUP_TITRE: 'Unique Personnel Register',
        RUP_BUTTON: 'Download',

        SEARCH: 'Search ',
        FIELD: 'in all fields',
        PRENOM: 'FIRST NAME',
        NOM: 'Last name',
        Responsable: 'Responsible',
        Fonction: 'Function',
        Site: 'Site',
        Service: 'Service',
        Equipe: 'Team',
        ACTIONS: 'ACTIONS',
        IMG: 'Picture',
        IMPORT_COLLABS_BTN: 'Import',
        IMPORT_COLLABS_FROM_FILE_TITLE: 'Adding employees from a file',
        IMPORT_COLLABS_FROM_FILE_DESC: 'Please import a .xls, or xlsx file following the format: ',
        IMPORT_COLLABS_FROM_FILE_DESC_FORMAT: 'email, first name, last name, function, service',
        TAG_AS_AMBASSADOR: 'Tag as ambassador',
        MARKED_AS_AMBASSADOR: 'was marked as an ambassador',
        UNMARKED_AS_AMBASSADOR: 'was unmarked as an ambassador',
        // These labels are scoped to the redesigned collaborator-management action menu.
        ACTION_MENU: {
          DETAILS_DESCRIPTION: 'Open the collaborator profile',
          TAGS_STATUS: 'Tags & status',
          HIGH_POTENTIAL: 'High potential',
          HIGH_POTENTIAL_DESCRIPTION: 'Identify high-potential talent',
          PARTICULAR_FOLLOW_UP: 'Particular follow-up',
          PARTICULAR_FOLLOW_UP_DESCRIPTION: 'Enhanced monitoring and special attention',
          AMBASSADOR: 'Ambassador',
          AMBASSADOR_DESCRIPTION: 'Enable ambassador status',
          ACCOUNT_MANAGEMENT: 'Account management',
          ACTIVATE_ACCOUNT: 'Activate account',
          ACTIVATE_ACCOUNT_DESCRIPTION: 'Make the account active and accessible',
          TRANSFER_ALUMNI: 'Transfer to Alumni',
          TRANSFER_ALUMNI_DESCRIPTION: 'Move to the alumni database',
          DEACTIVATE_ACCOUNT: 'Deactivate account',
          DEACTIVATE_ACCOUNT_DESCRIPTION: 'Temporarily suspend access',
          UPCOMING_STARTER: 'Upcoming starter',
          // The upcoming departure label complements the existing arrival marker in the list.
          UPCOMING_DEPARTURE: 'Upcoming departure',
        },
        // The redesigned modal preserves the existing actions and only clarifies the comment workflow.
        TAG_COMMENT_MODAL: {
          CLOSE: 'Close',
          POTENTIAL_TITLE: 'Identify high potential',
          POTENTIAL_DESCRIPTION: 'Add useful context describing the qualities or potential you observed.',
          FOLLOW_UP_TITLE: 'Enable particular follow-up',
          FOLLOW_UP_DESCRIPTION: 'Describe why enhanced attention or support is needed.',
          COMMENT_LABEL: 'Comment',
          COMMENT_HINT: 'Optional · 500 characters maximum',
          POTENTIAL_PLACEHOLDER: 'E.g. strong growth potential, observed leadership, key expertise…',
          FOLLOW_UP_PLACEHOLDER: 'E.g. recommended support, point of attention, management follow-up…',
          CANCEL: 'Cancel',
          CONFIRM_POTENTIAL: 'Confirm high potential',
          CONFIRM_FOLLOW_UP: 'Enable follow-up',
        },
        ACTIF: 'Active',
        ALUMNI: 'Alumni',
        DESACTIVER: 'Disabled',
        EN_ATTENTE: 'waiting for registration',
        SITE: 'Site',
        FILTRE: 'Filter',
        ALL: 'All',
        TITREALUMNI: 'Transfer to the list of alumni',
        SOUSTITREALUMNI: 'Transfer to the list of alumni ...',
        BODYALUMNI2: 'confirmation of the effective date of departure.',
        BODYALUMNI: 'Are you sure you want to deactivate the user account and transfer it to the list of alumni?',
        TITREACTIF: 'Reactivate account',
        SOUSTITREACTIF: 'Reactivation account...',
        BODYACTIF: 'Are you sure you want to reactivate this account?',
        CANCEL: 'Cancel',
        SAVE: 'save',
        ENVOIEMAILBIENVENUE: 'Configure the sending of Welcome emails',
        ENVOYERMAILBIENVENUEINSCRIT: 'Send the welcome email automatically to each new registrant',
        PASENVOYERMAILBIENVENUEINSCRIT: 'Do not send a welcome email automatically',
        ENTREPRISESTRUCTURE: 'Organization chart',
        ORGA: 'Organization chart',
        MONEQUIPE: 'My team',
        CONFIRMATIONEMAIL: 'Confirmation of sending welcome email',
        MSGCONFIRMATIONEMAIL:
          'Would you like to send a welcome email to collaborators who have already been added but have not received it yet?',
        OUI: 'Yes',
        NON: 'No',
        SENDEMAILSALLCOLLABS:
          'Welcome emails will be sent to all collaborators who have already been added and have not received the email.',
        SENDEMAILSALLCOLLABS2: 'Only new collaborators added from this point on will receive the welcome email.',
        SUCCESSPARAMETRAGE: 'Configuration completed successfully',
        ERRPARAMETRAGE: 'Error during configuration',

        ListCollegues: {
          LIST: 'List of colleagues',
          p1: 'If you want to be able to offer appointments to your colleagues, you must accept the option allowing your colleagues to book an appointment with you',
          Profil: 'Profile',
          p2: 'You must agree to be visible to others in order to access the directory.',
          p3: 'Your company must activate the directory option for collaborators',
          interet: 'Interest:',
        },
      },

      EDIT: {
        Edit: 'Edit',
        Create: 'Add',
        customer: 'collaborator',
        Nom: 'Last Name',
        Name: 'Name',
        Prenom: 'First Name',
        FIrstName: 'First Name',
        fonction: 'Function',
        fon: 'Function',
        Email: 'Professional email',
        mail: 'Personal email',
        password: 'Password',
        m2p: 'Password',
        Equipe: 'Select team',
        Role: 'Select role',
        ADMIN: 'Administrator',
        USER: 'Collaborator',
        BTN_SAVE: 'Save',
        BTN_SAVEBROUILLON: 'Save as draft',
        BTN_SAVEINTERNE: 'Save and publish internally',
        BTN_SAVEPORTAIL: 'Save and publish to the portal',
        BTN_CANCEL: 'Cancel',
        ERR: 'This email already exists. Please use another email',
        ERR1: 'This email invalid. Please enter a valid email',
        dateentree: 'Date of entry',
        dateSortie: 'Date of departure',
        qualification: 'Qualification',
        dateAutorisationEmbauche: 'Date of authorization to hire',
        dateAutorisationLicenciement: 'Date of authorization to dismiss',
        dateAutorisationDemande: 'Date of authorization or request for authorization',
        titreAutorisation: 'Authorization title',
        numeroOrdreTitre: 'Title order number',
        dateDelivranceTitre: 'Title issue date',
        dateExpirationTitre: 'Title expiration date',
        ERROR_DATE_EXPIRATION_AFTER_DELIVRANCE:
          'The title expiration date must be after the title issue date.',
        departement_naissance: 'Departement of birth',
        date_entree_groupe: 'Date of entry in the group',
      },
      SELFSERVICE: {
        TITLE: 'Consult Availability',
      },
      RECONNAISSANCE: {
        // Labels for the modern recognition composer, history and editing flow.
        TITRE: 'Send Recognition',
        EYEBROW: 'Celebrate a colleague',
        DESCRIPTION: 'Highlight a contribution that deserves to be shared.',
        CLOSE: 'Close recognition dialog',
        NAVIGATION: 'Recognition navigation',
        COMPOSE_TAB: 'Send',
        HISTORY_TAB: 'My recognitions',
        CHOIXIMAGE: 'Choose an image',
        IMAGE_WELCOME: 'Welcome',
        IMAGE_BRAVO: 'Well done',
        IMAGE_COLLABORATION: 'Collaboration',
        IMAGE_ENGAGEMENT: 'Engagement',
        IMAGE_LEADERSHIP: 'Leadership',
        IMAGE_THANKS: 'Thank you',
        IMAGE_GOAL: 'Goal achieved',
        IMAGE_TEAMWORK: 'Teamwork',
        PUBLIC_NOTICE_TITLE: 'Visible to everyone',
        PUBLIC_DASHBOARD_NOTICE:
          'This recognition will appear on the company dashboard and will be visible to every colleague.',
        MSGTEXT: 'Message of recognition',
        MESSAGE_PLACEHOLDER: 'Explain what you appreciated about their contribution…',
        BTN_SEND: 'Send',
        CANCEL: 'Cancel',
        SENDING: 'Sending…',
        ADDSUCCESS: 'Recognition added successfully',
        ADD_ERROR: 'The recognition could not be sent. Please try again.',
        INVALID_FORM: 'Select a card and write a message.',
        INVALID_MESSAGE: 'The message cannot be empty.',
        SELECTIMAGESUCCES: 'Image selected successfully!',
        ERREURSELECTIMAGESUCCES: 'Please select an image and write a message',
        HISTORY_TITLE: 'Sent recognitions',
        HISTORY_DESCRIPTION: 'Review and correct the messages you have published.',
        HISTORY_LOADING: 'Loading your history…',
        HISTORY_LOAD_ERROR: 'Your history cannot be loaded right now.',
        HISTORY_EMPTY_TITLE: 'No recognition sent yet',
        HISTORY_EMPTY: 'Your next recognition message will appear here.',
        REFRESH_HISTORY: 'Refresh history',
        RETRY: 'Try again',
        SENT_AT: 'Sent on',
        EDIT: 'Edit',
        EDIT_FOR: 'Edit the recognition sent to',
        EDIT_TITLE: 'Edit message',
        EDIT_CANCEL: 'Cancel',
        UPDATE: 'Save changes',
        UPDATE_SUCCESS: 'Recognition updated successfully',
        UPDATE_ERROR: 'The recognition could not be updated.',
        UNKNOWN_RECIPIENT: 'Former colleague',
        LOAD_MORE: 'Show more',
      },
      RESERVER: {
        TITLE: ' Booking Activity',
        DESC_1: 'Booking Activity ...',
        DESC_2: 'Are you sure you want to book  this Activity ?',
        BTN_DELETE: 'Booking',
        BTN_CANCEL: 'Cancel',
      },
      DELETE: {
        TITLE: 'Account Deactivation',
        DESC_1: 'Are you sure you want to deactivate this account?',
        DESC_2:
          'The deactivation will take effect on the date indicated below. The user will no longer be able to log in after this date.',
        BTN_NETOYER: 'Clean',
        BTN_DELETE: 'Desactivate',
        BTN_CANCEL: 'Cancel',
      },
      btnSave: 'Save',
      collaborateursManages: 'Collaborators managed',
      listeCollaborateursManages: 'List of managed collaborators',
      aucunCollaborateurManage: 'No collaborators managed found',
      ajouterCollaborateur: 'Add collaborator',
      aucunCollaborateurSansManager: 'No collaborators without manager found',
      ajouter: 'Add',
      photo: 'Photo',
      nom: 'Last name',
      prenom: 'First name',
      fonction: 'Function',
      equipe: 'Team',
      service: 'Service',
      site: 'Site',
      actions: 'Actions',
      CONFIRMATION_RETIRER_MANAGER: 'Are you sure you want to remove this employee from your list of managed persons?',
    },
    ANNUAIRE: {
      TITLE: 'Directory',
      p0: 'To take into account the changes it is necessary to refresh the application',
      button: 'Refresh application',
      p: 'Activate the directory for collaborators',
      p100: 'To take into account the changes it is necessary to click on button save after filling in the fields below',

      p1: 'Activate communities for collaborators',
      p2: 'Activate events for collaborators',
      p3: 'Activate the questions and answers for the collaborators',
      ponboarding: 'Activate onboarding ',
      Annuaire: 'Appear in the directory',
      Accept: 'Accept to receive appointment proposals from colleagues',
      abn: 'Your subscription is',
      parametre_msg1:
        'Manage your modules here by activating or deactivating them according to your subscription to adapt the platform to your needs',
    },
    MYACTVITY: {
      status: {
        att: 'Waiting for your confirmation',
        att1: 'Waiting for confirmation of',
        att2: 'Waiting for confirmation of two collaborators',
        rdvConfirme: 'The appointment is confirmed',
        rdvDecline: 'You declined the appointment',
        rdvDecline1: ' declined the appointment',
        annule: 'Canceled',
        terminer: 'Finish',
      },
      DETAILS: {
        detail: 'Appointment details',
        restoDetail: 'Restaurant details',
        Lieu: 'Location',
        ACTIVITY_DETAILS: 'Activity Details',
        COFFE: 'Cofee',
        LUNCH: 'Lunch',
        RESTAURANT: 'Restaurant',
        BACK: 'Back',
        CANCEL: 'Cancel',
        ACCEPT: 'Accept',
        REFUSE: 'Refuse',
        TERMINER: 'Finish and Rate',
        ACTIVITY_TYPE: 'Activity type',
        MADE_BY: 'Made By',
        ACTIVITY_STATUS: 'Activity status',
        MEETING_IS_WITH: 'Collaborater',
        MY_STATUS: 'My status',
        MY_COMMENT: 'My comment',
        MY_COMMENT2: 'Collaborater comment',
        RESTAURANT_NAME: 'Restaurant name',
        JOIN: 'Join',
        LEAVE: 'Leave',
        SEND: 'Send',
        WELCOME: 'chat with ',
        ACCEPTED: 'Accepted',
        REFUSED: 'Refused',
        CANCELED: 'Canceled',
        CREATED: 'Created',
        ATTENTE: 'Need your confirmation',
        FINISHED: 'Finished',
        RATING: ' My Rating',
        RAITING2: 'collaborater Rating',
        FILE: 'Upload your file',
        RATE_COMMENT: 'Rate',
        DEATAILLS: 'Details',
        note: 'My rating',
        newMess: 'Communicate with your collaborator',
        disponible: ' List available',
        avecQui: 'With whom?',
        Avis: 'Notice',
        ser: 'Service: ',
        Avis1: 'Notice:',
        Nom: 'Name: ',
        Adresse: 'Address: ',
        Horraires: 'Hours: ',
      },
      MENU: {
        TLF: 'Phone',
        Cuisine: 'Kitchen',
        Services: 'Services',
        Livraison: 'Delivery',
        Self: 'Self service',
        tearace: 'terrace',
        vegetariens: 'Suitable for vegetarians',
        bio: 'Bio products',
        Halal: 'Halal dishes',
        gluten: 'Gluten-free dishes',
        diabetiques: 'Dishes for diabetics',
        vegans: 'Suitable for vegans',
      },
      note: {
        head: 'Did your date go well ?',
        body: 'Leave a note',
        comnt: 'Leave a comment',
      },
      LIST: {
        TITLE: 'Manage your team meetings',
        BTN_ADD: 'New Activity',
        SEARCH: ' Search',
        FIELD: ' in all fields',
        start_date: 'Start date',
        status_global: ' Global status',
        user_1: 'Collaborater 1',
        status_1: 'Status 1',
        user_2: 'Collaborater 2',
        status_2: 'Status 2',
        TASK_STATUS_IN_PROGRESS: 'in progress',
        ACTIONS: 'Actions',
      },
      EDIT: {
        TITLEADD: 'Activity',

        TITLEMODIF: 'Activity',
        CREATE: 'Create',
        UPDATE: 'Update',
        TITLE: 'Activity',
        Date: 'Start date',
        Restaurant: 'Enter restaurant name',
        USER_1: 'Select guest 1',
        User1: 'Guest 1',
        USER_2: 'Select guest 2',
        User2: 'Guest 2',
        Description: 'Description',
        type: 'Type of appointment',
        caffee: 'Coffee',
        meal: 'Meal',
        BTN_SAVE: 'Save',
        BTN_CANCEL: 'Cancel',
        ERRERRDV: 'Meeting exists for users on this date',
      },
      DELETE: {
        TITLE: ' Delete meet',
        DESC_1: 'meet is deleting...',
        DESC_2: 'Are you sure to permanently delete this meet ?',
        DESC_3: 'Are you sure you want to delete the document titled',

        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
      ACTIVITY: {
        TITLE: 'List of notes and comments',
        SEARCH: ' Search',
        FIELD: ' in all fields',
        start_date: 'start date',
        Disponible: 'List of available people',
      },
      RATING: {
        TITLE: 'Did your date go well ?',
        COMMENT: 'Leave a Comment',
        NOTE: 'Leave a note',
        no: 'Note',
        BTN_SAVE: 'Save',
        BTN_CANCEL: 'Cancel',
        BTN_SAVESEND: 'Save and send',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    SITE: {
      DETAILS: {},
      LIST: {
        TITLE: 'List of sites',
        BTN_ADD: 'New site',
        SEARCH: 'Search ',
        FIELD: 'in all fields',
        NAME: 'Name',
        ADDRESS: 'Address',
        VILLE: 'City',
        PAYS: 'Country',
        ACTIONS: 'Actions',
      },
      EDIT: {
        res: 'Responsible',
        ressite: 'Responsible site',

        Edit: 'Edit',
        Create: 'Create new site',
        SITE: 'site',
        Nom: 'Site name',
        Name: 'Name',
        Address: 'Address',
        add: 'Address',
        ville: 'City',
        city: 'City',
        pays: 'Country',
        country: 'Country',
        BTN_SAVE: 'Save',
        BTN_CANCEL: 'Cancel',
        AMBASSADEUR: 'Site ambassador',
        DOCUMENTS: 'Documents',
        DOCUMENTS_DROP: 'Drag and drop or select',
        DOCUMENTS_FORMATS: 'Fill in the agreement title and add the agreement document before adding it to the list.',
        DOCUMENTS_TITLE: 'Agreement title',
        DOCUMENTS_FILE: 'Agreement document',
        DOCUMENTS_TYPE: 'Document type',
        DOCUMENTS_TYPE_PLACEHOLDER: 'Select document type',
        DOCUMENTS_IMPORTED: 'Previously uploaded document',
        DOCUMENTS_ADD: 'Add agreement',
        DOCUMENTS_PRIORITY_HIGH: 'Highest priority',
        DOCUMENTS_PRIORITY_LOW: 'Lowest priority',
        DOCUMENTS_EMPTY: 'No document added yet.',
        DOCUMENTS_DELETE_TITLE: 'Delete agreement',
        DOCUMENTS_DELETE_CONFIRM: 'Do you really want to delete this agreement?',
        DOCUMENTS_DELETE_SUCCESS: 'Agreement deleted successfully',
        DOCUMENTS_DELETE_ERROR: 'Error while deleting agreement',
        DELETE_ALL_DOCUMENTS: 'Delete all documents',
        DELETE_ALL_DOCUMENTS_TITLE: 'Delete all documents',
        DELETE_ALL_DOCUMENTS_CONFIRM: 'Are you sure you want to delete all documents for this site?',
        DELETE_ALL_DOCUMENTS_SUCCESS: 'All documents have been deleted successfully',
        DELETE_ALL_DOCUMENTS_ERROR: 'Error while deleting documents',
        DOCUMENTS_EXTRACTING_TEXT: 'Extracting text...',
        DOCUMENTS_PROCESSING_CHUNKS: 'Processing document...',
        DOCUMENTS_FINALIZING: 'Finalizing...',
        DOCUMENTS_PLEASE_WAIT: 'This may take a few moments for large documents.',
        DOCUMENTS_STATUS_EXTRACTING: 'Extracting text',
        DOCUMENTS_STATUS_PREPARING: 'Preparing for Julie',
        DOCUMENTS_STATUS_IMPORTED: 'Successfully imported',
        DOCUMENTS_UPLOAD_SUCCESS: 'Agreement uploaded successfully',
        DOCUMENTS_UPLOAD_ERROR: 'Error while uploading agreement',
      },
      DELETE: {
        TITLE: '  Delete Site',
        DESC_1: 'Site is deleting...',
        DESC_2: 'Are you sure to permanently delete this Site?',
        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
    },
    INDICATOR: {
      DELETE: {
        TITLE: '  Delete Indicator',
        DESC_1: ' indicator deleting ...',
        DESC_2: 'Are you sure to permanently delete this indicator?',
        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
    },
    GROUP: {
      DETAILS: {},
      LIST: {
        TITLE: 'List of teams',
        BTN_ADD: 'New Team',
        SEARCH: 'Search ',
        FIELD: 'in all fields',
        NAME: 'Team name',
        MSG1: 'WARNING, you cannot delete it,',
        MSG2: 'Employees are attached to this team!',
        NBR: 'N° MEMBERS',
        SERVICE: 'Service name',
        ACTIONS: 'Actions',
        USERS: 'Users',
        AFFECTER: 'Affect',
        MODIFIEREQUIPE: 'EDIT',
        SUPPRIMEREQUIPE: 'Delete',
        HISTORIQUE: 'History',
      },
      EDIT: {
        Edit: 'Edit',
        Create: 'Create',
        GROUP: 'Team',
        GROUPREQUIS: ' Team name',
        Service: 'Select Service',
        BTN_SAVE: 'Save',
        BTN_CANCEL: 'Cancel',
        NOMGROUP: 'Team name',
        GROUPedit: 'Team',
        RESPONSABLE_EQUIPE: 'Responsible team',
        AMBASSADEUR_EQUIPE: 'Team ambassador',
      },
      EDITTRANSVERSE: {
        Edit: 'Edit',
        Create: 'Create',
        GROUP: ' Transverse Team',
        GROUPREQUIS: ' Team name',
        Service: 'Select Service',
        BTN_SAVE: 'Save',
        BTN_CANCEL: 'Cancel',
      },
      DELETE: {
        TITLE: 'Delete Team',
        DESC_1: 'Team is deleting...',
        DESC_2: 'Are you sure to permanently delete this Team?',
        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
    },
    SERVICE: {
      LIST: {
        TITLE: 'List of services',
        BTN_ADD: 'New service',
        SEARCH: 'Search ',
        FIELD: 'in all fields',
        NAME: 'Service name',
        SITE: 'Site name',
        ACTIONS: 'Actions',
      },
      EDIT: {
        Edit: 'Edit',
        Create: 'Create new service',
        SERVICE: 'Service',
        NAME: 'Service name',
        SITE: 'Select Site',
        si: 'Site',
        BTN_SAVE: 'Save',
        BTN_CANCEL: 'Cancel',
        RESP_SERVICE: 'Responsible service',
        AMBASSADEUR_SERVICE: 'Service ambassador',
      },
      DELETE: {
        TITLE: '  Delete service',
        DESC_1: 'Service is deleting...',
        DESC_2: 'Are you sure to permanently delete this service?',
        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
    },
    USER_PROFILE,
    DASHBOARD: {
      MYACTIVITY: 'Overall Involvement Rate',
      RDVFINICHED: 'Appointments completed',
      RDVREFUSED: 'Appointment refused',
      NOTEMOY: 'Average grade',
      RDVACCEPTED: 'Appointment Accepted',
    },
    ONBOARDINGTEXT: {
      SUIVREONB: 'Monitoring of onboarding and offboarding',
      ADDBUDDYONB: 'Add buddy',
      ADDFORMATIONONB: 'Add training rule',
      ADDACCEUILONB: 'Add welcome rule',
      ADDTACHEONB: 'Add task rule',
      ADDENQUETEONB: 'Add survey rule',
      ADDDEBRIEFONB: 'Add debriefing rule',
      ADDRDVONB: 'Add appointment',
      ADDVIDEOONB: 'Add video',
      ACTIVERONB: 'Activate onboarding',
      DESACTIVERONB: 'Deactivate onboarding',
      ACTIFOFFBOARDING: 'Activate offboarding',
      DESACTIFOFFBOARDING: 'Deactivate offboarding',
      ADDDOCONB: 'Add a document',
      TELECHARDERDOCONB: 'Download',
      VOIRDOCONB: 'View document',
      PLUSONB: 'More',
      MOINSONB: 'Less',
      TELECHARGEDOC: 'Download document',
      TOUTONB: 'All',
      FAITONB: 'Done',
      AFAIREONB: 'To do',
      INDEXERONB: 'Index',
      SURVEY_ONBOARDING_TARGET_HELP:
        'Only surveys with an onboarding targeting type will be listed below',
    },

    APIEXTERNE: {
      description: ' Generate an external API key for your company',
      descriptionsupprimer: 'Delete the external API key for your company',
      button: 'Generate key',
      buttonsupprimer: 'Delete key',
    },
    DASHBOARD1: {
      MESRDV: 'My appointments',
      MESRDVonboarding: 'Your appointments',

      ABSCENCERDV: 'No appointment scheduled',
      VOIR: 'See all',
      EQUIPE: 'Your team',
      ABSEQUIPE: 'No members in your team at the moment.',
      BUDDY: 'Your buddy',
      ABSBUDDY: 'No buddy',
      INFORMATIONSCONTACT: 'Contact information',
      ABSINFORMATIONSCONTACT: 'Not yet existing',
      ACCEUILPREMIERJOUR: 'The person who will welcome you',
      ABSACCEUILPREMIERJOUR: 'The person who will welcome you has not yet been assigned.',
      INCONNU: 'Unknown',
      Compte: 'Countdown',
      Jours: 'days',
      Heures: 'hours',
      Minutes: 'minutes',
      Precedent: 'Previous',
      Suivant: 'Next',
      CONGRAT: 'Send congratulations',
      ANNIVERSAIRE: 'Today is the birthday of',
      CARTEDEJOUR: 'Your cards of the day',
      ABSCENCERECRUE: 'No new arrivals',
      DEMANDECAFE: 'Offer him a coffee',
      RECONNAISSANCE: 'Recognition',
      // Editorial recognition card banner copy.
      RECONNAISSANCE_SUBTITLE: 'Celebrate everyday achievements and thoughtful gestures',
      RECONNAISSANCE_TAGLINE: 'Small words, a big impact',
      // Accessible interactions for the recognition social feed.
      RECOGNITION_TO: 'to',
      RECOGNITION_LIKE: 'Like this recognition',
      RECOGNITION_UNLIKE: 'Remove my like from this recognition',
      RECOGNITION_SHOW_LIKERS: 'See the {{count}} people who like this recognition',
      RECOGNITION_LIKED_BY: 'Liked by',
      RECOGNITION_LIKES_LOADING: 'Loading people…',
      RECOGNITION_LIKES_ERROR: 'Unable to load the list.',
      RECOGNITION_OTHER: 'Recognition',
      RECOGNITION_UNKNOWN_USER: 'Former colleague',
      RECOGNITION_TODAY: 'Today',
      RECOGNITION_YESTERDAY: 'Yesterday',
      RECOGNITION_DAYS_AGO: '{{count}} days ago',
      RDVPROCHAIN: 'Next meeting',
      WITH: 'With',
      Restaurant: 'Restaurant',
      GROWTITLE: 'Grow your career',
      GROWMSG1: 'Share moments of conviviality with your colleagues and expand your network!',
      GROWMSG2: 'Well done 👏 your network is growing, keep increasing your visibility!',
      GROWMSG3: 'Congratulations 👏 you have developed your network well, keep maintaining it!',
      POTENTIELTITLE: 'The potential of your profile',
      POTENTIELMSG1: ' Fill in your profile to break the ice more easily.',
      POTENTIELMSG2: 'Congratulations 👏 your profile is at its full potential!',
      POTENTIELMSG3: 'You are at position ',
      POTENTIELMSG4: '  of the tops miameurs!',
      POTENTIELMSG5: 'Thank you for making appointments to increase your position!',

      PROCHAINRDV: 'Next meetings',
      ABSRESTAURANT: 'Location to be determined.',
      ABSRDV: 'No appointment scheduled',
      ABSRDV2: "You don't have an appointment scheduled at the moment",
      ABSNOTIF: "You don't have any notifications at the moment",

      ABSEQUIPEMOIS: 'No top teams for this month',
      ABSMIAMEURSSEMAINE: 'No top miameurs this week',
      ABSRDV3: 'No top services for this month',
      ABSEVENT: 'No event planned',
      ABSEVENT2: "You don't have  events planned at the moment",
      ABSIDEA: 'No idea to plan',
      ABSIDEA2: "You don't have an idea to plan at the moment",

      TOPSERVICES: 'Top services of the Month',
      ABSSERVICE: 'Ranking coming soon',
      RDV: 'meeting',
      TOP_MIAM_SEMAINE: 'Top miameurs of the week',
      JOURSFERIES: 'Upcoming holidays',
      TOP_MOIS_EQUIPE: 'Top Teams of the Month',
      EVENNEMENT: 'Events',
      IDEA: 'Collaborator idea',
      PARTICIPATION: 'Employee participation',
      BAROMETRE0: 'Next action:',
      BAROMETRE: 'Run the Barometer',
      GO: "Let's go",
      COLLABS: 'Collaborators',
      ACTIVE: 'Active',
      GENRE: 'Gender',
      SORTIE: 'Exits',
      ENTREE: 'Entries',
      ALERT: 'Alerts',
      QUESTION: 'Pending questions',
      IDEAOUVERTES: 'Numbers of open idea',
      DETAILS: 'more details',
      SELECT: 'Select site here',
      PARTICIPATIONSER: 'Participation by service',
      ABSSERVICEdash: 'no services for this site',
      EVOLUTIONQVCT: 'Evolution of the QVCT',
      BAROMETREDASH: 'Barometer QVCT',
      BAROMETRERELATION: 'relationship',
      BAROMETRECONTENU: 'Content',
      BAROMETRESANTE: 'Health',
      BAROMETREEGALITE: 'Equality',
      BAROMETREMANAGEMENT: 'Management',
      BAROMETRECOMPETENCES: 'Skills',
      RendezvousDASH: 'Meeting',
      EvenementsDASH: 'Events',
      NewsletterDASH: 'Newsletter',
      FormationDASH: 'Training',
      ideeDASH: 'Idea',
      SAVEDASH: 'Save',
      BIENVENUERECRU: 'Welcome to the new recruits',
      BIENVENUERECRU1: 'We welcome ',
      BIENVENUERECRU2: 'which integrates our company into the service ',
      BIENVENUERECRU3: 'See more ',
      BIENVENUERECRU4: 'Offer him a coffee',
      PARRAINEPERSONNE: 'The people you sponsor',
      ABSPARRAINEPERSONNE: 'No sponsored person',
      PERSONNESMANAGEES: 'The people you manage',
      ABSPERSONNESMANAGEES: 'No one to manage',
      ANNIF: 'Upcoming birthdays',
      ABSANNIF: 'You have no upcoming birthdays at the moment',
      FERIER: 'Upcoming holidays',
      ABSFERIER: 'No upcoming holidays',
      TEMPSTRAVAILLE: 'Time worked',
      PAUSEDEPEPUIS: 'On break since',
      COMMENCER: 'Start my day',
      REPREND: 'I resume',
      PAUSE: 'I take a break',
      TERMINERJOURNE: 'End my day',
      BIENVENUE: 'Welcome',
      BIENVENUEEQUIPE: 'We are delighted to have you on our team!',
      COMPLETEPROFIL: 'Complete your profile',
      VOICI: 'Here are your actions to take:',
      VOIRVIDEO: 'Watch the welcome video',
      SUIVREFORMATION: 'Follow the requested training',
      COMMENCERONB: 'Start',
    },
    PARAMETRENOTIFICATION: {
      PARAMETRENOTIF: 'Setting notification preferences',
      NOTIFEMAIL: 'Receive email notifications',
      NOTIFSLACK: 'Receive slack notifications',
      NOTIFTEAMS: 'Receive teams notifications',
    },

    INDICATEUR: {
      BLOCK: ' block flag value ',
      TITLE:
        'To take into account changes, it is necessary to click on the save button after filling in the fields below',
      CONFLITS: 'Conflict rate',
      GESTIONCONFLIS: 'Conflict management rate',
      SATISFACTION: 'Satisfaction rate',
      ENGAGEMENT: 'Engagement rate',
      AUTONOMIE: 'Autonomy rate',
      VARIETETACHE: 'Task variety rate',
      PRODUCTIVITE: 'Productivity rate',
      ERREUR: 'Error rate',
      SANTE: 'Health absenteeism rate',
      STRESS: 'Professional stress rate',
      BIENETRE: 'Well-being index',
      BURNOUT: 'Burnout rate',
      MOBILITE: 'Professional mobility rate',
      PROMOTION: 'Internal promotion rate',
      SCORE: 'Global score',
    },
    DASHBOARD2: {
      RDVACC: 'RDVS Accepted',
      RDVRED: 'RDVS Refused',
      RSVCAN: 'RDVS Cancelled',
    },
    WIZARDS: {
      taille: 'What is the size of your company: ',
      Bienvenue: 'Welcome',
      ADD: 'Address',
      ADDSIEGE: 'Address of the registered office',
      ACCOUNTTYPE: 'Type of account',
      Organization: 'Organization',
      Service: 'Service',
      Siege: 'Seat',
      Team: 'Team',
      Ended: 'Ended',
      CYTOA: 'Choose your type of account',
      IFYOUNEED: 'If you need more information you can consult',
      help: 'Online help',
      Société: 'Company',
      Équipe: 'Team',
      GRP: 'Friends team',
      ENTER: 'Enter your company details',
      NOMSOS: 'Your company name',
      SILNOMSOS: 'Please enter your company name.',
      Country: 'Country',
      Ville: 'City',
      ENTERCITY: 'Please enter your city.',
      ENTEREQ: 'Enter your team details',
      ENTERNOMEQ: 'Name of your team',
      SILENTERNOMEQ: 'Please type your team name.',
      ENTERGRP: 'Enter the details of your team of friends',
      ENTERADD: 'Please type your address',
      ENterGRPNAME: 'Name of your team',
      SILENTERNOMSos: 'Please enter your company name.',
      ServiceDetails:
        'To provide an intelligent and personalized service for each collaborator we need to know the position of each one in the company.',
      nomService: 'What department are you attached to?',
      SILService: 'Please type in your service.',
      DETAILSDESER: 'Details of your service',
      NOMSERVICE: 'Service name',
      TAPEREQ:
        'To provide an intelligent and personalized service for each collaborator we need to know the position of each one in the company.',
      NomEQ: 'what team are you attached to?',
      SILEQ: 'Please type your team.',
      DetailsEQ: 'Your team details',
      REVIEW: 'Review your Details and Submit',
      FELICITATION: 'Congratulations you are ready to go',
      REQ1: 'Now add employees to: your company',
      REQ2: 'members of your team',
      REQ3: 'members of your team',
      Previous: 'Previous',
      Next: 'Next Step',
      Equipe_Trans: 'Transversal team that leads the follow-up',
      SITE_Talend: 'Site of beneficiary employees',
      Submit: 'Submit',
    },
    DISPO: {
      EMI: {
        title: 'How can I help you ?',
        send: 'Send',
        historique: 'My History',
        poser: 'Ask the question',
        p: "Please note that the wizard's answers are for informational purposes and cannot replace the advice of an expert. WeMiam does not bear any responsibility with regard to the application or not of the advice and indications provided by the AI which feeds this assistant. If you need more specific answers or assistance, our experts are available to help you.",
        contacter: 'Contact an Expert',
        question: 'My questions',
        placeholderquestion:
          'It is important to specify your request so that we can provide you with an adequate response. Please give us more details about what you would like so that we can understand your needs and assist you in the best possible way.',
      },
      demander: 'Ask ',
      btn: "I'm available",
      btnDej: 'Lunch',
      btnAfter: 'After work',
      alert: 'You are already registered for this event.',
      att: 'Warning',
    },
    STRATEGIE: {
      GERER: {
        list: 'List of strategies',
        new: 'new strategy',
        icons: 'icons',
        NAME: 'NAME',
        DESCRIPTION: 'DESCRIPTION',
      },
      EDIT: {
        DETAILSSTRATEGIE: 'Strategy Details',
        EDIT: 'Edit strategy',
        event_id: 'Event',
        nom: 'Event name',
        HEURE: 'Generation time',
        jour_mois: 'Day of month',
        jour_semaine: 'Weekday',
        type_frequence: 'Generation frequency',
        equipe_cible1: 'Team that benefits from the Service',
        equipe_cible2: 'Team that provides its calendar',
        site_cible: ' Site concerned',
        service_cible: 'Service concerned',
        equipetrans_cible: 'Transverse team concerned',
        delai: 'Notice period',
        delai_minimum: 'Minimum time between two reservations from the same member',
        nbre_mois: 'Number of reservations authorized per month',
        jours: 'Every day',
        mois: 'Every month',
        semaines: 'Every week',
        datedemarrage: 'Starting date',
        type: 'Event type',
        dej: 'Lunch',
        petitdej: 'Breakfast',
        after: 'Afterwork',
        diner: 'Dinner',
      },
      DELETE: {
        TITLE: '  Delete strategy',
        DESC_1: 'Strategy is deleting...',
        DESC_2: 'Are you sure to permanently delete this strategy?',
        BTN_DELETE: 'Delete',
        BTN_CANCEL: 'Cancel',
      },
      ACTIVATE: {
        TITLE: 'Activate strategy',
        TITLE1: 'Deactivate strategy',
        DESC_1: 'Are you sure to permanently activate this strategy?',
        DESC_2: 'Are you sure to permanently deactivate this strategy?',

        BTN_ACTIVATE: 'Activate',
        BTN_DESACTIVATE: 'Desactivate',
        BTN_CANCEL: 'Cancel',
      },
      WIZARDS: {
        taille: 'What is the size of your company: ',
        Param: 'Set up your strategy',
        ACCOUNTTYPE: 'Type of strategy',
        Organization: 'Details',
        Service: 'Release date',
        Ended: 'Ended',
        CYTOA: 'Choose your strategy',
        IFYOUNEED: 'If you need more information you can consult',
        ENTER: 'Customize your strategy',
        help: 'Online help',
        Société: 'Society',
        Detailssp: 'Specific details',
        Previous: 'Previous',
        FREQUENCY: 'Frequency',
        TYPEEVENT: 'Event type',
        JOUR: 'Generation day',
        HOUR: 'Activity time',
        site: 'Targeted collaborators',
        plus: 'When should this strategy start?',
        demarrage: 'Starting date',
        Next: 'Next step',
        Submit: 'Submit',
        FELICITATION: 'Congratulations, your strategy is ready!',
        name: 'Name',
        duree_min: 'Minimum time between two activities with the same employee (in month)',
        duree_min1: 'Minimum duration',
        duree_max: 'Maximum time between two activities with the same employee (in month)',
        duree_max1: 'Maximum duration',
        delaiPrev: 'Minimum notice period (In days)',
        delaiPrev1: 'Notice period',
        nbrAct: 'Maximum number of activities per week',
        nbrAct1: 'Number of activities',
        typeAct: 'Type of activities',
        pas: 'no specific setting for this policy',
        delaiMin: 'Minimum time between two reservations from the same member',
        nbrAu: 'Number of authorized reservations per month',
        list1: 'Scope of employees who benefit from self-service',
        list2: 'Self-service team',
        list3: 'Cross-functional team proposing its schedule',
      },
      DETAILS: {
        nettoyage: 'Strategy cleaning',
        reginerer: 'Generate strategy',
        Refresh: 'Refresh',
        generer: 'Generate',
        strategieCible: 'Strategy',
        Collaborateur: 'Collaborater',
        Status: 'Status',
        ListRDV: 'Appointment list',
        ListUSER: 'List of beneficiary users',
        ListUSER1: 'List of users open their calendar',
        DESC_1: 'Cancel all appointments that are not completed regardless of their status',
        DESC_2: 'Regenerate appointments and send invitations to employees',
        DESC_3: 'Are you sure you want to launch now',
        minute: 'Appointment regeneration may take up to a minute',
        BTN_NETOYER: 'Clean',
      },
    },
    TEMPS: {
      CONTRAT_HEURES: 'Contractual hours',
    },
    ALERTES: {
      LOADING_ALERTS: 'Loading alerts...',
      PLEASE_WAIT: 'Please wait',
      NO_ALERTS: 'No alerts',
      SENDER: 'Sent by',
      MESSAGE: 'Message',
      DATE: 'Date',
    },
    CONTROLEDESAISIE: {
      SessionExpired: 'Your session has expired. Please log in again',
      noSelection: 'No Selection',
      nofound: 'No data found',
      FetchFails: "Can't get data",
      dateDebutBeforeNow: 'The start date must be greater than the current date',
      dateFinAfterDateDebut: 'The end date must be greater than the start date',
      dateFinBeforeNow: 'The end date must be greater than the current date',
      dateFinEssai1AfterDateDebut: 'The end date of the first trial period must be after the contract start date',
      dateFinEssai2AfterDateFinEssai1:
        'The end date of the second trial period must be after the end date of the first trial period',
      VALID: ' has been entered correctly',
      required: ' is required',
      min: ' should have at least 3 symbols',
      min2: ' should have at least 2 symbols',
      max: ' should have maximum 500 symbols',
      email: ' format is incorrect',
      datemin: ' should have a number greater than 1',
      datemax: ' should have a number less than 32',
      notemin: ' should have a score greater than or equal to 0',
      notemax: ' should have a score lower than 6',
      notmatch: " didn't match",
      semaineMin: ' should have a number of days greater than 1',
      semaineMax: ' should have a number of days less than 60',
      semaineMin1: 'should have a number of weeks greater than 1',
      semaineMax1: ' should have a number of weeks less than 5',
      monthMin: 'should have a number of months greater than 1',
      monthMax: '',
      logicDate: 'end date must be superior to start date',
      minvalue: ' should have a number greater than 0',
      maxvalue: ' should have a number less than 100',
    },
    GERER: {
      Title: 'Your organization',
      IMAGE: 'Picture',
      nom: 'Name',
      pays: 'Pays',
      ville: 'City',
      USE_LOGO_IN_SIDEBAR: 'Use company logo in sidebar',
      USE_LOGO_IN_SIDEBAR_TOOLTIP:
        'Enable to display your company logo in the left sidebar. Disable to keep the EmyeHR logo.',
      BRANDING_COLORS_TITLE: 'Company colors',
      BRANDING_COLORS_HELP: 'Choose up to three colors for interview card themes.',
      BRAND_PRIMARY_COLOR: 'Primary color',
      BRAND_SECONDARY_COLOR: 'Secondary color',
      BRAND_TERTIARY_COLOR: 'Tertiary color',
      BRAND_COLOR_CLEAR: 'Clear',
      BRAND_COLOR_INVALID: 'Enter a hexadecimal color in #RRGGBB format.',
      BRAND_SETTINGS_INVALID: 'The company branding settings are invalid.',
      BRAND_TYPOGRAPHY_TITLE: 'Typography',
      BRAND_TYPOGRAPHY_HELP: 'Choose the font used in the interview completion window.',
      BRAND_TYPOGRAPHY_DEFAULT: 'None / current font',
      update: 'update',
    },
    motdepasse: {
      titre1: 'Change Password',
      titre2: 'Change Your Account Password',
      btnSave: 'Update',
      btnCancel: 'Cancel',
      err1: 'Configure users password to expire periodically. Users need to be warned that their passwords are going to expire, ',
      err2: 'or they might be inadvertently locked out of the system!',
      succes: 'Password changed successfully',
      verify: 'Verify your current password',
      currentpwd: 'Current Password',
      newpass: 'New Password',
      verifypass: 'Verify Password',
      passwordconfirm: 'Password confirmation',
      passwordRequirements: 'Password requirements:',
      minLength: 'At least 8 characters',
      hasUpperCase: 'At least one uppercase letter',
      hasLowerCase: 'At least one lowercase letter',
      hasNumeric: 'At least one number',
      hasSpecialChar: 'At least one special character',
    },
    disponibilite: {
      dispo: 'Availability',
      demander: 'Ask ',
      new: 'New availability',
      Search: 'Search for a date',
      all: 'in all fields',
      jour: 'Day',
      EVENT: 'Event',
    },
    deleteDispo: {
      title: 'Delete availability',
      msg1: 'Availability is deleting...',
      msg2: 'Are you sure to permanently delete this Availability?',
      btnCancel: 'Cancel',
      btnDelete: 'Delete',
    },
    createDisponibilite: {
      title: 'Create disponibility',
      new: 'New disponibility',
      date: 'Day',
      créneaux: 'Slots',
    },
    status: {
      created: 'created',
      accepted: 'accepted',
      refused: 'refused',
      finished: 'finished',
      canceled: 'canceled',
      notified: 'notified',
    },
    acceptMyAct: {
      title: 'Activity accept',
      info: 'Are you sure to accept this Activity?',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
    },
    EditMyAct: {
      Edit: 'Edit',
      Create: 'Create',
      comment: 'comment/rate',
      labelComment: 'Comment',
      valid1: 'Comment was entered correct',
      valid2: 'Comment should have at least 3 symbols',
      valid3: 'Comment should have maximum 10000 symbols',
      btnCancel: 'Cancel',
      btnSave: 'Save',
    },
    refuseMyAct: {
      title: 'Activity refuse',
      info: 'Are you sure to refuse this Activity ?',
      btnCancel: 'Cancel',
      btnAccept: 'Refuse',
    },
    cancelAct: {
      title: 'Activity cancel',
      info: 'Are you sure to cancel this Activity ?',
      btnCancel: 'Cancel',
      btnAccept: 'Save',
    },
    dialogInsc: {
      insc: 'Registration by link',
      btn: 'Copy',
    },
    jour: {
      importe: 'Any',
      dimanche: 'Sunday',
      lundi: 'Monday',
      mardi: 'Tuesday',
      mercredi: 'Wednesday',
      jeudi: 'Thursday',
      vendredi: 'Friday',
      samedi: 'Saturday',
    },
    typeDispo: {
      petitDej: 'Breakfast',
      dej: 'Lunch',
      afterwork: 'Afterwork',
      diner: 'Dinner',
    },
    editDispo: {
      Edit: 'Edit',
      Create: 'Create',
      dispo: 'Availablity',
      err1: 'Check your data ,',
      err2: 'Ouups! availability already exists!',
      selectDay: 'Select day',
      day: 'Day',
      selectType: 'Select type',
      type: 'Type',
      Cancel: 'Cancel',
      Save: 'Save',
    },
    ListeDesJeux: {
      ListJeux: 'Games list',
      jeuxAssoc: 'associated games',
      pasAssoc: 'non associated',
      joueurs: 'players',
    },
    gameOne: {
      ListJeux: 'games list',
      gereAssoc: 'manage associated strategies ',
      rein: 'reset stats',
      ListJeuxM: 'return',
      gereAssocM: 'manage',
      reinM: 'reset',
      desc: 'game complete description',
      points: 'points',
      numFois: 'number of times played',
      temp: 'average game time',
      collab: 'most active employees',
      date: 'date of last attendance',
      numDePart: 'number of entries',
      serviceActif: 'most active services',
      taux: 'participation rate',
      derparticipation: 'last participation date',
    },
    jeux: {
      play: 'play',
      played: 'finished',
      title: 'Game title :',
      quit: 'quit',
      actif: 'disabled',
      timer: 'ends in',
      timerDays: 'days',
    },
    popupstart: {
      liste: 'Strategies list',
      assoc: 'associate',
      dissoc: 'dissociate',
      activer: 'enable',
      des: 'disable',
      garde: 'keep the results secret until the end of the game',
    },
    assocStrat: {
      assoc: 'associate with a strategy',
      dateD: 'start date',
      dateF: 'end date',
      validate: 'validate',
      annuler: 'cancel',
    },
    sondage: {
      title: 'Surveys list',
      icon: 'ICÔNES',
      nom: 'NAME',
      description: 'DESCRIPTION',
      action: 'ACTIONS',
    },
    reset: {
      resettitle: 'are you sure you want to delete the statistics for this game ?',
      resetdesc:
        'WARNING: This will delete game statistics including score, time played, number of times played for all players belonging to the company',
      confirm: 'confirm',
    },
    wsregister: {
      wsr: 'GAME INTERFACE IS TEMPORARILY UNAVAILABLE !',
      wsolution:
        'it appears that game interface is not accessible for now, please be patient until the problem is fixed or you can try to solve this problem by reconnecting to our website. thank you for your understanding',
      annuler: 'cancel',
      déconnecter: 'deconnect',
    },
    HAUTPOTENTIEL: {
      head: 'Mark "High Potential"',
      body: 'Tag end date',
      comnt: 'Leave a comment',
    },
    DETAG: {
      TITLE: ' Delete collaborator tag',

      DESC_2: "Are you sure you want to permanently delete this collaborator's tag?",
      BTN_DELETE: 'Delete',
      BTN_CANCEL: 'Cancel',
    },
    SUIVIPAR: {
      head: 'Mark "Special follow-up"',
      body: 'Tag end date',
      comnt: 'Leave a comment',
    },
    DETAGSUIVIPAR: {
      TITLE: ' Delete collaborator tag',

      DESC_2: "Are you sure you want to permanently delete this collaborator's tag?",
      BTN_DELETE: 'Delete',
      BTN_CANCEL: 'Cancel',
    },
    presentation: {
      PERSO_INFO: 'Personal Informations',
      presentation: 'Presentation',
      parag: 'Presentation',
      date: 'Birthday',
      hobies: 'List of selected hobbies',
      AVAIL: 'Availabilities',
      succ: 'Profil changed successfully',
      allow: 'Allowed file types',
      btn: 'Update',
      COLLAB: 'Collaborator',
      ENTRE: 'Enterprise',
      EQUIPE: 'Team',
      SITE: 'Site',
      SERVICE: 'Service',
      msg: 'Pour valider votre profil cliquer sur la bouton mise à jour',
    },
    toastr: {
      evnt: 'You are registered for this event.',
      link: 'The link was copied correctly.',
      key: 'The key was copied correctly.',
      gnrl: 'Your give save successfully',
      pres_err: 'Be sure to select a video of size less than 10M!',
      pres_err1: 'Be sure to select a video!',
      pres_success: 'Your give save successfully',
      idea: 'No idea is being validated',
      eventinscrit: 'You are registered for an event',
      eventA_venir: 'Do not forget the event',
      prevus: 'prevus',
      eventinscritdate: 'prevu for the date of',
      titreevent: 'Event',
      absabonnementevent: 'Events are available in a higher offer',
      absabonnementidea: 'Ideas are available in a higher offer',
      suc: 'Operation successful',
      err: 'An error occurred',
    },
    Notification: {
      newnotification: 'New Notification',
      rendezvosmeeting: 'Meeting',
    },
    ANNONCE: {
      NVLANN: 'New announcement',
      ANN: 'Announcement',
      LISTANNONCE: 'List of announcements',
      MODIFANNONCE: 'Edit announcement',
      SUPPRIMERANNONCE: 'Delete announcement',
      MODAL_CREATE_TITLE: 'Create announcement',
      MODAL_EDIT_TITLE: 'Edit announcement',
      FIELD_TITLE: 'Announcement title',
      FIELD_DESCRIPTION: 'Description',
      FIELD_START_DATE: 'Announcement start date',
      FIELD_END_DATE: 'Announcement end date',
      FIELD_TARGET: 'Announcement target',
      PRIORITY_LABEL: 'Priority level',
      PRIORITY_BASE: 'Standard priority',
      PRIORITY_BASE_HINT: 'Default visibility for all collaborators',
      PRIORITY_MEDIUM: 'Medium priority',
      PRIORITY_MEDIUM_HINT: 'Highlighted in lists and notifications',
      PRIORITY_HIGH: 'High priority',
      PRIORITY_HIGH_HINT: 'Marked urgent for immediate visibility',
      TARGET_MANAGERS: 'Managers',
      TARGET_MANAGERS_PAIE: 'Payroll managers',
      TARGET_ADMINS_PAIE: 'Payroll admins',
      SELECT_MANAGERS: 'Select managers',
      SELECT_MANAGERS_PAIE: 'Select payroll managers',
      SELECT_ADMINS_PAIE: 'Select payroll admins',
      SEARCH_USER: 'Search a user...',
      NO_USER_FOUND: 'No user matches your search',
    },
    CONGE: {
      conge: 'Holiday',
      new: 'New holiday',
      dateDebut: ' Start date',
      dateFin: ' End date',
      EDIT: {
        NEW: 'New Leave',
        date_début: 'Start date',
        debut_ms: 'Beginning',
        date_fin: 'End date',
        fin_ms: 'End',
      },
      DELETE: {
        TITLE: ' Delete holiday',

        DESC_2: 'Are you sure you want to permanently delete this holiday?',
      },
    },
    PRESENTAION: {
      info: 'Information for ',
      VIDEO: 'Video',
      Presentation: 'Presentation',
      HOBIES: 'Hobbies',
      NOTAVAILBLE: ' not available',
    },
    Planning: {
      LIST: {
        TITLE: 'Shift',
        SITE: 'Site ',
        DT_BEBUT: 'Starting date',
        DT_FIN: 'End date',
        BTN: 'New Shift',
      },
      EDIT: {
        TITLE: 'Create Shift',
        TITLE1: 'Update Shift',
        SITE: 'Select Site',
        DT_BEBUT: 'Start date',
        DT_FIN: 'End date',
      },
      DELETE: {
        TITLE: 'Delete the schedule',
        CONTENT: 'delete shift...',

        CONTENT2: 'Are you sure you want to permanently delete this shift ?',
      },
    },
    TopBar: {
      ESPACE1: 'Administrator space',
      ESPACE2: 'Employee space',
    },
    CRON: {
      EVERY_MINUTE: 'Every minute',
      HOURLY_AT_MINUTE: 'Every hour at minute {{minute}}',
      DAILY_AT_TIME: 'Daily at {{hour}}:{{minute}}',
      WEEKLY_ON_DAY_AT_TIME: 'Weekly on {{day}} at {{hour}}:{{minute}}',
      MONTHLY_ON_DAY_AT_TIME: 'Monthly on day {{day}} at {{hour}}:{{minute}}',
      CUSTOM_SCHEDULE: 'Custom schedule',
      SUNDAY: 'Sunday',
      MONDAY: 'Monday',
      TUESDAY: 'Tuesday',
      WEDNESDAY: 'Wednesday',
      THURSDAY: 'Thursday',
      FRIDAY: 'Friday',
      SATURDAY: 'Saturday',
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications & Scheduling',
      TABS: {
        NEW: 'New',
        ALL: 'All',
        PLANS: 'Scheduling',
      },
      NO_NEW_ALERTS: 'No new alerts',
      NO_ALERTS: 'No notifications',
      NO_PLANS: 'No active schedules',
      PLANS: {
        TITLE: 'Scheduling',
        QUERY: 'Query',
        SCHEDULE: 'Schedule',
        PERIOD: 'Period',
        STATUS: 'Last execution status',
        STATUS_SUCCESS: 'Success',
        STATUS_ERROR: 'Error',
        STATUS_PENDING: 'Pending',
        DELETE: 'Delete',
        DELETE_CONFIRM_TITLE: 'Delete schedule',
        DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete this schedule? This action is irreversible.',
        DELETE_SUCCESS: 'Schedule deleted successfully',
        DELETE_ERROR: 'Error deleting schedule',
        LOAD_ERROR: 'Error loading schedules',
        LAST_RUN: 'Last run',
        STATUS_FAILED: 'Failed',
        STATUS_RUNNING: 'Running',
      },
    },
    COURRIERS_LIST: {
      LOAD_ERROR: "Error loading letters",
      PREVIEW_ERROR: "Error previewing the letter",

      HEADER_NO_NAME: "Unnamed header",
      HEADER_LOAD_WARNING: "Unable to load headers, continuing without",
      HEADER_PROCESSING_WARNING: "Unable to process header/footer, continuing without",
      HEADER_S3_ERROR: "Unable to retrieve header from server",

      CAMPAIGN_DATA_LOAD_WARNING: "Unable to load campaign data, continuing without",

      SIGNATURE_LOAD_WARNING: "Unable to load signature image, ignoring",
      SIGNATURE_S3_ERROR: "Unable to retrieve signature from server",

      PDF_CONVERT_ERROR: "Error converting PDF to image",
      CANVAS_CONTEXT_ERROR: "Unable to obtain canvas context.",

      S3_PDF_LOAD_FALLBACK: "Unable to load PDF from server, displaying HTML version"
    },
    EDIT_COURRIER_MODAL: {
      EDITOR_NOT_INITIALIZED: "Text editor is not initialized",
      EDITOR_PLACEHOLDER: "Edit the letter content...",

      SEND_SUCCESS: "Letter sent successfully!",
      SEND_ERROR: "Error sending the letter",

      SAVE_SUCCESS: "Letter updated successfully!",
      CONTENT_SAVE_SUCCESS: "Content saved successfully!",
      CONTENT_SAVE_ERROR: "Error saving content",

      PDF_GENERATION_ERROR: "Error: Unable to generate PDF",
      PDF_UPLOAD_ERROR: "Error uploading PDF",
      PDF_PREVIEW_ERROR: "Error generating PDF preview",
      PDF_BLOB_NULL: "PDF generation failed: empty result",
      PDF_CONVERT_ERROR: "Error converting PDF to image",

      UNAUTHORIZED_ERROR: "Error: Unauthorized (session expired?)",
      COURRIER_NOT_FOUND_ERROR: "Error: Letter not found",
      SERVER_ERROR: "Error: Server problem",

      HEADER_LOAD_PREVIEW_ERROR: "Unable to load header preview",
      HEADER_PROCESSING_WARNING: "Unable to process header/footer, continuing without",
      HEADER_S3_ERROR: "Unable to retrieve header from server",

      CAMPAIGN_DATA_LOAD_WARNING: "Unable to load campaign data, continuing without",

      SIGNATURE_LOAD_WARNING: "Unable to load signature image, ignoring",
      SIGNATURE_S3_ERROR: "Error retrieving signature from server",

      CANVAS_CONTEXT_ERROR: "Unable to obtain canvas context."
    },
    CAMPAIGN_COURRIER: {
      SETTING_TITLE: 'Mail Module',
      SETTING_ENABLED: 'Enabled',
      TITLE: 'Mail Campaign',
      LIST: 'Campaign List',
      CREATE: 'Create Campaign',
      EDIT_CAMPAIGN: 'Edit Campaign',
      DELETE: 'Delete Campaign',
      MODAL_CREATE_TITLE: 'Create Mail Campaign',
      MODAL_EDIT_TITLE: 'Edit Mail Campaign',
      FIELD_TITLE: 'Campaign Title',
      FIELD_DESCRIPTION: 'Description',
      FIELD_START_DATE: 'Start Date',
      FIELD_END_DATE: 'End Date',
      FIELD_TARGET: 'Campaign Target',
      PRIORITY_LABEL: 'Priority Level',
      PRIORITY_BASE: 'Standard Priority',
      PRIORITY_MEDIUM: 'Medium Priority',
      PRIORITY_HIGH: 'High Priority',
      DESCRIPTION: "Description",
      NBR_COLLABS: "Targeted collaborators",
      NBR_COURRIERS: "Sent letters",
      CREATED_BY: "Created by",
      UPDATED_AT: "Updated at",
      EDIT_REMETTANT: "Edit deliverer",
      SELECT_REMETTANT: "Select a deliverer",
      REMETTANT_UPDATED: "Deliverer updated successfully",
      REMETTANT_UPDATE_ERROR: "Error updating deliverer",
      
      CONFIGURATION: 'Configuration',
      MODIFICATION_VISUALIZATION: 'Modification and visualization',
      COURIER_MANAGEMENT: 'Letter management',
      CAMPAIGN_SETTINGS: 'Campaign settings',
      CAMPAIGN_NAME: 'Campaign name',
      CAMPAIGN_NAME_PLACEHOLDER: 'Ex: Salary Increase Campaign 2024',
      CAMPAIGN_NAME_REQUIRED: 'Name is required.',
      DESCRIPTION_PLACEHOLDER: 'Campaign description...',
      HEADER_PAPER: 'Header paper',
      SELECT_HEADER: 'Select a header',
      HEADER_REQUIRED: 'Header is required.',
      WHO_DELIVERS_MAIL: 'Who delivers the mail?',
      SELECT_MANAGER: 'Select a manager',
      FIELD_REQUIRED: 'Field required.',
      DESIGNATED_COLLABORATOR: 'Designated collaborator',
      SEARCH_COLLABORATOR: 'Search a collaborator...',
      COURIER_CONTENT: 'Letter content',
      COLLABORATOR_DATA: 'Collaborator Data',
      SEARCH: 'Search',
      YEAR: 'Year',
      REDUCE: 'Reduce',
      SHOW_MORE: 'Show more',
      NO_DATA_FOUND: 'No data found for "{{searchText}}"',
      CONTENT_REQUIRED: 'Content is required.',
      PREVIEW_RENDER: 'Preview render',
      GENERATE_PDF_PREVIEW: 'Generate PDF preview',
      NO_HEADER_LOADED: '(No header loaded)',
      GENERATING_PDF_PREVIEW: 'Generating PDF preview...',
      GENERATING_COURRIERS: 'Generating letters...',
      GENERATING_COURRIER_FOR: 'Generating letter',
      COURRIERS_GENERATED_SUCCESS: '{{count}} letter(s) generated successfully',
      COURRIERS_GENERATED_WITH_DUPLICATES: '{{generated}} letter(s) generated, {{duplicates}} already exist(s)',
      ALL_COURRIERS_ALREADY_EXIST: '{{count}} letter(s) already exist for these collaborators',
      COURRIERS_GENERATION_ERRORS: '{{count}} error(s) during generation',
      CREATE_CAMPAIGN_CONTINUE: 'Create campaign and continue',
      CREATING: 'Creating...',
      COURIER_LIST: 'Letter list',
      ADD_COLLABORATOR: 'Add a collaborator',
      SEARCH_COLLABORATOR_NAME: 'Search by collaborator name...',
      SEARCH_BY_REMETTANT_NAME: 'Search by deliverer name...',
      NAME_FIRSTNAME: 'Name and firstname',
      STATUS: 'Status',
      DELIVERED_BY: 'Delivered by',
      DELIVERY_FILTER: 'Delivery',
      CONSULTATION_FILTER: 'Consultation',
      ALL_DELIVERY_STATUSES: 'All delivery statuses',
      ALL_CONSULTATION_STATUSES: 'All consultation statuses',
      DELIVERED: 'Delivered',
      CONSULTED: 'Consulted',
      ACTIONS: 'Actions',
      PREVIEW: 'Preview',
      EDIT: 'Edit',
      SEND: 'Send',
      SELECT: 'Select',
      NO_LETTER_ADDED: 'No letter added for the moment.',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      CANCEL: 'Cancel',
      EXIT: 'Exit',
      ADD_LETTER: 'Add a letter',
      SEARCH_BY_COLLABORATOR_NAME: 'Search by collaborator name...',
      EDIT_LETTER: 'Edit letter - {{prenom}} {{nom}}',
      LETTER_CONTENT: 'Letter content',
      SAVE: 'Save',
      SELECT_TARGET: 'Select target',
      TARGET: 'Target',
      SINGLE_COLLABORATOR: 'Single collaborator',
      SITES: 'Site(s)',
      SERVICES: 'Service(s)',
      TEAMS: 'Team(s)',
      PAYROLL_MANAGERS: 'Payroll managers',
      PAYROLL_ADMINS: 'Payroll admins',
      COLLABORATOR: 'Collaborator',
      CONFIRM: 'Confirm',
      MANAGE_LETTERS: 'Manage letters',
      NO_LETTER_ADDED_YET: 'No letter added yet.',
      FORMULA_CALCULATION_TEST: 'Formula Calculation Test',
      LAUNCH_ALL_TESTS: 'Launch all tests',
      CALCULATION_IN_PROGRESS: 'Calculation in progress...',
      RESET: 'Reset',
      CALCULATION_RESULTS: 'Calculation Results',
      VARIABLE: 'Variable',
      CODE: 'Code',
      TYPE: 'Type',
      FORMULA: 'Formula',
      RESULT: 'Result',
      SUCCESS_STATUS: 'Success',
      ERROR_MSG: 'Error',
      MISSING: 'Missing',
      ERROR_STATUS: 'Error',
      SUCCESS: 'Success',
      MISSING_COUNT: 'Missing',
      ERRORS: 'Errors',
      TOTAL: 'Total',
      NO_TEST_EXECUTED: 'No test executed',
      CLICK_LAUNCH_TESTS: 'Click "Launch all tests" to start formula calculation.',
      MANAGE_COURIER: 'Manage Courier',
      SENT: 'Sent',
      DRAFT: 'Draft',
      DELETED: 'Deleted',
      DELETE_LETTER: "Delete letter",
      DELETE_LETTER_CONFIRM: "Are you sure you want to delete this letter?",
      DELETE_LETTER_IMPOSSIBLE: "Cannot delete this letter. It may already be in use.",
      DELETE_LETTER_IRREVERSIBLE: "This action is irreversible.",
      DELETING_LETTER: "Deleting letter...",
      COURRIER_DELETED_SUCCESS: "Letter deleted successfully",
      COURRIER_DELETE_ERROR: "Error deleting letter",
      FORMULA_HELP_TITLE: 'Mathematical Formulas',
      FORMULA_HELP_TEXT: 'You can insert mathematical formulas that will be calculated automatically. Formulas must start with the "=" sign.',
      FORMULA_EXAMPLES_TITLE: 'Formula example: ={{a}}+{{b}}',
      RETURN_TO_DRAFT: "Return to draft",
      RETURN_TO_DRAFT_CONFIRM: "Are you sure you want to return this letter to draft?",
      RETURNING_TO_DRAFT: "Returning to draft...",
      COURRIER_RETURNED_SUCCESS: "Letter returned to draft successfully",
      COURRIER_RETURN_ERROR: "Error returning letter to draft",
      EDIT_TEMPLATE: "Edit Template",
      TEMPLATE_MODIFICATION_WARNING: "Warning: Modifying this template will not affect already generated letters. Only new letters will use this updated template.",
      SIGNATURES: 'Signatures',
      SIGNATURE: 'Signature',
      SIGNATURE_UPLOAD: 'Upload signature',
      SIGNATURE_POSITION: 'Signature position',
      SIGNATURE_PREVIEW: 'Signature preview',
      NO_SIGNATURES: 'No signatures added',
      ADD_SIGNATURES: 'Add signature',
      SIGNATURE_IMAGE_SPECS: 'The image must be 800x800 pixels and not exceed 200Ko',
      SIGNATURE_FORMAT_INFO: 'Recommended format: PNG or JPG, 800x800px, max 200Ko',
      SIGNATURE_SIZE: 'Signature size',
      REMETTANT_FETCH_WARNING: "Unable to retrieve remittant, continuing without",

      STEP1_REQUIRED_FIELDS: "Please fill in all required fields before continuing.",
      COMPLETE_PREVIOUS_STEPS: "Please complete the previous steps before continuing.",
      FORMS_INVALID: "Please check the forms.",

      HEADER_NO_NAME: "Unnamed header",
      HEADER_LOAD_ERROR: "Unable to load the header list",
      HEADER_FILE_NOT_FOUND: "File not found for this header.",
      HEADER_PREVIEW_ERROR: "Unable to preview the document.",
      HEADER_LOAD_PREVIEW_ERROR: "Unable to load header preview",
      HEADER_PROCESSING_WARNING: "Unable to process header/footer, continuing without",

      COLLABORATORS_LOAD_ERROR: "Unable to load collaborators",
      COLLABORATORS_FETCH_ERROR: "Error retrieving collaborators",
      NO_COLLABORATORS_FOUND: "No collaborators found for this target",

      VARIABLES_LOAD_ERROR: "Unable to load the variables list from payroll data.",
      PAIES_DATA_LOAD_WARNING: "Unable to load payroll data, continuing without",

      CAMPAIGN_ALREADY_CREATED: "The campaign is already created. You can no longer modify the template.",
      CAMPAIGN_AUTO_CREATED: "Campaign created automatically with success",
      CAMPAIGN_AUTO_CREATE_ERROR: "Error during automatic creation",
      CAMPAIGN_CREATED: "Campaign created successfully",
      CAMPAIGN_CREATE_ERROR: "Error during creation",
      CAMPAIGN_DATA_LOAD_WARNING: "Unable to load campaign data, continuing without",
      CAMPAIGN_SIGNATURES_LOAD_WARNING: "Unable to load campaign signatures, continuing without",

      EDITOR_INIT_ERROR: "Unable to initialize the text editor",
      EDITOR_NOT_INITIALIZED: "Text editor is not initialized",

      PDF_PREVIEW_GENERATED: "PDF preview generated!",
      PDF_PREVIEW_ERROR: "Error generating PDF preview",
      PDF_PREVIEW_FALLBACK: "Unable to generate PDF, displaying HTML preview",
      PDF_BLOB_NULL: "PDF generation failed: empty result",
      PDF_BLOB_EMPTY: "Generated PDF is empty",
      PDF_COURRIER_PREVIEW_SUCCESS: "PDF preview generated for {{prenom}} {{nom}}!",

      CANVAS_CONTEXT_ERROR: "Unable to obtain canvas context.",

      SIGNATURE_BUILD_ERROR: "Error building signature element",
      SIGNATURE_LOAD_ERROR: "Error loading signature image",
      SIGNATURE_S3_ERROR: "Unable to retrieve signature from server",
      SIGNATURE_UPLOAD_ERROR: "Error uploading signature",
      SIGNATURE_SIZE_EXCEEDED: "Image must not exceed 200KB",
      SIGNATURE_DIMENSIONS_EXCEEDED: "Image dimensions must not exceed 800x800px",
      SIGNATURE_REMOVED: "Signature removed successfully",

      COURRIER_UPDATED: "Letter updated successfully!",
      COURRIER_GENERATION_COLLAB_ERROR: "Error for collaborator {{id}}",
      COURRIERS_LOAD_ERROR: "Error loading letters for this campaign",
      COURRIERS_GENERATED: "{{count}} letter(s) generated successfully",
      COURRIERS_ALREADY_EXIST: "{{count}} letter(s) already exist for these collaborators",

      RETURN_TO_DRAFT_SUCCESS: "Letter returned to draft successfully",
      RETURN_TO_DRAFT_ERROR: "Error returning letter to draft",

      AI_TEST_SELECT_COLLABORATOR: "Please select a collaborator",
      AI_TEST_EMPTY_TEMPLATE: "Letter content is empty",
      AI_TEST_SUCCESS: "Preview generated successfully",
      AI_TEST_ERROR: "Error during generation",
      AI_GENERATION_ERROR: "Error during AI generation",
      AI_GENERATION_FALLBACK_WARNING: "AI generation failed, using raw template",

      SELECT_HEADER_FIRST: "Please select a header first.",

      UNKNOWN_NOM: "Unknown last name",
      UNKNOWN_PRENOM: "Unknown first name",

      DELIVERED_DIRECTLY: "Delivered directly",

      DELETE_CANCELLED: "Deletion cancelled",
      READING_DATE: "Reading date",
      DELIVERY_DATE: "Delivery date",
      NOT_CONSULTED: "Not consulted",
      NOT_DELIVERED: "Not tr",
      INVALID_DATE: "Invalid date",
      MARK_AS_DELIVERED: "Mark as delivered",
      MARK_AS_DELIVERED_SUCCESS: "Courrier marked as delivered successfully",
      MARK_AS_DELIVERED_ERROR: "Error marking courrier as delivered",
      READY: 'Ready',
      SAVE_READY: 'Save as ready to send',
      MARK_AS_READY: 'Mark as ready',
      COURRIER_MARKED_READY: 'Courier marked as ready successfully',
      COURRIER_READY_ERROR: 'Error when marking courier as ready',
      IMAGE_FORMAT_NOT_SUPPORTED: 'Unsupported image format. Supported formats: PNG, JPEG, JPG',
      SIGNATURE_FORMAT_ERROR: 'Unsupported signature image format',
      HEADER_FORMAT_ERROR: 'Unsupported header image format',
      MUST_SAVE_BEFORE_STEP3: 'Please save the campaign.',
      PDF_DELETE_ERROR: "Error deleting PDF",
      DOWNLOAD_PDF: 'Download PDF',
      DOWNLOAD_PDF_TITLE: 'Download letter PDF',
      PDF_DOWNLOAD_SUCCESS: 'PDF downloaded successfully',
      PDF_DOWNLOAD_ERROR: 'Error downloading PDF',
      // Translate the optional response configuration and administrator campaign results.
      RESPONSE_REQUIRED: 'Collaborator response',
      RESPONSE_REQUIRED_HELP: 'Request a choice from the collaborator for this campaign',
      RESPONSE_QUESTION: 'Question',
      RESPONSE_QUESTION_PLACEHOLDER: 'E.g. Do you accept this proposal?',
      RESPONSE_OPTIONS: 'Available choices',
      ADD_RESPONSE_OPTION: 'Add a choice',
      RESPONSE_CONFIGURATION_INVALID: 'Enter a question and at least two different choices.',
      RESULTS: 'Results',
      TARGETED: 'Targeted collaborators',
      RESPONDENTS: 'Respondents',
      NON_RESPONDENTS: 'No response',
      RESPONSE_RATE: 'Response rate',
      ANSWER: 'Answer',
      RESPONSE_DATE: 'Response date',
      NO_RESPONSE: 'No response',
      NO_RESPONSE_QUESTION: 'This campaign does not request a response.',
      RESULTS_LOAD_ERROR: 'Error loading the results.',
      // Translations for multi-question configuration and free-text answers.
      QUESTION: 'Question',
      ADD_QUESTION: 'Add a question',
      OPTION_PLACEHOLDER: 'Choice',
      ALLOW_FREE_TEXT: 'Allow a free-text answer',
      QUESTION_CONFIGURATION_INVALID: 'Incomplete question: label required, two distinct choices or free text allowed.',
      FREE_TEXT_ANSWERS: 'Free-text answers'

      
 },   
    COURRIER: {
      AI_INSTRUCTIONS: {
        TITLE: "Custom AI Instructions",
        DESCRIPTION: "Define conditions to include or exclude sections of the letter (e.g., promotion, deferred cap, etc.)",
        PLACEHOLDER: "E.g.: If bonus_2025 > 10000, include the promotion paragraph.\nIf the sum of columns X + Y + Z exceeds 50000, it's a deferred cap case.",
        SEARCH_VARIABLE: "Search for a variable to insert...",
      },
      AI_TEST: {
        BUTTON: "Test with AI",
        BUTTON_TITLE: "Test the letter with a collaborator",
        PANEL_TITLE: "AI Test with Collaborator",
        SELECT_COLLABORATOR: "Select a collaborator to test",
        SEARCH_PLACEHOLDER: "Search for a collaborator...",
        GENERATE: "Generate AI Preview",
        GENERATING: "Generating...",
        RESULT_TITLE: "AI Generation Result",
        SUCCESS: "Preview generated successfully",
        ERROR: "Error during AI generation",
        EMPTY_TEMPLATE: "The letter content is empty",
      },
     DEFAULT_TEMPLATE: `<p style="text-align: right;">Paris le XX/XX/XXXX</p>
<p style="text-align: right;">&nbsp;</p>
<p style="text-align: right;">A l'attention de [Monsieur/Madame] {{nom}}</p>
<p>&nbsp;</p>
<p><strong>Objet : Rémunération 2026</strong></p>
<p>&nbsp;</p>
<p>[Monsieur/Madame],</p>
<p>&nbsp;</p>
<p>J'ai le plaisir de vous annoncer que votre rémunération variable attribuée au titre de 2025 s'élève à =({{bonus_n_euro}}+{{portion_differee_2026}}+{{portion_differee_2027}}+{{portion_differee_2028}}) euros, se décomposant comme suit conformément à la politique de rémunération de XXXX en vigueur :</p>
<p>&nbsp;</p>
<ul>
<li>{{bonus_n_euro}} euros bruts versés en mars 2026 au titre du bonus,</li>
<li>=({{portion_differee_2026}}+{{portion_differee_2027}}+{{portion_differee_2028}}) euros bruts total sous forme de rémunération variable différée et à acquérir par tiers sur les 3 prochaines années sous conditions (2027,2028,2029)<sup>1</sup></li>
</ul>
<p>&nbsp;</p>
<p>J'ai également le plaisir de vous annoncer que vous êtes promu au poste de {{nouvelle_fonction_promo}}. Votre rémunération de base annuelle (temps plein) est portée à {{salaire_fixe_n_propose_euro}} euros bruts à compter du 1<sup>er</sup> janvier 2026, soit une augmentation de ={{salaire_fixe_n_propose_euro}}-{{salaire_fixe_n_1_euro}} euros.</p>
<p>&nbsp;</p>
<p>Je vous remercie de votre contribution aux résultats de l'entreprise et je vous prie d'agréer,</p>
<p>[Monsieur/Madame], l'expression de mes salutations distinguées.</p>
<p>&nbsp;</p>
<p style="text-align: right;"><strong>XXXX</strong></p>
<p style="text-align: right;">Directeur Général Délégué</p>`,
    },
    AI_COURRIER: {
      VERIFICATION_AGENT: {
          LABEL: "Verification Agent",
          TOOLTIP: "Checks and automatically corrects errors, not guarantee 100% correction.",
          DESCRIPTION: "The verification agent checks each generated letter and attempts to automatically correct errors (up to 3 attempts). It reduces errors but does not guarantee 100% correction.",
          STATUS_ENABLED: "Verification agent enabled",
          STATUS_DISABLED: "Verification agent disabled",
          CREDIT_WARNING_TITLE: "Additional credits consumption",
          CREDIT_WARNING_DESC:"The verification agent performs an additional check on the generated content. This consumes more AI credits per generated letter.",

      },
      AI_INSTRUCTIONS: {
        TITLE: "Custom AI Instructions",
        DESCRIPTION: "Define conditions to include or exclude sections of the letter (e.g., promotion, deferred cap, etc.)",
        DEFAULT: "Choose ‘Mr.’ if the collaborator’s gender is M, and ‘Ms.’ if it is F.",
        PLACEHOLDER: "E.g.: If bonus_2025 > 10000, include the promotion paragraph.\nIf the sum of columns X + Y + Z exceeds 50000, it's a deferred cap case.",
        SEARCH_VARIABLE: "Search for a variable to insert...",
      },
      AI_TEST: {
        BUTTON: "Test with AI",
        BUTTON_TITLE: "Test the letter with a collaborator",
        PANEL_TITLE: "AI Test with Collaborator",
        SELECT_COLLABORATOR: "Select a collaborator to test",
        SEARCH_PLACEHOLDER: "Search for a collaborator...",
        GENERATE: "Generate AI Preview",
        GENERATING: "Generating...",
        RESULT_TITLE: "AI Generation Result",
        SUCCESS: "Preview generated successfully",
        ERROR: "Error during AI generation",
        EMPTY_TEMPLATE: "The letter content is empty",
      },
      DEFAULT_TEMPLATE: `<p style="text-align: right;">Paris le [jour/mois] 2026</p>
<p style="text-align: right;">&nbsp;</p>
<p style="text-align: right;">A l'attention de [Monsieur/Madame] {{nom}}</p>
<p>&nbsp;</p>
<p><strong>Objet : Rémunération 2026</strong></p>
<p>&nbsp;</p>
<p>[Monsieur/Madame],</p>
<p>&nbsp;</p>
<p>J'ai le plaisir de vous annoncer que votre rémunération variable attribuée au titre de 2025 s'élève à =({{bonus_n_euro}}+{{portion_differee_2026}}+{{portion_differee_2027}}+{{portion_differee_2028}}) euros, se décomposant comme suit conformément à la politique de rémunération de Vauban Infrastructure Partners en vigueur :</p>
<p>&nbsp;</p>
<ul>
<li>{{bonus_n_euro}} euros bruts versés en mars 2026 au titre du bonus,</li>
<li>=({{portion_differee_2026}}+{{portion_differee_2027}}+{{portion_differee_2028}}) euros bruts total sous forme de rémunération variable différée et à acquérir par tiers sur les 3 prochaines années sous conditions (2027,2028,2029)<sup>1</sup></li>
</ul>
<p>&nbsp;</p>
<p>J'ai également le plaisir de vous annoncer que vous êtes promu au poste de {{nouvelle_fonction_promo}}. Votre rémunération de base annuelle (temps plein) est portée à {{salaire_fixe_n_propose_euro}} euros bruts à compter du 1<sup>er</sup> janvier 2026, soit une augmentation de ={{salaire_fixe_n_propose_euro}}-{{salaire_fixe_n_1_euro}} euros.</p>
<p>&nbsp;</p>
<p>Je vous remercie de votre contribution aux résultats de l'entreprise et je vous prie d'agréer,</p>
<p>[Monsieur/Madame], l'expression de mes salutations distinguées.</p>
<p>&nbsp;</p>
<p style="text-align: right;"><strong>Mounir CORM</strong></p>
<p style="text-align: right;">Directeur Général Délégué</p>`,
    },
    MES_COURRIERS: {
      TITLE: "My Letters",
      SEARCH_BY_COLLABORATOR_NAME: "Search by collaborator name",
      NAME_FIRSTNAME: "Name & Firstname",
      CONSULTATION_DATE: "Consultation Date",
      ACTIONS: "Actions",
      PREVIEW: "Preview",
      NOT_CONSULTED: "Not consulted",
      NO_LETTER_FOUND: "No letter found",
      LOADING_PREVIEW: "Loading preview...",
      CLOSE: "Close",
      MY_LETTERS: "My Letters",
      TEAM_LETTERS: "Team Letters",
      MY_LETTERS_NO_LETTER_FOUND: "No letter found",
      TEAM_LETTERS_NO_LETTER_FOUND: "No letter found for the team",
      CAMPAIGN: 'Campaign',
      SEARCH_BY_CAMPAIGN: 'Search by campaign',
      DELIVERY_DATE: "Delivery date",
      NOT_DELIVERED: "Not delivered",
      INVALID_DATE: "Invalid date",
      DECLARE_AS_DELIVERED: "Declare as delivered",
      MARK_AS_DELIVERED_SUCCESS: "Courrier marked as delivered successfully",
      MARK_AS_DELIVERED_ERROR: "Error marking courrier as delivered",
      // Translate the collaborator confirmation and immutable recorded response state.
      RESPONSE_CONFIRM: "Permanently confirm the answer “{{option}}”?",
      FREE_TEXT_PLACEHOLDER: "Or type your own answer…",
      SUBMIT_RESPONSES: "Submit my answers",
      RESPONSES_INCOMPLETE: "Answer every question before submitting.",
      RESPONSES_CONFIRM: "Your answers will be recorded permanently and cannot be changed.",
      RESPONSE_CONFIRM_TITLE: "Confirm your response",
      RESPONSE_CONFIRM_OK: "Confirm",
      RESPONSE_CONFIRM_CANCEL: "Cancel",
      RESPONSE_SUCCESS: "Your response has been recorded.",
      RESPONSE_ERROR: "Unable to record your response.",
      YOUR_RESPONSE: "Your response"
    },
    COMMON: {
      YES: 'Yes',
      NO: 'No',
      SUCCESS: 'Success',
      ERROR: 'Error',
    },
    SKILLS: {
      TITLE: 'Skills Management',
      ADD_SKILL: 'Add Skill',
      EDIT_SKILL: 'Edit Skill',
      DELETE_TITLE: 'Delete Skill',
      DELETE_CONFIRM: 'Are you sure you want to delete this skill?',
      TRANSLATE: 'Translate',
      CREATED_FOR_ALL_LANGUAGES: 'The skill will be created for all enterprise languages.',
      CUSTOM_SKILLS: 'Custom Skills',
      SHARED_SKILLS: 'Shared Skills',
      SHARED_SKILLS_INFO: 'These skills are shared and cannot be modified.',
      SKILL_LABEL: 'Skill Name',
      SKILL_LABEL_PLACEHOLDER: 'Enter skill name',
      DESCRIPTION: 'Description',
      DESCRIPTION_PLACEHOLDER: 'Enter a description (optional)',
      ACTIONS: 'Actions',
      RELATED_USERS: 'Related users',
      MANAGE_USERS: {
        TITLE: 'Manage users',
        SEARCH: 'Search users...',
        NO_USERS: 'No users found',
        ALREADY_LINKED: 'Linked',
        SAVE: 'Save',
        SAVED: 'Users updated successfully',
        LOAD_ERROR: 'Failed to load users',
        SAVE_ERROR: 'Failed to save users',
        INVALID_SKILL: 'Invalid skill',
        RATING_REQUIRED: 'Please select a level (1 to 5 stars) for each selected user',
      },
      SEARCH_PLACEHOLDER: 'Search for a skill...',
      SEARCH_SKILLS: 'Search for skills',
      NO_CUSTOM_SKILLS: 'No custom skills',
      NO_SHARED_SKILLS: 'No shared skills found',
      LABEL_REQUIRED: 'Skill name is required',
      DOMAIN_REQUIRED: 'Domain is required',
      TOAST_CREATED: 'Skill created successfully',
      TOAST_DOMAIN_CREATED: 'Skill domain created successfully',
      TOAST_DOMAIN_UPDATED: 'Skill domain updated successfully',
      TOAST_DOMAIN_DELETED: 'Skill domain deleted successfully',
      MANAGE_DOMAINS: 'Manage domains',
      MANAGE_DOMAINS_CREATE: 'Create domain',
      MANAGE_DOMAINS_MANAGE: 'Manage domains list',
      MANAGE_DOMAINS_CREATE_TITLE: 'Create a new domain',
      MANAGE_DOMAINS_CREATE_DESC: 'Launch the guided creator to define a domain with translations.',
      MANAGE_DOMAINS_CREATE_CTA: 'Create domain',
      MANAGE_DOMAINS_LIST_TITLE: 'Manage existing domains',
      MANAGE_DOMAINS_LIST_DESC: 'View, search and maintain the domains already configured.',
      MANAGE_DOMAINS_LIST_CTA: 'Open manager',
      MANAGE_DOMAINS_LIST_HEADER: 'Custom domains',
      MANAGE_DOMAINS_LIST_HINT: '{{count}} domain(s) available',
      COMPETENCE_CUSTOM_ACTIF: {
        OPEN: 'Skills source settings',
        TITLE: 'Skills source',
        LABEL: 'Use skills from:',
        STANDARD_ONLY: 'Use standard skills only',
        CUSTOM_ONLY: 'Use custom skills only',
        BOTH: 'Use both',
        LOAD_ERROR: 'Failed to load skill source configuration',
        SAVE_ERROR: 'Failed to save skill source configuration',
        SAVED: 'Skill source configuration updated',
      },
      DOMAIN_LINKED_SKILLS_TITLE: 'Linked skills',
      NO_DESCRIPTION: 'No description provided',
      NO_CUSTOM_DOMAINS: 'No custom domains',
      TOAST_UPDATED: 'Skill updated successfully',
      TOAST_DELETED: 'Skill deleted successfully',
      TOAST_ERROR: 'An error occurred',
      SKILL_TYPE: 'Type',
      STATUS: 'Status',
      REUSE_LEVEL: 'Reuse Level',
      DEFINITION: 'Definition',
      SCOPE_NOTE: 'Scope Note',
      SKILL_URI: 'Skill URI',
      SYNONYMS: 'Synonyms',
      DOMAIN_FILTER: 'Domain',
      ALL_DOMAINS: 'All domains',
      DOMAIN: 'Domain',
      DOMAIN_SELECT: 'Select a domain',
      DOMAIN_CREATE_TOGGLE: 'Create a new domain',
      DOMAIN_UPDATE_TOGGLE: 'Update domain',
      DOMAIN_LABEL: 'Domain label',
      DOMAIN_LABEL_PLACEHOLDER: 'Enter domain label',
      DOMAIN_LABEL_REQUIRED: 'Domain label is required',
      DOMAIN_CREATE: 'Create',
      DOMAIN_UPDATE: 'Update',
      DOMAIN_NEW: 'New domain',
      DOMAIN_DELETE_TITLE: 'Delete domain',
      DOMAIN_DELETE_CONFIRM: 'Are you sure you want to delete this domain?',
      PARENT_URI: 'Parent URI',
      PARENT_URI_PLACEHOLDER: 'Enter parent URI (optional)',
      PARENT_LABEL: 'Parent Label',
      PARENT_LABEL_PLACEHOLDER: 'Enter parent label (optional)',
      INVALID_URL: 'Please enter a valid URL',
      LANGUAGE_NOTE: 'The skill language will be automatically set based on your user language.',
      // The skills import assistant keeps all visible copy in the bilingual SKILLS.IMPORT namespace.
      IMPORT: {
        BUTTON: 'Import with AI',
        TITLE: 'Adaptive skills import',
        SUBTITLE: 'Analyze variable file layouts, review every proposal, then apply only confirmed rows.',
        STEPS: {
          STEP_1: 'Files and instructions',
          STEP_2: 'Domains',
          STEP_3: 'Skills',
          STEP_4: 'Associations and assessments',
        },
        FILES: {
          KICKER: 'Source lot',
          TITLE: 'Add your files',
          DESCRIPTION: 'Add up to 20 PDF, XLS, or XLSX files. Layouts may vary; no fixed template is required.',
          DROP_TITLE: 'Drop files here or press to browse',
          DROP_HINT: 'PDF up to 10 MB, Excel up to 25 MB, 50 MB per lot',
          REMOVE: 'Remove file',
          KB: 'KB',
          MB: 'MB',
          STATUS_READY: 'Ready to analyze',
          STATUS_ANALYZING: 'Analyzing',
          STATUS_ANALYZED: 'Analyzed',
          STATUS_FAILED: 'Analysis failed',
          STATUS_IGNORED: 'Explicitly ignored',
          STATUS_DUPLICATE: 'Binary duplicate, analysis reused',
        },
        INSTRUCTIONS: {
          LABEL: 'Instructions for AI',
          PLACEHOLDER: 'Example: import only skills from the 2026 sheet and ignore assessments.',
          HELP: 'Specify relevant sheets, periods, rating types, exclusions, or identity rules.',
        },
        QUESTIONS: {
          TITLE: 'Details required',
          UNRESOLVED: 'required question(s) unresolved',
          ANSWER: 'Your answer',
          // Model-ranked suggestions remain optional; the last choice always accepts an explicit human answer.
          RECOMMENDED: 'Recommended',
          OTHER: 'Other: write my own answer',
          ACTION_REQUIRED: 'Action required',
          WAITING: 'Processing',
          REVIEWED: 'Answers saved locally',
          REQUIRED: '(required)',
          ANSWERS_REQUIRED: 'Answer the required questions below to continue reviewing the catalogue.',
          PROCESSING: 'Please wait while processing continues. You can answer the questions when it finishes.',
          ANSWERS_LOCAL: 'Your answers stay local and are sent only with the association analysis.',
        },
        PROCESSING: {
          TITLE: 'Processing your import',
          EXECUTING: 'Applying validated data…',
          ASSOCIATIONS: 'Analyzing associations…',
          HELP: 'Please wait without closing this page. Actions are temporarily blocked while processing is in progress.',
        },
        SCOPE: {
          TITLE: 'Detected scope',
          COMPLETE: 'Complete coverage',
          INCOMPLETE: 'Coverage requires review',
          UNPROCESSED_TITLE: 'Unprocessed sheets',
          CONFIRM_PARTIAL: 'I have reviewed the unprocessed sheets and want to continue using only verified data from the other sheets.',
          NO_CANDIDATES_REASON: 'No usable data was extracted from this sheet.',
        },
        SCALE: {
          TITLE: 'Level mapping',
          HELP: 'Explicitly confirm how each scale maps to integer levels from 1 to 5.',
        },
        PERIODS: {
          LABEL: 'Source period',
        },
        REVIEW: {
          KICKER: 'Controlled review',
          DOMAINS_DESCRIPTION: 'Resolve every domain before continuing to dependent skills.',
          SKILLS_DESCRIPTION: 'Review the real parent, cross-domain duplicates, and multilingual impact.',
          ASSESSMENTS_DESCRIPTION: 'Select existing employees only and keep self and assigned scores separate.',
          STATUS_FILTER: 'Filter by status',
          ALL_STATUSES: 'All statuses',
          LOADING: 'Preparing review…',
          EMPTY_STEP: 'No rows were proposed for this step. The step remains visible and can be completed.',
          SELECT_ROW: 'Select this row',
          RAW: 'Source value',
          EXISTING: 'Existing value',
          EFFECTIVE: 'Effective value',
          DESCRIPTION: 'Effective description',
          PARENT: 'Source domain',
          SELECT_PARENT: 'Select an applied or reused domain',
          SHARED_READ_ONLY: 'Read-only shared catalogue',
          CREATE_TRANSLATION_NOTICE: 'Creation may copy source text across enterprise languages. Automatically translated content is not promised.',
          EMPLOYEE: 'Existing employee',
          SELECT_EMPLOYEE: 'Select an employee',
          SEARCH_EMPLOYEE: 'Search by name, email or employee number…',
          NO_EMPLOYEES_FOUND: 'No matching employee',
          CLEAR_EMPLOYEE: 'Clear selection',
          SKILL: 'Applied or reused skill',
          SELECT_SKILL: 'Select a skill',
          SELF_SCORE: 'Self-assessment',
          ASSIGNED_SCORE: 'Manager/admin assigned score',
          OLD_VALUE: 'Current value',
          RAW_VALUE: 'Raw value',
          // Extraction omissions are visible even after automatic navigation to review.
          EXTRACTION_NOTICES: 'Items to review and omitted sources ({{count}})',
          PARTIAL_MAPPING_NOTICE: 'Score conversion or mapping entry no. {{index}} was ignored because its validity could not be established. Other data is preserved.',
          PARTIAL_LINE_NOTICE: 'Association proposal no. {{index}} was ignored because it cannot be verified. This number refers to its position in the AI output, not a row in the Excel file.',
          PARTIAL_ASSOCIATIONS_CONFIRM: 'I confirm that I want to continue using only validated associations and scores. No discarded score will be applied.',
          PARTIAL_MORE_NOTICE: 'Additional issues not detailed in this list: {{count}}.',
          MORE_NOTICES: 'Show {{count}} more explanations',
          PROPOSED_VALUE: 'Confirmed level (1 to 5)',
          UNSPECIFIED: 'Unspecified, preserve existing value',
          CONFIRM_UNSCORED_ASSOCIATION: 'Create or keep this association without importing a score. Existing scores are preserved.',
          LINK_SUBSTEP: 'Association',
          ASSIGNED_SUBSTEP: 'Assigned score',
          SELF_SUBSTEP: 'Self-assessment',
          NO_PROVENANCE: 'Provenance unavailable',
          SHEET_NAME: 'Sheet name: {{sheet}}',
          UNRESOLVED_COUNT: '{{count}} row(s) remaining',
          REASONS: {
            EXACT_DOMAIN_MATCH: 'Matching existing domain',
            NEW_DOMAIN: 'New domain proposed',
            EXACT_SHARED_SKILL_MATCH: 'Matching shared skill',
            EXACT_CUSTOM_SKILL_MATCH: 'Matching custom skill',
            NEW_SKILL: 'New skill proposed',
            CROSS_DOMAIN_DUPLICATE: 'The same label already exists in another domain',
            EXACT_EMPLOYEE_MATCH: 'Employee identified with certainty',
            NAME_MATCH_REQUIRES_CONFIRMATION: 'Name match requires confirmation',
            EMPLOYEE_REQUIRED: 'Existing employee required',
            SCALE_MAPPING_REQUIRED: 'Scale mapping required',
            UNSCORED_ASSOCIATION_REQUIRES_CONFIRMATION: 'Explicitly confirm an unscored association or provide at least one assessment',
            DUPLICATE_ACQUIRED_SKILL_URI: 'Multiple acquired associations exist for this URI',
            DOMAIN_SOURCE_REQUIRED: 'The source domain must be clarified or reassigned',
            SKILL_SOURCE_REQUIRED: 'The source skill must be clarified or reassigned',
            ASSOCIATION_DOMAIN_MISMATCH: 'The existing association domain does not match the proposed domain',
            PARENT_DOMAIN_IGNORED: 'The parent domain was ignored or has not been applied',
            SKILL_PARENT_IGNORED: 'The parent skill was ignored or has not been applied',
            EVALUATIONS_UNAVAILABLE_CATALOGUE_ONLY: 'Assessment ignored under the confirmed catalogue-only scope',
          },
        },
        STATUS: {
          REVIEW: 'Needs review',
          BLOCKED: 'Blocked',
          READY: 'Ready',
          RUNNING: 'Running',
          VERIFIED: 'Applied and verified',
          FAILED: 'Failed',
          PARTIAL: 'Partially applied',
          UNCERTAIN: 'Uncertain result',
          IGNORED: 'Ignored',
          REUSED: 'Reused unchanged',
        },
        ACTIONS: {
          CLOSE: 'Close assistant',
          START_PAID_ANALYSIS: 'Confirm 200 credits and analyze',
          START_CATALOGUE_ANALYSIS: 'Confirm 200 credits and analyze the catalogue',
          ANALYZING: 'Analyzing…',
          PERSIST_CATALOGUE_AND_ANALYZE_ASSOCIATIONS: 'Create/validate catalogue and analyze associations',
          ANALYZE_ASSOCIATIONS: 'Analyze associations',
          PREVIOUS: 'Previous',
          NEXT: 'Next',
          FINISH: 'Finish',
          CREATE: 'Insert',
          UPDATE: 'Update',
          REUSE: 'Reuse unchanged',
          IGNORE: 'Ignore',
          REVIEW_RETRY: 'Review before retry',
          SELECT_READY: 'Select valid rows',
          IGNORE_SELECTED: 'Ignore selected',
          APPLY_SELECTED: 'Apply selected',
          APPLY_VALID: 'Apply valid rows',
        },
        BILLING: {
          FORMATION_LIMITATION: 'Assessment writes require both Training and Skills modules. Confirm catalogue-only import to continue.',
          CONFIRMATIONS: 'Scope confirmation',
          CONFIRM_CATALOGUE_ONLY: 'I confirm continuing with domains and skills only, without assessment writes.',
          NEW_LOT: 'Create a new lot',
          NEW_LOT_CONFIRM: 'Discard this draft and prepare a new lot?',
        },
        TRANSLATIONS_WARNING: 'Warning: the existing API will replace every language variant with label “{{label}}” and description “{{description}}”. I confirm this exact payload.',
        ERRORS: {
          NEW_LOT_REQUIRED: 'The current lot can no longer be changed. Explicitly create a new lot.',
          MAX_FILES: 'A lot cannot contain more than 20 files.',
          FILE_TYPE: 'Unsupported format. Use PDF, XLS, or XLSX only.',
          FILE_SIZE: 'The file exceeds its size limit or is empty.',
          LOT_SIZE: 'The lot exceeds the cumulative 50 MB limit.',
          DUPLICATE_FILE: 'This file is already in the lot.',
          FILE_HASH_RECONCILIATION_FAILED: 'Accepted-lot hashes do not match local files. No file was sent for analysis.',
          INVALID_START_RESULT: 'The server admission response is invalid.',
          FILES_REQUIRED: 'Add at least one file before analysis.',
          INSTRUCTIONS_TOO_LONG: 'Instructions exceed 8,000 characters.',
          CATALOGUE_ONLY_CONFIRMATION_REQUIRED: 'Confirm catalogue-only scope before starting the analysis.',
          SETTINGS_UNAVAILABLE: 'Enterprise context cannot be verified. Analysis remains blocked.',
          INVALID_CONTEXT: 'The import context is invalid.',
          INVALID_MANIFEST: 'The file manifest is invalid.',
          INVALID_FILE_LOT: 'The uploaded file lot is invalid.',
          SOURCE_LIMIT_EXCEEDED: 'An uploaded source exceeds an import limit.',
          CONTEXT_LIMIT_EXCEEDED: 'The import context exceeds the allowed size.',
          UNSUPPORTED_SOURCE_TYPE: 'Only PDF, XLS, and XLSX files are supported.',
          INVALID_SOURCE_SIGNATURE: 'A file does not match its declared extension.',
          UNSAFE_PDF_SOURCE: 'The PDF contains unsupported active or encrypted content.',
          PDF_PAGE_LIMIT_EXCEEDED: 'The PDF exceeds the allowed page count.',
          UNREADABLE_SOURCE: 'A source could not be read safely.',
          CANDIDATE_LIMIT_EXCEEDED: 'The lot exceeds the cumulative limit of 10,000 proposals.',
          INVALID_CATALOGUE_RESULT: 'The catalogue response is invalid. No associations were analyzed.',
          INVALID_CATALOGUE_LOCAL_ID: 'The catalogue contains invalid or duplicate local references.',
          INVALID_ASSOCIATIONS_RESULT: 'The association response is invalid.',
          UNKNOWN_LOCAL_ID: 'An association references a domain or skill outside the approved catalogue.',
          ASSOCIATION_LOCAL_ID_MISMATCH: 'An association does not exactly match its approved domain and skill.',
          CATALOGUE_NOT_PERSISTED: 'Every catalogue row must be validated before association analysis.',
          WORKBOOK_PROFILE_LIMIT_EXCEEDED: 'The workbook structure is too large for one analysis.',
          ADMIN_REQUIRED: 'Enterprise administrator access is required.',
          UNAUTHORIZED: 'An authenticated enterprise session is required.',
          INSUFFICIENT_AI_CREDITS: 'The enterprise does not have enough AI credits.',
          RECEIPT_OR_MANIFEST_CONFLICT: 'The workflow does not match this file lot.',
          ANALYSIS_BUSY: 'The analysis service is busy. Retry later.',
          AI_PROVIDER_TIMEOUT: 'The AI provider timed out.',
          AI_PROVIDER_UNAVAILABLE: 'The AI provider is temporarily unavailable.',
          AI_PROVIDER_OUTPUT_FAILED: 'The AI provider returned an invalid result.',
          AI_AGENT_LIMIT_EXCEEDED: 'Automatic analysis reached its limits. The file lot is preserved. You can retry within this same import without another charge.',
          AI_AGENT_INCOMPLETE: 'Automatic analysis is incomplete. No business data was written by this analysis.',
          ACCOUNTING_UNAVAILABLE: 'AI credit accounting is temporarily unavailable.',
          AI_CONFIGURATION_UNAVAILABLE: 'The AI analysis configuration is unavailable.',
          PDF_CAPABILITY_UNAVAILABLE: 'Native PDF analysis is unavailable.',
          REQUEST_CANCELLED: 'The import request was cancelled.',
          INTERNAL_ERROR: 'The import request could not be completed.',
          ANALYSIS_FAILED: 'No file could be analyzed. Ignore affected files or retry within the same workflow.',
          REVIEW_CONTEXT_FAILED: 'Existing catalogue or employee data could not be loaded for review.',
          EXECUTION_PAUSED: 'The queue is paused after a global authentication, permission, or rate-limit error.',
          REVIEW_REQUIRED: 'Complete and confirm required values.',
          REUSE_TARGET_REQUIRED: 'Reuse requires an existing match.',
          SHARED_SKILL_READ_ONLY: 'A shared skill cannot be created or updated.',
          SHARED_DOMAIN_READ_ONLY: 'A shared domain cannot be created or updated.',
          TRANSLATION_OVERWRITE_CONSENT_REQUIRED: 'Confirm multilingual overwrite for this exact payload.',
          DOMAIN_CHANGED_REVIEW_REQUIRED: 'The existing domain changed. Review values before confirming again.',
          SKILL_CHANGED_REVIEW_REQUIRED: 'The existing skill changed. Review values and confirm again.',
          PARENT_DOMAIN_UNRESOLVED: 'The parent domain must be applied or reused before this skill.',
          SKILL_DEPENDENCY_UNRESOLVED: 'The dependent skill must be applied or reused before this association.',
          EMPLOYEE_REQUIRED: 'Select an existing employee.',
          EMPLOYEE_PROFILE_LOADING: 'Loading the employee skills sequentially…',
          EMPLOYEE_PROFILE_READ_FAILED: 'The employee skills could not be read.',
          DUPLICATE_ACQUIRED_SKILL_URI: 'Multiple acquired associations use this URI; automatic processing is blocked.',
          ASSOCIATION_DOMAIN_MISMATCH: 'The read-back domain of the existing association does not match the proposed domain.',
          DOMAIN_READBACK_UNCERTAIN: 'The domain could not be confirmed after writing.',
          SKILL_READBACK_UNCERTAIN: 'The skill could not be confirmed after writing.',
          ASSOCIATION_CREATE_UNCERTAIN: 'Association creation may have succeeded, but readback is unavailable.',
          ASSIGNED_SCORE_READBACK_FAILED: 'The assigned score was not confirmed by readback.',
          SELF_SCORE_READBACK_FAILED: 'The self-assessment was not confirmed by readback.',
          DOMAIN_TARGET_REQUIRED: 'The target domain cannot be found.',
          CUSTOM_DOMAIN_TARGET_REQUIRED: 'The target custom domain cannot be found or is read-only.',
          CUSTOM_SKILL_TARGET_REQUIRED: 'The target custom skill cannot be found.',
          EXECUTION_FAILED: 'Execution failed without a verifiable result.',
          HTTP_0: 'Connection interrupted. Check the displayed status before retrying.',
          HTTP_400: 'The import request is invalid.',
          HTTP_401: 'The session has expired.',
          HTTP_403: 'Permissions or credits are insufficient for this operation.',
          HTTP_409: 'The workflow or manifest no longer matches the paid lot.',
          HTTP_410: 'This import workflow is no longer available.',
          HTTP_413: 'Processing limits were exceeded.',
          HTTP_415: 'The file type is incompatible.',
          HTTP_422: 'The source is unreadable or invalid.',
          HTTP_429: 'Too many requests. The queue has been paused.',
          HTTP_502: 'The AI provider returned invalid output.',
          HTTP_503: 'Billing or AI configuration is unavailable.',
          HTTP_504: 'AI analysis exceeded its time limit.',
          SOURCE_READ_FAILED: 'The source file is no longer accessible. Select the original file again to retry.',
        },
        CONFIRM_CLOSE: {
          MESSAGE: 'Verified writes will remain. In-memory files, answers, and corrections will be lost. Close?',
        },
        SUMMARY: {
          TITLE: 'Workflow summary',
          CATALOGUE_PHASE: 'Catalogue: {{domains}} domain(s) and {{skills}} skill(s) reviewed.',
          ASSOCIATIONS_PHASE: 'Associations: {{associations}} proposal(s) reviewed.',
        },
        ACCESSIBILITY: {
          STEPS: 'Skills import progress',
          PROGRESS: '{{completed}} operation(s) completed out of {{total}}',
        },
      },
      PAGINATION: {
        OF: 'of',
        RESULTS: 'results',
        ROWS_PER_PAGE: 'Rows per page',
      },
    },
    PROJET: PROJECT,
    CHAT,
    COMMUNITY,
    GENERAL,
    CALENDAR,
    USERDETAILS,
    ONBOARDING,
    QUESTION_REPONSE,
    EVENT,
    FORMATIONS,
    NEWSLETTER,
    SURVEY,
    OSPLANNER,
    IDEA,
    // Report AI keeps all user-visible copy in the established bilingual catalog.
    REPORT_AI: {
      // Pending labels describe transient actions, never persisted report content.
      PENDING: { SAVE: 'Saving...', SOURCES: 'Loading source rows...' },
      HOME: { EYEBROW: 'AI-assisted HR analysis', TITLE: 'Put every decision into perspective', SUBTITLE: 'Create and operate HR dashboards with Emye while retaining control over data and versions.', CREATE: 'Create report', SEARCH: 'Search reports', SORT: 'Sort reports', UPDATED: 'Last updated', UPDATED_AT: 'Updated', CREATED: 'Created date', NAME: 'Name', DIRECTION: 'Reverse sorting', SEARCH_ACTION: 'Search', LOADING: 'Loading reports...', RETRY: 'Try again', NO_DESCRIPTION: 'No description', PREVIEW_UNAVAILABLE: 'Preview available after the next save', VERSION: 'Version', OPEN: 'Open', DUPLICATE: 'Duplicate', DELETE: 'Delete', EMPTY_TITLE: 'No reports yet', EMPTY_TEXT: 'Describe your need to Emye to create your first dashboard.', PREVIOUS: 'Previous', NEXT: 'Next' },
      CREATE: { BACK: 'Back to reports', STEP: 'New report', TITLE: 'What do you want to understand?', NAME: 'Report name', DESCRIPTION: 'Description', PROMPT: 'Your request', PLACEHOLDER: 'Example: analyze headcount, contracts and approved absences by department...', SUGGESTION_1: 'Analyze headcount and movements by department', SUGGESTION_2: 'Compare approved absences and contracts by site', GENERATE: 'Generate report', CONTINUE: 'Continue', NOT_SAVED: 'Not saved' },
      // Workspace labels support the grouped toolbar without changing any underlying operation.
      WORKSPACE: { BACK: 'Reports', UNTITLED: 'Untitled report', UNSAVED: 'Unsaved changes', SAVE: 'Save', REFRESH: 'Refresh', REFRESHING: 'Refreshing...', RETRY: 'Try again', LOADING: 'Loading report...', EMPTY_TITLE: 'This tab is empty', EMPTY_TEXT: 'Ask Emye to add a KPI, table, or chart.', NO_DATA: 'No data', DEFAULT_TAB: 'Overview', ADD_TAB: 'Add tab', RENAME_TAB: 'Rename tab', DELETE_TAB: 'Delete tab', TAB_NAME: 'Tab name', RENAME_REPORT: 'Rename', EDIT_REPORT_TITLE: 'Edit report title', REPORT_NAME: 'Report title', COMPONENT_TITLE: 'Component title', TITLE_TOO_LONG: 'The title cannot exceed {{max}} characters.', MORE_ACTIONS: 'More actions' },
      // Layout labels describe dedicated handles, keyboard mode, and every refusal without changing existing STT chat keys.
      LAYOUT: { MOVE_HANDLE: 'Move {{title}}', RESIZE_HANDLE: 'Resize {{title}} from the bottom-right corner', MOVE_HELP: 'Press Enter or Space to start, use the arrow keys to move on the grid, then Enter to apply or Escape to cancel.', RESIZE_HELP: 'Press Enter or Space to start, use the arrow keys to resize on the grid, then Enter to apply or Escape to cancel.', MOVE_STARTED: 'Move started. Use the 12-column by 32-row grid.', RESIZE_STARTED: 'Bottom-right resize started.', TARGET_VALID: 'Target position is valid.', TARGET_BOUNDS: 'Position rejected: the target exceeds the 12-column by 32-row grid.', TARGET_SIZE: 'Size rejected: this component type limit would be exceeded.', TARGET_COLLISION: 'Position rejected: the target overlaps another component.', APPLIED: 'Layout applied to the draft. Save the report to persist it.', UNCHANGED: 'Layout is unchanged.', CANCELLED: 'Layout change cancelled.' },
      FILTERS: { TITLE: 'Report filters', ALL: 'All', CLEAR: 'Reset', MULTI_HELP: 'Use Ctrl or Cmd to select multiple values.', START_DATE: 'Start date', END_DATE: 'End date' },
      FORMS: { SUBMIT: 'Apply', REQUIRED: 'Required field', SAVE_VALUES: 'Save these values' },
      // Component title editing is named explicitly because the icon-only palette exposes its text through labels and tooltips.
      COMPONENT_MENU: { OPEN: 'Open component menu', REFERENCE_IN_CHAT: 'Target this component in Emye', EDIT_TITLE: 'Edit title', REFRESH: 'Refresh', EXPORT_PNG: 'Export PNG', EXPORT_XLSX: 'Export to Excel (.xlsx)', EXPORT_SOURCE_XLSX: 'Download source data (.xlsx)', EXPAND: 'Expand', SHRINK: 'Shrink', DELETE: 'Delete component' },
      // Source export feedback is separate from runtime errors because it never replaces visible chart data.
      SOURCE_EXPORT: { SUCCESS: 'Source data downloaded.', UNAVAILABLE: 'This chart’s source rows cannot be exported safely. Regenerate the chart.', FORBIDDEN: 'You are not allowed to export this chart’s source rows.', FAILED: 'Source data download failed.' },
      // Drill labels explain analytical navigation and row-level evidence in functional HR language.
      DRILL: { HIERARCHY: 'Hierarchy', ROLL_UP: 'Return to the previous level', VIEW_SOURCE_ROWS: 'Verify source rows', CLICK_TO_DRILL: 'Select a value to display the next level of detail.', SOURCE_EVIDENCE: 'Result evidence', SOURCE_DESCRIPTION: 'These rows were used to calculate the displayed result. Columns are limited to the information needed to verify it.', ACTIVE_CONTEXT: 'Result context', LEVEL: 'Level', EMPTY_VALUE: 'Not provided', ROW_COUNT: '{{count}} source row(s)', TRUNCATED: 'The result is limited. Refine the filters to view all rows.', UNAVAILABLE: 'This component detail is not safely available. Regenerate it or refine the filters.', CLOSE: 'Close', YES: 'Yes', NO: 'No' },
      // Information explains the reviewed business meaning before exposing row-level evidence.
      // Control-row export is named explicitly so the downloaded workbook remains understandable outside the dialog.
      INFORMATION: { OPEN: 'Understand and verify {{title}}', VERIFY_CALCULATION: 'Verify source rows and calculation for {{title}}', EYEBROW: 'Understand this result', ALIGNED: 'Checked against the original need', POPULATION: 'Population and scope', CALCULATION: 'Calculation and formula', FILTERS: 'Filters and exclusions', SOURCES: 'Functional sources', LIMITATIONS: 'Points to consider', COMPONENT_TYPE: 'Type:', VISIBLE_ROWS: 'Displayed values:', REFRESHED_AT: 'Refreshed:', EVIDENCE_TITLE: 'Verification rows', EVIDENCE_DESCRIPTION: 'This information can be used to verify the population and calculated result.', EXPORT_CONTROL_ROWS: 'Export to Excel', LEGACY_DESCRIPTION: 'This historical component does not yet have a validated functional explanation. Regenerate it with Emye to document its population, formula and limitations precisely.', SOURCE_UNAVAILABLE: 'Source rows cannot be reconstructed safely for this historical component.', NO_SOURCE_ROWS: 'No source rows match the current scope.' },
      // The composer also explains the local visual reference, its V1 limits, and upload state without treating it as a source.
      CHAT: { TITLE: 'Emye', SUBTITLE: 'Build your charts', NEW: 'New conversation', COLLAPSE: 'Collapse chat', EXPAND: 'Open chat', YOU: 'You', ASSISTANT: 'Emye', EMPTY: 'Describe a targeted change for this report.', THINKING: 'Emye is preparing a proposal...', PROMPT: 'Message to Emye', PLACEHOLDER: 'Add a chart, change a filter, rename an axis...', REFERENCED_OBJECT: 'Targeted object', REMOVE_REFERENCE: 'Stop targeting this object', SEND: 'Send', VISUAL_REFERENCE_ADD: 'Attach a visual reference', VISUAL_REFERENCE_REMOVE: 'Remove visual reference', VISUAL_REFERENCE_IMAGE: 'Image', VISUAL_REFERENCE_PDF: 'PDF', VISUAL_REFERENCE_UPLOADING: 'Uploading visual reference…', VISUAL_REFERENCE_INVALID_TYPE: 'Unsupported format. Use a PNG, JPEG, or WebP image, or a PDF.', VISUAL_REFERENCE_IMAGE_TOO_LARGE: 'The image exceeds the 5 MB limit.', VISUAL_REFERENCE_PDF_TOO_LARGE: 'The PDF exceeds the 10 MB limit.', VOICE_START: 'Dictate with this device', VOICE_STOP: 'Stop dictation', VOICE_PREPARING: 'Starting system dictation…', VOICE_LISTENING: 'Listening…', VOICE_WAITING: 'Start speaking and the transcript will appear here.', VOICE_UNAVAILABLE: 'Voice dictation is not supported by this browser.', VOICE_PERMISSION_DENIED: 'Allow microphone and speech recognition in the device settings.', VOICE_NO_MICROPHONE: 'No microphone is available on this device.', VOICE_NO_SPEECH: 'No speech was detected.', VOICE_LOCAL_UNAVAILABLE: 'The dictation language is not installed on this device.', VOICE_ERROR: 'Device speech recognition failed.', MICROPHONE_SELECT: 'Choose microphone', MICROPHONE_LOADING: 'Finding microphones…', MICROPHONE_DEFAULT: 'Default microphone', MICROPHONE_NUMBER: 'Microphone {{number}}', MICROPHONE_NONE: 'No additional microphone detected.' },
      AGENT_STOPPED_STEP: 'Not completed',
      SWARM: {
        PROGRESS: 'Progress',
        TITLE: 'Data Engineer companions',
        COMPLETED_TOTAL: '{{completed}}/{{total}} completed',
        COMPLETED: '{{completed}} completed',
        TOTAL: '{{total}} agents',
        ACTIVE: '{{count}} active',
        QUEUED: '{{count}} queued',
        FAILED: '{{count}} failed',
        LAUNCHED_LIMIT: '{{count}}/{{limit}} launched',
        LAUNCHED: '{{count}} launched',
        LAUNCH_LIMIT: '{{limit}} launches maximum',
        CONCURRENT_LIMIT: '{{limit}} concurrent maximum',
        VISUAL_ACCEPTED_WITHOUT_RECHECK: 'Corrections applied after the last review, without a new visual verification.',
      },
      // Pauses preserve validated work without claiming completion or bypassing provider checks.
      PAUSE_REASONS: {
        // Repair continuation preserves work but requires additional AI calls.
        REPAIR_LIMIT: 'Emye needs an additional correction step. Your work is preserved; continuing will use new AI calls.',
        PROVIDER_CONTENT_FILTER: 'The AI provider interrupted generation because of its content filter. Previously validated work is preserved. Click "Continue generation" to request a resume: it remains subject to the same filter and may be blocked again. This action does not bypass the filter.',
        PROVIDER_TRANSIENT: 'A temporary AI provider interruption paused generation. Previously validated work is preserved. Click "Continue generation" to request a resume. Provider checks remain active: the resumed request may be filtered and does not bypass those checks.',
        OUTPUT_LIMIT: 'The AI provider response reached its output limit. Previously validated work is preserved, but generation remains incomplete. Click "Continue generation" to request a resume. Provider checks remain active: the resumed request may be filtered and does not bypass those checks.',
        // The correction window may expire despite partial improvements; do not claim that no progress occurred.
        VISUAL_STALLED: 'Visual validation remains incomplete after several corrections. Previously validated work is preserved, but the report cannot yet be considered ready. Click "Continue generation" to request a resume.',
        PATCH_STALLED: 'Corrections are no longer progressing and report validation is not complete. Previously validated work is preserved, but the report cannot yet be considered ready. Click "Continue generation" to request a resume.',
      },
      // Execution budgets are server-configured; do not promise a hardcoded number of steps in the client.
      AGENT: { PLAN: 'Execution plan', CLARIFICATION_TITLE: 'Details needed', CLARIFICATION_PLACEHOLDER: 'Answer the questions to continue...', QUESTION_PROGRESS: 'Question {{current}} of {{total}}', FREE_ANSWER: 'Write another answer', FREE_ANSWER_PLACEHOLDER: 'Write your answer...', NEXT_QUESTION: 'Next question', CONTINUATION_TITLE: 'Generation paused', CONTINUATION_DESCRIPTION: 'Emye kept its progress. Continuing authorizes additional AI calls to finish the work.', CONTINUE: 'Continue generation', RUN_PHASE: { ANALYZE: 'Analysis', CLARIFY: 'Clarification', PLAN: 'Planning', EXECUTE: 'Execution', VERIFY_DATA: 'Data verification', VERIFY_VISUAL: 'Visual review', FINALIZE: 'Finalization' }, RUN_STATUS: { QUEUED: 'The request is waiting to be processed.', CLARIFICATION_REQUIRED: 'Emye is waiting for your details.', PLANNED: 'The plan is ready.', RUNNING: 'Emye is executing the plan.', VERIFYING_DATA: 'Emye is checking the data.', VERIFYING_VISUAL: 'Emye is reviewing the report layout.', CONTINUATION_REQUIRED: 'Emye kept its progress and is waiting for your confirmation to continue.', COMPLETED: 'The report is ready.', FAILED: 'The generation failed.', CANCELLED: 'The generation was cancelled.' }, STEP_STATUS: { PENDING: 'Pending', IN_PROGRESS: 'In progress', COMPLETED: 'Completed', FAILED: 'Failed' } },
      CONVERSATIONS: { TITLE: 'Conversations', EMPTY: 'No conversations', NEW_TITLE: 'New conversation', DELETE: 'Delete conversation', DELETE_TITLE: 'Delete conversation', DELETE_MESSAGE: 'Permanently delete this conversation and all its messages?', DELETE_SUCCESS: 'Conversation deleted.' },
      SOURCES: { TITLE: 'Sources', DESCRIPTION: 'Add only CSV or XLSX files scoped to this report (25 MB maximum). Adds, replacements, and detachments are applied on the next save.', UPLOAD: 'Add file', UPLOADING: 'Secure import in progress...', NAME: 'Name', ROWS: 'Rows', STATUS: 'Status', ACTIONS: 'Actions', REPLACE: 'Replace', DELETE: 'Detach', DELETE_TITLE: 'Detach source', DELETE_MESSAGE: 'Remove this source from the next version? Previous versions and their data remain available.', EMPTY: 'No imported sources' },
      SHARE: { TITLE: 'Share', SEARCH: 'Search administrators', SEARCH_ACTION: 'Search', CURRENT: 'Current access', ACCESS_LABEL: 'Access level for {{name}}', REMOVE: 'Remove' },
      VERSIONS: { TITLE: 'Versions', RESTORE: 'Restore', EMPTY: 'No versions', NO_DESCRIPTION: 'No description' },
      EXPORT: { TITLE: 'Export', FORMAT_PROMPT: 'Which format do you want to export to?', DESCRIPTION: 'The backend recalculates and validates data before the browser creates the file.', FORM_NOTICE: 'Interactive form' },
      DELETE: { TITLE: 'Delete report', MESSAGE: 'This action is permanent. Do you want to continue?', ACTION: 'Delete', COMPONENT_MESSAGE: 'Delete this component from the draft?' },
      UNSAVED: { TITLE: 'Unsaved changes', MESSAGE: 'Save the report, leave without saving, or stay on this page.', STAY: 'Stay', DISCARD: 'Leave without saving', SAVE: 'Save and leave' },
      ACCESSIBILITY: { TABS: 'Report tabs', DATA_TABLE: 'Component data', PAGINATION: 'Pagination', CLOSE: 'Close', CROSS_FILTER: 'Filter the report with a chart value' },
      ENUMS: { ACCESS: { OWNER: 'Owner', EDIT: 'Edit', VIEW: 'View' }, COMPONENT: { CHART: 'Chart', TABLE: 'Table', KPI: 'KPI', TEXT: 'Text', FORM: 'Form' }, CHART: { BAR: 'Bar', LINE: 'Line', AREA: 'Area', PIE: 'Pie', DONUT: 'Donut', SCATTER: 'Scatter' }, FILTER: { SELECT: 'Select', MULTI_SELECT: 'Multi-select', DATE_RANGE: 'Date range', TEXT: 'Text', NUMBER: 'Number' }, FORM: { TEXT: 'Text', NUMBER: 'Number', DATE: 'Date', SELECT: 'Select', BOOLEAN: 'Yes/No' }, EXPORT: { RUNTIME: 'Refresh', PDF: 'PDF', PNG: 'PNG', XLSX: 'XLSX' }, DATASET_STATUS: { READY: 'Ready', INCOMPATIBLE: 'Incompatible', PROCESSING: 'Processing' } },
      ERRORS: { REPORT_AI_BAD_REQUEST: 'The Report AI request is invalid.', REPORT_AI_FORBIDDEN: 'You are not allowed to perform this action.', REPORT_AI_PERMISSION_REQUIRED: 'The required Report AI permission is missing.', REPORT_AI_NOT_FOUND: 'This report cannot be found or accessed.', REPORT_AI_VERSION_CONFLICT: 'A newer version exists. Reload the report before retrying.', REPORT_AI_REVISION_CONFLICT: 'The component changed. The proposal was not applied.', REPORT_AI_DATASET_IN_USE: 'This source is still used by the following components:', REPORT_AI_VALIDATION_FAILED: 'The submitted data is invalid.', REPORT_AI_RATE_LIMITED: 'Too many requests. Try again shortly.', REPORT_AI_CANCELLED: 'This calculation was replaced by a newer request.', REPORT_AI_TIMEOUT: 'The calculation exceeded its time limit.', REPORT_AI_INVALID_FILE: 'Invalid file. Use a CSV or XLSX within the limits.', REPORT_AI_FILE_TOO_LARGE: 'The file exceeds 25 MB.', REPORT_AI_EXPORT_TOO_LARGE: 'The export exceeds the maximum row count.', REPORT_AI_SQL_PIPELINE_UNAVAILABLE: 'The secure calculation pipeline is unavailable.', REPORT_AI_DATABASE_UNAVAILABLE: 'Report AI storage is unavailable.', REPORT_AI_AI_UNAVAILABLE: 'Emye is temporarily unavailable.', REPORT_AI_AGENT_INVALID_TOOL_CALL: 'Emye produced an invalid action.', REPORT_AI_AGENT_INVALID_SQL_OUTPUT: 'The data verification result is invalid.', REPORT_AI_AGENT_INVALID_PATCH_OUTPUT: 'The proposed report change is invalid.', REPORT_AI_AGENT_INVALID_VISUAL_OUTPUT: 'The report visual review is invalid.', REPORT_AI_AGENT_INVALID_STATE: 'This generation can no longer continue.', REPORT_AI_AGENT_RESUME_INVALID_STATE: 'This clarification was already processed.', REPORT_AI_AGENT_MODEL_LIMIT: 'Emye reached the allowed step limit.', REPORT_AI_AGENT_UNKNOWN_TOOL: 'Emye requested an unsupported action.', REPORT_AI_AGENT_SQL_LIMIT: 'The data verification limit was reached.', REPORT_AI_AGENT_PATCH_LIMIT: 'The report modification limit was reached.', REPORT_AI_AGENT_VISUAL_LIMIT: 'The visual review limit was reached.', REPORT_AI_AGENT_PLAN_REQUIRED: 'Emye could not establish a valid plan.', REPORT_AI_AGENT_VISUAL_REVIEW_REQUIRED: 'The final visual review could not be completed.', REPORT_AI_MEMORY_UNAVAILABLE: 'Emye private memory is unavailable.', REPORT_AI_MEMORY_LIMIT: 'Emye private memory reached its limit.', REPORT_AI_EXPORT_FAILED: 'The export could not be created.', REPORT_AI_INTERNAL_ERROR: 'An error occurred. Try again.' },
      // A visual upload failure states that no run started and remains separate from dataset-import feedback.
      TOASTS: { CREATE_SUCCESS: 'Report created and Version 1 saved.', SAVE_SUCCESS: 'New version and preview saved.', THUMBNAIL_FAILED: 'The dashboard preview could not be captured. The report was not saved.', RENAME_SUCCESS: 'Report renamed and new version saved.', DUPLICATE_SUCCESS: 'Report duplicated.', DELETE_SUCCESS: 'Report deleted.', SHARE_SUCCESS: 'Sharing updated.', UPLOAD_SUCCESS: 'Source added to the draft.', REPLACE_SUCCESS: 'Replacement added to the draft.', SOURCE_DETACH_READY: 'Source removed from the draft. Save to create the new version.', VISUAL_REFERENCE_UPLOAD_FAILED: 'The visual reference could not be uploaded. No run was started.', EXPORT_SUCCESS: 'Export created.', SOURCE_EXPORT_SUCCESS: 'Source data downloaded.', RESTORE_SUCCESS: 'Version restored.' },
    },
    ADMINPARKING,
    TRANSPORT,
    DOCUMENT,
    FICHEPOSTE,
    LEAVE,
    DICTIONNAIRE,
    CAREER,
    ...TEMPS,
  },
  GENERAL: GENERAL,
  AUTH: AUTH,
  CALENDAR: CALENDAR,
  CHAT: CHAT,
  COMMUNITY: COMMUNITY,
  DICTIONNAIRE: DICTIONNAIRE,
  DOCUMENT: DOCUMENT,
  EVENT: EVENT,
  FICHEPOSTE: FICHEPOSTE,
  FORMATIONS: FORMATIONS,
  IDEA: IDEA,
  LEAVE: LEAVE,
  NEWSLETTER: NEWSLETTER,
  ONBOARDING: ONBOARDING,
  OSPLANNER: OSPLANNER,
  QUESTION_REPONSE: QUESTION_REPONSE,
  SURVEY: SURVEY,
  TACHEADMINSTRATIVE: TACHEADMINSTRATIVE,
  TRANSPORT: TRANSPORT,
  USER_PROFILE: USER_PROFILE,
  ADMINPARKING: ADMINPARKING,
  USERDETAILS: USERDETAILS,
  USER: {
    DETAILS: {
      PERSO_INFO: 'Personal Informations',
      presentation: 'Presentation',
      CHANGE_PASS: 'Change password',
      CONGE: 'Holiday',
      NOM: 'Last Name',
      PRENOM: 'First Name',
      AVAIL: 'Availabilities',
      PLANNING: 'Travel schedule',
      PLANNING_WORK_MODE: 'Work modes',
      succ: 'Profil changed successfully',
      allow: 'Allowed file types',
      btn: 'Update',
      COLLAB: 'Collaborator',
      ENTRE: 'Enterprise',
      EQUIPE: 'Team',
      SITE: 'Site',
      SERVICE: 'Service',
      RESERVATION: 'the maximum number of bookable meeting for this month has been reached.',
      FORMATIONS: 'Trainings',
      COMPETENCES: 'Skills',
    },
    ADMINPARKING,
    AUTH,
    CALENDAR,
    CAREER,
    CHAT,
    COMMUNITY,
    DICTIONNAIRE,
    DOCUMENT,
    EVENT,
    FICHEPOSTE,
    FORMATIONS,
    GENERAL,
    IDEA,
    LEAVE,
    NEWSLETTER,
    ONBOARDING,
    OSPLANNER,
    PROJECT,
    QUESTION_REPONSE,
    REMUNERATION_TRANSLATIONS,
    SURVEY,
    TACHEADMINSTRATIVE,
    ...TEMPS,
    TRANSPORT,
    USER_PROFILE,
    USERDETAILS,
    ...FORFAIT,
  },
}

Object.assign(locale.data.REPORT_AI.ERRORS, {
  // Companion budget exhaustion stops generation; it is not transient provider throttling.
  REPORT_AI_COMPONENT_ATTEMPT_LIMIT: 'One or more companions have reached their maximum number of attempts. Generation has stopped; unfinished results are not applied to the report.',
  REPORT_AI_SWARM_LAUNCH_LIMIT: 'Generation has reached the maximum number of companion launches. Generation has stopped; unfinished results are not applied to the report.',
  REPORT_AI_AGENT_PLAN_INCOMPLETE: 'Emye did not complete every plan step.',
  // Credit exhaustion remains actionable and distinct from a temporary AI provider outage.
  REPORT_AI_INSUFFICIENT_CREDITS: 'The AI credit balance is insufficient to continue.',
  // Locked edits explain owner-controlled read-only mode without exposing authorization details.
  REPORT_AI_LOCKED: 'This dashboard is locked by its owner.',
})

// Owner lock labels remain grouped with the existing workspace and toaster vocabulary.
Object.assign(locale.data.REPORT_AI.WORKSPACE, {
  LOCKED: 'Locked',
  LOCK_REPORT: 'Lock dashboard',
  UNLOCK_REPORT: 'Unlock dashboard',
  DUPLICATE_REPORT: 'Duplicate dashboard',
})
Object.assign(locale.data.REPORT_AI.TOASTS, {
  LOCK_SUCCESS: 'The dashboard is locked.',
  UNLOCK_SUCCESS: 'The dashboard is unlocked.',
})
